import axios from 'axios';

export namespace XV1 {
    export namespace API {
        export namespace AdminAdyenCompanyPost {
            export const url = '/admin/adyen/company';
            export type Input = {
                companyId: number;
            };
            export type Output = {
                company: any;
                locations: any;
                adyenAccountHolder: any;
            };
        }
        export namespace AdminAdyenCompanyHopPost {
            export const url = '/admin/adyen/company/hop';
            export type Input = {
                companyId: number;
                accountHolderCode: string;
            };
            export type Output = {
                redirectUrl: string;
            };
        }
        export namespace AdminAdyenLocationAccountPost {
            export const url = '/admin/adyen/location-account';
            export type Input = {
                locationId: number;
            };
            export type Output = any;
        }
        export namespace AdminLocationBootstrapPost {
            export const url = '/admin/location/bootstrap';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                location: {
                    id: number;
                    name: string;
                    currency: string;
                    timezone: string;
                };
                company: {
                    id: number;
                    name: string;
                };
                features: FeatureType[];
                ui: {
                    v2: boolean;
                };
            };
        }
        export namespace AdminLocationGetPost {
            export const url = '/admin/location/get';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                location: AdminLocationGetLocation;
                outlets: AdminLocationGetOutlet[];
            };
            export type AdminLocationGetLocation = Pick<Location, 'id' | 'name'>;
            export type AdminLocationGetOutlet = Pick<Outlet, 'id' | 'name'>;
        }
        export namespace AdminLocationSettlementActionPost {
            export const url = '/admin/locationSettlement/action';
            export type Input = AdminLocationSettlementActionUpdate | AdminLocationSettlementActionConfirm;
            export type AdminLocationSettlementActionUpdate = {
                settlementId: number;
                type: 'UPDATE';
                values: Pick<LocationSettlement, 'description'>;
            };
            export type AdminLocationSettlementActionConfirm = {
                settlementId: number;
                type: 'CONFIRM';
            };
            export type Output = void;
        }
        export namespace AdminLocationSettlementGetPost {
            export const url = '/admin/locationSettlement/get';
            export type Input = {
                id: number;
                groupBy?: 'LOCATION' | 'OUTLET';
                countAs?: SettlementProductCountAs | SettlementPaymentCountAs;
            };
            export type Output = {
                settlement: Pick<LocationSettlement, 'id' | 'status' | 'description'>;
                segments;
                hasInvoiceSales: boolean;
                confirm?: {
                    message: string;
                    canConfirm: boolean;
                };
            };
        }
        export namespace AdminLocationSettlementGetPendingPost {
            export const url = '/admin/locationSettlement/getPending';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                settlementId?: number;
            };
        }
        export namespace AdminLocationSettlementGetReportPost {
            export const url = '/admin/locationSettlement/getReport';
            export type Input = {
                locationId: number;
                from: string;
                to: string;
                groupBy: 'location' | 'outlet';
                groupBySettlement?: boolean;
                countAs?: SettlementProductCountAs | SettlementPaymentCountAs;
            };
            export type Output = {
                segments;
                hasInvoiceSales: boolean;
            };
        }
        export namespace AdminOnboardingPost {
            export const url = '/admin/onboarding';
            export type Output = {};
            export type Input = {};
        }
        export namespace AdminReportingGetOperatorSalesPost {
            export const url = '/admin/reporting/getOperatorSales';
            export type Input = {
                locationId: number;
                from: string;
                to: string;
            };
            export type Output = {
                operators: {}[];
                chart: {
                    data: {
                        key: string;
                        amount: number;
                        count: number;
                        data: number[];
                    }[];
                    type: string;
                    xAxisLabels: string[];
                };
            };
        }
        export namespace AdminReportingGetTerminalUsagePost {
            export const url = '/admin/reporting/getTerminalUsage';
            export type Input = {
                locationId: number;
                from: string;
                to: string;
                orderBy?: 'terminalName' | 'amount';
            };
            export type Output = {
                chart: {
                    xAxis: {
                        data: string[];
                    };
                    yAxis: {}[];
                    series: {
                        name: string;
                        type: 'bar';
                        data: number[];
                        yAxisIndex?: number;
                    }[];
                };
                xrTerminalIntervalChart;
            };
        }
        export namespace AdminReportingSalesPost {
            export const url = '/admin/reporting/sales';
            export type Input = {
                from: string;
                to: string;
            };
            export type Output = {
                total: number;
                locations: { label: string; value: number }[];
                xrRevenueChart;
                result;
            };
        }
        export namespace AdminSettlementConfirmPost {
            export const url = '/admin/settlement/confirm';
            export type Input = {
                locationId: number;
            };
            export type Output = void;
        }
        export namespace AdminSettlementGetPost {
            export const url = '/admin/settlement/get';
            export type Input = {
                locationId: number;
                pagination?: {
                    offset: number;
                    limit: number;
                };
            };
            export type Output = {
                settlements: AdminSettlementGetSettlement[];
            };
            export type AdminSettlementGetSettlement = Pick<
                Settlement,
                'id' | 'sequence' | 'periodStart' | 'periodEnd' | 'revenueTotalIncludingVat'
            > & {
                vismaSettlement: Pick<VismaSettlement, 'id'>;
            };
        }
        export namespace AnalyticsGet {
            export const url = '/analytics/[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace AnalyticsSalesPost {
            export const url = '/analytics/sales';
            export type Output = {};
            export type Input = {};
        }
        export namespace AuthPost {
            export const url = '/auth/[post]';
            export type Output = {};
            export type Input = {
                loginType: 'USERNAME' | 'EMAIL' | 'PHONE';
            };
        }
        export namespace BalanceAdminGetTablePost {
            export const url = '/balance/admin/getTable';
            export type Output = {};
            export type Input = {
                locationId: number;
            };
        }
        export namespace BalanceUpdatePost {
            export const url = '/balance/update';
            export type Output = {};
            export type Input = {};
            export type BalanceUpdateInput = {
                id: number | number[];
                data: BalanceUpdateInputData;
            };
            export type BalanceUpdateInputData = Partial<Balance>;
            export type BalanceUpdateOutput = void;
        }
        export namespace CheckoutTipDataPost {
            export const url = '/checkout/tip/data';
            export type Output = {};
            export type Input = {};
        }
        export namespace ClientAddBalancePost {
            export const url = '/client/addBalance';
            export type Input = {
                clientId: number;
                balance: ClientAddBalanceInputBalance | ClientAddBalanceInputBalance[];
            };
            export type ClientAddBalanceInputBalance = Partial<
                Pick<Balance, 'id' | 'name' | 'isActive' | 'amountInitial' | 'amountRemaining'>
            >;
            export type Output = Pick<Balance, 'id'> | Pick<Balance, 'id'>[];
        }
        export namespace ClientAdminBalanceGetPost {
            export const url = '/client/admin/balance/get';
            export type Output = {};
            export type Input = {};
            export type ClientAdminBalanceGetInput = {
                clientId: number;
            };
            export type ClientAdminBalanceGetOutput = {
                balances: ClientAdminBalanceGetBalance[];
            };
            export type ClientAdminBalanceGetBalance = Pick<
                Balance,
                | 'id'
                | 'name'
                | 'nameInternal'
                | 'namePublic'
                | 'type'
                | 'isActive'
                | 'hash'
                | 'amountInitial'
                | 'amountRemaining'
                | 'validFrom'
                | 'validTo'
            > & {
                userBalances: ClientAdminBalanceGetUserBalance[];
                balanceClaims: ClientAdminBalanceGetBalanceClaim[];
            };
            export type ClientAdminBalanceGetUserBalance = Pick<UserBalance, 'userId'> & {
                user: ClientAdminBalanceGetUserBalanceUser;
            };
            export type ClientAdminBalanceGetUserBalanceUser = Pick<User, 'areaCode' | 'phone' | 'email' | 'username'>;
            export type ClientAdminBalanceGetBalanceClaim = Pick<BalanceClaim, 'areaCode' | 'phone'>;
        }
        export namespace ClientAdminCreateInvoicePost {
            export const url = '/client/admin/createInvoice';
            export type Input = {
                clientId: number;
            };
            export type Output = Pick<ClientInvoice, 'id'>;
        }
        export namespace ClientAdminGetPost {
            export const url = '/client/admin/get';
            export type Output = {};
            export type Input = {};
            export type ClientAdminGetInput = {
                clientId: number;
            };
            export type ClientAdminGetOutput = {
                client: ClientAdminGetOutputClient;
                invoice: {
                    notBilled: {
                        paymentCount: number;
                        amount: number;
                    };
                };
                discountId?: number;
            };
            export type ClientAdminGetOutputClient = Pick<
                Client,
                'id' | 'name' | 'description' | 'contactName' | 'contactEmail' | 'companyRegNr' | 'locationId'
            > & {
                clientInvoices: ClientAdminGetOutputInvoice[];
                balances: ClientAdminGetOutputBalance[];
            };
            export type ClientAdminGetOutputInvoice = Pick<
                ClientInvoice,
                'id' | 'amount' | 'isInvoiced' | 'periodFrom' | 'periodTo' | 'createdAt'
            >;
            export type ClientAdminGetOutputBalance = Pick<Balance, 'id' | 'name' | 'amountRemaining'>;
        }
        export namespace ClientAdminGetInvoiceDataPost {
            export const url = '/client/admin/getInvoiceData';
            export type Input = {
                clientId?: number;
                clientInvoiceId?: number;
                requestType?: 'PER_BALANCE';
                perBalance?: boolean;
            };
            export type Output = {
                period: {
                    from?: string;
                    to?: string;
                };
                payments: {
                    count: number;
                    amount: number;
                };
                products: ClientAdminGetInvoiceDataOutputProduct[];
                accounts: ClientAdminGetInvoiceDataOutputAccount[];
                clientInvoice?: Pick<ClientInvoice, 'id' | 'ref' | 'periodFrom' | 'periodTo' | 'customFields'> & {
                    client: Pick<Client, 'id' | 'name'>;
                };
                balances: {
                    id: number;
                    name: string;
                    products: ClientAdminGetInvoiceDataOutputProduct[];
                    accounts: ClientAdminGetInvoiceDataOutputAccount[];
                }[];
                previousInvoiceCustomFields?: ClientInvoice['customFields'];
                perDate;
                perDatePerBalance;
            };
            export type ClientAdminGetInvoiceDataOutputProduct = {
                productId: number;
                productName: string;
                count: number;
                amount: number;
            };
            export type ClientAdminGetInvoiceDataOutputAccount = Pick<
                Account,
                'id' | 'name' | 'code' | 'type' | 'vatPercent'
            > & {
                count: number;
                amount: number;
            };
        }
        export namespace ClientAdminGetOverviewPost {
            export const url = '/client/admin/getOverview';
            export type Output = {};
            export type Input = {};
            export type ClientAdminGetOverviewInput = {
                locationId: number;
            };
            export type ClientAdminGetOverviewOutput = {
                clients: ClientAdminGetOverviewOutputClient[];
            };
            export type ClientAdminGetOverviewOutputClient = Pick<Client, 'id' | 'name'>;
        }
        export namespace ClientAdminUpdateInvoicePost {
            export const url = '/client/admin/updateInvoice';
            export type Input = {
                clientInvoiceId: number;
                values: Pick<ClientInvoice, 'customFields'>;
            };
            export type Output = void;
        }
        export namespace ClientCreatePost {
            export const url = '/client/create';
            export type Input = {
                locationId: number;
                data: Partial<Client>;
            };
            export type ClientCreateInputData = Partial<Client>;
            export type Output = Pick<Client, 'id'>;
        }
        export namespace ClientImportBalancesPost {
            export const url = '/client/importBalances';
            export type Input = {
                clientId: number;
                balances: ClientImportBalancesRow[];
            };
            export type Output = {};
            export type ClientImportBalancesRow = Pick<Balance, 'name' | 'namePublic' | 'nameInternal'> & {
                amount?: number;
                validFrom?: string;
                validTo?: string;
                isActive?: any;
                areaCode?: string;
                phone?: string;
            };
        }
        export namespace ClientInvoiceDownloadPost {
            export const url = '/client/invoice/download';
            export type Input = {
                id: number;
                perBalance?: boolean;
            };
            export type Output = {
                url: string;
            };
        }
        export namespace ClientInvoiceMarkAsInvoicedPost {
            export const url = '/client/invoice/markAsInvoiced';
            export type Input = {
                id: number;
            };
            export type Output = {};
        }
        export namespace ClientUpdatePost {
            export const url = '/client/update';
            export type Output = {};
            export type Input = {};
            export type ClientUpdateInput = {
                id: number;
                data: ClientUpdateInputData & { discountId?: number | null };
            };
            export type ClientUpdateInputData = Partial<
                Pick<
                    Client,
                    'name' | 'type' | 'description' | 'contactName' | 'contactEmail' | 'companyRegNr' | 'isActive'
                >
            >;
            export type ClientUpdateOutput = void;
        }
        export namespace CompanyCompanyIdUserPost {
            export const url = '/company/{companyId}.user';
            export type Output = {};
            export type Input = {};
        }
        export namespace CompanyAdyenAddBankAccountPost {
            export const url = '/company/adyen/addBankAccount';
            export type Output = {};
            export type Input = {
                companyId: number;
                ownerName: string;
                ownerCity: string;
                ownerCountryCode: string;
                ownerStreet: string;
                ownerPostalCode: string;
                iban: string;
                countryCode: string;
                currencyCode: string;
            };
        }
        export namespace CompanyAdyenCreateAccountPost {
            export const url = '/company/adyen/createAccount';
            export type Output = {};
            export type Input = {};
            export type CompanyAdyenCreateAccountInput = {
                locationId: number;
            };
            export type CompanyAdyenCreateAccountOutput = {};
        }
        export namespace CompanyGetAdyenHopUrlPost {
            export const url = '/company/getAdyenHopUrl';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronEJournalSyncPaymentsGet {
            export const url = '/cron/e-journal-sync-payments.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronEJournalSyncSettlementsGet {
            export const url = '/cron/e-journal-sync-settlements.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronKdrSyncOrdersGet {
            export const url = '/cron/kdr-sync-orders.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronLocationConfigAutoPayoutGet {
            export const url = '/cron/locationConfigAutoPayout.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronLocationConfigAutoSettleGet {
            export const url = '/cron/locationConfigAutoSettle.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronOrderProductInventorySyncGet {
            export const url = '/cron/order-product/inventorySync.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronOutletEventsGet {
            export const url = '/cron/outlet-events.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace CronTerminalCheckLiveConnectionGet {
            export const url = '/cron/terminal/checkLiveConnection.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DataQueryGetCountingReportSummaryHistoryPost {
            export const url = '/dataQuery/getCountingReportSummaryHistory';
            export type Input = {
                inventoryId: number;
            };
            export type Output = DataQueryGetCountingReportSummaryHistoryItem;
            export type DataQueryGetCountingReportSummaryHistoryItem = Pick<
                InventoryCountingReportSummary,
                'id' | 'createdAt'
            > & {
                user: Pick<User, 'username' | 'firstName' | 'lastName' | 'email'>;
            };
        }
        export namespace DataQueryGetLocationSettlementReportsPost {
            export const url = '/dataQuery/getLocationSettlementReports';
            export type Input = {
                locationId: number;
            };
            export type Output = DataQueryLocationReportsItem;
            export type DataQueryLocationReportsItem = Pick<
                Report,
                'id' | 'description' | 'type' | 'status' | 'error' | 'createdAt'
            > & {
                from?: string;
                to?: string;
            };
        }
        export namespace DataQueryGetLocationSettlementsPost {
            export const url = '/dataQuery/getLocationSettlements';
            export type Input = {
                locationId: number;
            };
            export type Output = DataQueryGetLocationSettlementsItem;
            export type DataQueryGetLocationSettlementsItem = Pick<
                LocationSettlement,
                'id' | 'sequence' | 'status' | 'from' | 'to' | 'description' | 'revenue'
            > & {
                day;
                vismaSyncs: DataQueryGetLocationSettlementsEvent[];
                adyenPayouts: DataQueryGetLocationSettlementsEvent[];
            };
            export type DataQueryGetLocationSettlementsEvent = Pick<
                SettlementEvent,
                'id' | 'type' | 'status' | 'statusReason' | 'request' | 'response' | 'data' | 'createdAt'
            >;
        }
        export namespace DataQueryGetOutletPaymentsPost {
            export const url = '/dataQuery/getOutletPayments';
            export type Input = {
                outletId: number;
                from: string;
                to: string;
                cardNumber: string;
                orderIds: number[];
            };
            export type Output = DataQueryGetOutletPaymentsItem;
            export type DataQueryGetOutletPaymentsItem = Pick<
                Payment,
                | 'id'
                | 'status'
                | 'amountInitial'
                | 'amount'
                | 'amountRefund'
                | 'createdAt'
                | 'cardNumber'
                | 'settlementId'
            > & {
                orderProducts: Pick<
                    OrderProduct,
                    'id' | 'status' | 'paymentStatus' | 'productId' | 'productName' | 'priceCombined'
                >[];
            };
        }
        export namespace DataQueryGetPaymentsPost {
            export const url = '/dataQuery/getPayments';
            export type Input = {
                zoneId: number;
            };
            export type Output = DataQueryGetPaymentsItem;
            export type DataQueryGetPaymentsItem = Pick<
                Payment,
                'id' | 'status' | 'amountInitial' | 'amount' | 'amountRefund' | 'createdAt' | 'cardNumber'
            > & {
                orderProducts: Pick<
                    OrderProduct,
                    'id' | 'status' | 'paymentStatus' | 'productId' | 'productName' | 'priceCombined'
                >[];
            };
        }
        export namespace DataQueryLocationClientsPost {
            export const url = '/dataQuery/locationClients';
            export type Input = {
                locationId: number;
            };
            export type Output = DataQueryLocationClientsItem;
            export type DataQueryLocationClientsItem = Pick<
                Client,
                'id' | 'name' | 'type' | 'isActive' | 'locationId'
            > & {
                isPendingInvoice: boolean;
                amountToInvoice: number;
                invoiceCountNotMarkedAsInvoiced: number;
            };
        }
        export namespace DataQueryLocationMunuOrdersPost {
            export const url = '/dataQuery/locationMunuOrders';
            export type Input = {
                locationId: number;
            };
            export type Output = DataQueryLocationMunuOrdersItem;
            export type DataQueryLocationMunuOrdersItem = {
                id: number;
                syncStatus: 'MISSING' | 'ERROR' | 'SUCCESS';
                hash: string | number;
                createdAt: Date;
                amount: number;
                order: DataQueryLocationMunuOrdersItemOrder;
                munuOrder?: DataQueryLocationMunuOrdersItemMunuOrder;
            };
            export type DataQueryLocationMunuOrdersItemOrder = Pick<Order, 'id' | 'hash' | 'createdAt'> & {
                orderProducts: Pick<OrderProduct, 'id' | 'productName' | 'priceCombined'>[];
            };
            export type DataQueryLocationMunuOrdersItemMunuOrder = Pick<
                MunuOrder,
                'id' | 'orderId' | 'createdAt' | 'isSuccess' | 'request' | 'munuOrderId'
            >;
        }
        export namespace DataQueryLocationSettlementHistoryPost {
            export const url = '/dataQuery/locationSettlementHistory';
            export type Input = {
                locationId: number;
            };
            export type Output = SettlementHistoryItem;
            export type SettlementHistoryItem = Pick<
                Settlement,
                'id' | 'sequence' | 'periodStart' | 'periodEnd' | 'description' | 'revenueTotalIncludingVat'
            > & {
                adyenPayout?: Pick<AdyenPayout, 'id' | 'amount' | 'status' | 'statusReason' | 'createdAt'> & {
                    settlements: Pick<Settlement, 'id'>[];
                };
                vismaSettlement?: LocationSettlementHistoryItemVismaSettlement;
                syncTripletex: SettlementSyncRequest[];
                syncSevenOffice24: SettlementSyncRequest[];
            };
            export type LocationSettlementHistoryItemVismaSettlement = Pick<VismaSettlement, 'id' | 'response'>;
        }
        export namespace DataQueryPosHistoryGetOrdersPost {
            export const url = '/dataQuery/posHistory/getOrders';
            export type Input = {
                locationId?: number;
                outletId?: number;
                zoneId?: number;
                orderIds?: number[];
            };
            export type Output = Pick<Order, 'id' | 'sequence' | 'createdAt' | 'status'> & {
                locationName: string;
                outletName: string;
                zoneName: string;
                orderProducts: Pick<OrderProduct, 'id' | 'productId' | 'productName' | 'priceCombined'>[];
            };
        }
        export namespace DataQueryPosHistoryGetPaymentsPost {
            export const url = '/dataQuery/posHistory/getPayments';
            export type Input = {
                locationId?: number;
                outletId?: number;
                zoneId?: number;
                paymentIds?: number[];
                cardNumber?: string;
                orderSequence?: number;
            };
            export type Output = Pick<
                Payment,
                | 'id'
                | 'amount'
                | 'amountInitial'
                | 'amountRefund'
                | 'status'
                | 'provider'
                | 'cardNumber'
                | 'createdAt'
                | 'settlementId'
                | 'locationName'
                | 'outletName'
                | 'zoneName'
            > & {
                orderProducts: Pick<OrderProduct, 'id' | 'productId' | 'productName' | 'status'>[];
                orders: Pick<Order, 'id' | 'sequence' | 'status' | 'settlementId'>[];
                terminal?: Pick<Terminal, 'id' | 'name'>;
            };
        }
        export namespace DataQueryStarPrinterPost {
            export const url = '/dataQuery/starPrinter';
            export type Input = void;
            export type DataQueryStarPrinterItem = Pick<
                StarPrinter,
                'id' | 'name' | 'topic' | 'host' | 'port' | 'username' | 'password' | 'locationId'
            > & {
                location?: Pick<Location, 'id' | 'name'>;
            };
            export type Output = DataQueryStarPrinterItem;
        }
        export namespace DataQuerySuperAdminGetTerminalsPost {
            export const url = '/dataQuery/superAdmin/getTerminals';
            export type Input = {
                form?: Partial<Terminal> & {
                    companyName?: string;
                };
            };
            export type Output = Pick<
                Terminal,
                'id' | 'isActive' | 'model' | 'referenceId' | 'name' | 'pOIID' | 'permanentTerminalId'
            > & {
                company?: Pick<Company, 'id' | 'name'>;
                location?: Pick<Location, 'id' | 'name'>;
            };
        }
        export namespace DevAdyenGet {
            export const url = '/dev/adyen.[get]';
            export type Input = any;
            export type Output = any;
        }
        export namespace DevAssertConfigGet {
            export const url = '/dev/assert-config.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DevErrorGet {
            export const url = '/dev/error.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DevImportVenueGet {
            export const url = '/dev/import-venue.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DevPayoutsGet {
            export const url = '/dev/payouts.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DevPingGet {
            export const url = '/dev/ping.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DevPowerOfficeGet {
            export const url = '/dev/power-office.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DevSyncOpGet {
            export const url = '/dev/sync-op.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DevTerminalGet {
            export const url = '/dev/terminal.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DevTestGet {
            export const url = '/dev/test.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DevTripletexDelGet {
            export const url = '/dev/tripletex/del.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DevTripletexGetGet {
            export const url = '/dev/tripletex/get.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DevTripletexNewGet {
            export const url = '/dev/tripletex/new.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace DiscountGetDetailsPost {
            export const url = '/discount/getDetails';
            export type Input = {
                id?: number;
            };
            export type Output = {
                discount: Discount;
            };
        }
        export namespace EJournalSettlementGet {
            export const url = '/e-journal/settlement.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace EntityCompanyPost {
            export const url = '/entity-company';
            export type Output = {};
            export type Input = {};
        }
        export namespace EntityLocationInventoryPost {
            export const url = '/entity-location-inventory';
            export type Output = {};
            export type Input = {};
        }
        export namespace EntityLocationPost {
            export const url = '/entity-location';
            export type Output = {};
            export type Input = {};
        }
        export namespace InternalAbortTerminalPaymentPost {
            export const url = '/internal/abortTerminalPayment';
            export type Input = {
                terminalId: number;
            };
            export type Output = {};
        }
        export namespace InternalSendOrderToTerminalPost {
            export const url = '/internal/sendOrderToTerminal';
            export type Input = {
                terminalId: number;
                orderId: number;
            };
            export type Output = {
                paymentId: number;
            };
        }
        export namespace InventoryActionHistoryPost {
            export const url = '/inventory/action-history';
            export type Output = {};
            export type Input = {};
        }
        export namespace InventoryCountingReportSummaryConfirmPost {
            export const url = '/inventory/counting-report-summary-confirm';
            export type Output = {};
            export type Input = {
                inventoryId: number;
                countingReportSummaryId?: number;
                productIds: number[];
            };
        }
        export namespace InventoryCountingReportSummaryPost {
            export const url = '/inventory/counting-report-summary';
            export type Output = {};
            export type Input = {
                inventoryId: number;
                countingReportSummaryId?: number;
                productIds: number[];
            };
        }
        export namespace InventoryCountingReportPost {
            export const url = '/inventory/counting-report';
            export type Output = {};
            export type Input = {
                inventoryId: number;
                description: string;
                countingReportProducts: {
                    productId: number;
                    unitAmountAfter: number;
                }[];
            };
        }
        export namespace InventoryCountingReportConfirmPost {
            export const url = '/inventory/counting-report/confirm';
            export type Output = {};
            export type Input = {
                inventoryId: number;
                reportId: number;
                description: string;
                countingReportProducts: {
                    productId: number;
                    unitAmountAfter: number;
                }[];
                isDraft: boolean;
            };
        }
        export namespace InventoryCountingReportPreparePost {
            export const url = '/inventory/counting-report/prepare';
            export type Output = {};
            export type Input = {};
        }
        export namespace InventoryDownloadReportPost {
            export const url = '/inventory/downloadReport';
            export type Input = {
                type: 'HOLDINGS' | 'COUNTING_REPORT' | 'COUNTING_REPORT_SUMMARY';
                locationId: number;
                inventoryId: number;
                reportId?: number;
            };
            export type Output = {
                url: string;
            };
        }
        export namespace InventoryMenuProductPost {
            export const url = '/inventory/menu-product';
            export type Output = {};
            export type Input = MenuProduct & {
                inventoryId: number;
            };
        }
        export namespace InventoryMoveInventoryConfirmPost {
            export const url = '/inventory/move-inventory-confirm';
            export type Output = {};
            export type Input = {
                sourceInventoryId: number;
                targetInventoryId: number;
                products: {
                    id: number;
                    unitAmount: number;
                }[];
            };
        }
        export namespace InventoryMoveInventoryDataPost {
            export const url = '/inventory/move-inventory-data';
            export type Output = {};
            export type Input = {
                inventoryId: number;
            };
        }
        export namespace InventoryProcessActionsGet {
            export const url = '/inventory/process-actions.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace InventoryPurchaseOrderVendorGet {
            export const url = '/inventory/purchase-order-vendor.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace InventoryPurchaseOrderPost {
            export const url = '/inventory/purchase-order';
            export type Output = {};
            export type Input = {
                locationId: number;
                vendorId: number;
                inventoryId: number;
                products: {
                    id: number;
                    containerPrice: number;
                    unitAmount: number;
                }[];
                newVendorName?: string;
            };
        }
        export namespace InventoryPurchaseOrderCreatePost {
            export const url = '/inventory/purchase-order/create';
            export type Input = {
                inventoryId: number;
                vendorId: number;
                products: {
                    productId: number;
                    unitAmount: number;
                    price?: number;
                }[];
            };
            export type Output = {
                id: number;
            };
        }
        export namespace InventoryPurchaseOrderPreparePost {
            export const url = '/inventory/purchase-order/prepare';
            export type Output = {};
            export type Input = {};
        }
        export namespace InventoryRecipeProductPost {
            export const url = '/inventory/recipe-product';
            export type Output = {};
            export type Input = {};
        }
        export namespace IotPublishPost {
            export const url = '/iot/publish';
            export type Output = {};
            export type Input = {};
        }
        export namespace LandingContactPost {
            export const url = '/landing/contact';
            export type Output = {};
            export type Input = {};
        }
        export namespace LandingGetDocumentPost {
            export const url = '/landing/getDocument';
            export type Input = {
                id: 'TERMS_AND_CONDITIONS' | 'PRIVACY_POLICY' | 'MERCHANT_TERMS';
            };
            export type Output = {
                value;
            };
        }
        export namespace LandingGetMerchantTermsPost {
            export const url = '/landing/getMerchantTerms';
            export type Output = {};
            export type Input = {};
        }
        export namespace LegacyBrowseGet {
            export const url = '/legacy/browse.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace LegacyTagTagIdGet {
            export const url = '/legacy/tag.{tagId}.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace LocationLocationIdProductCategoryGet {
            export const url = '/location/{locationId}/product-category.[get]';
            export type Input = {};
            export type Output = {
                categories: string[];
                subCategories: string[];
            };
        }
        export namespace LocationLocationIdStaffPost {
            export const url = '/location/{locationId}/staff';
            export type Output = {};
            export type Input = {};
        }
        export namespace LocationConfigGetPost {
            export const url = '/location/config/get';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                locationConfigs: LocationConfigGetLocationConfig[];
            };
            export type LocationConfigGetLocationConfig = Pick<LocationConfig, 'id' | 'type' | 'isActive' | 'data'>;
        }
        export namespace LocationConfigUpdatePost {
            export const url = '/location/config/update';
            export type Input = {
                locationId: number;
                action: 'create' | 'update' | 'delete';
                type: LocationConfigType;
                model?: Partial<LocationConfig>;
            };
            export type Output = void;
        }
        export namespace LocationCourseCreatePost {
            export const url = '/location/course/create';
            export type Output = {};
            export type Input = {};
            export type LocationCourseInput = {
                locationId: number;
                name: string;
            };
            export type LocationCourseOutput = void;
        }
        export namespace LocationCreateStorePost {
            export const url = '/location/createStore';
            export type Output = {};
            export type Input = {};
        }
        export namespace LocationUpdateMiniInventoryPost {
            export const url = '/location/updateMiniInventory';
            export type Output = {};
            export type Input = {};
            export type UpdateMiniInventoryInput = {
                locationId: number;
                isActive?: boolean;
                productCountByProductId?: MiniInventoryProductCountByProductId;
            };
        }
        export namespace LocationsLocationIdAnalyticsSalesPost {
            export const url = '/locations.{locationId}/analytics/sales';
            export type Output = {};
            export type Input = {};
        }
        export namespace LocationsLocationIdStaffRolesDelete {
            export const url = '/locations.{locationId}/staff-roles.[delete]';
            export type Output = {};
            export type Input = {};
        }
        export namespace LocationsLocationIdStaffGet {
            export const url = '/locations.{locationId}/staff.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace LocationsLocationIdStaffPost {
            export const url = '/locations.{locationId}/staff';
            export type Output = {};
            export type Input = {
                areaCode: string;
                phone: string;
                email: string;
                roles: UserLocationRoleValue[];
                firstName: string;
                lastName: string;
                username?: string;
                password?: string;
            };
        }
        export namespace MeGet {
            export const url = '/me/[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace MeClaimPaymentPost {
            export const url = '/me/claimPayment';
            export type Input = {
                id: string;
            };
            export type Output = Payment | undefined;
        }
        export namespace MeCompanyPost {
            export const url = '/me/company';
            export type Output = {};
            export type Input = {};
        }
        export namespace MeDiscountPost {
            export const url = '/me/discount';
            export type Output = {};
            export type Input = {
                discountIds: number[];
            };
        }
        export namespace MeDownloadReceiptPost {
            export const url = '/me/download-receipt';
            export type Output = {};
            export type Input = {
                paymentId: number;
            };
        }
        export namespace MeGetOrderHistoryPost {
            export const url = '/me/getOrderHistory';
            export type Output = {};
            export type Input = {};
        }
        export namespace MeGetPaymentPost {
            export const url = '/me/getPayment';
            export type Output = {};
            export type Input = {
                paymentId: number;
            };
        }
        export namespace MeGetPaymentHistoryPost {
            export const url = '/me/getPaymentHistory';
            export type Output = {};
            export type Input = {};
        }
        export namespace MeGetReceiptPost {
            export const url = '/me/getReceipt';
            export type Input = {
                paymentId: number;
            };
            export type Output = any;
        }
        export namespace MeIotGet {
            export const url = '/me/iot.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace MeLocationsPost {
            export const url = '/me/locations';
            export type Output = {};
            export type Input = {};
        }
        export namespace MeLocationsLocationIdGet {
            export const url = '/me/locations.{locationId}.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace MeOrderHistoryPost {
            export const url = '/me/order-history';
            export type Output = {};
            export type Input = {};
        }
        export namespace MeOrderUpdatePost {
            export const url = '/me/order-update';
            export type Output = {};
            export type Input = {
                orderId: number;
                action: 'DISMISS' | 'UPDATE_CONTACT';
                areaCode?: string;
                phone?: string;
            };
        }
        export namespace MeOrderPost {
            export const url = '/me/order';
            export type Input = {
                orderIds: number[];
                orderGuids: string[];
            };
            export type Output = MeOrderOrder[];
            export type MeOrderOrder = Pick<Order, 'id' | 'status' | 'sequence' | 'userId' | 'locationId'> & {
                image?: string;
                orderProducts: MeOrderOrderProduct[];
            };
            export type MeOrderOrderProduct = Pick<OrderProduct, 'id' | 'status' | 'orderId'>;
        }
        export namespace MePasswordChangePost {
            export const url = '/me/password-change';
            export type Output = {};
            export type Input = {};
        }
        export namespace MePayPost {
            export const url = '/me/pay';
            export type Output = {};
            export type Input = {};
            export type MePayInput = {
                balanceId: number;
                orderProductIds?: number[];
                orderId?: number;
                paymentId?: number;
            };
            export type MePayOutput = {};
        }
        export namespace MenuProductAddToMenuPost {
            export const url = '/menu-product/addToMenu';
            export type Output = {};
            export type Input = {
                menuId: number;
                productIds: number[];
            };
        }
        export namespace MenuProductRemoveFromMenuPost {
            export const url = '/menu-product/removeFromMenu';
            export type Output = {};
            export type Input = {
                menuId: number;
                productIds: number[];
            };
        }
        export namespace MenuProductUpdatePost {
            export const url = '/menu-product/update';
            export type Output = {};
            export type Input = {};
            export type UpdateInput = {
                menuId: number;
                productIds: number[];
                properties: Partial<MenuProduct>;
            };
        }
        export namespace MetaPost {
            export const url = '/meta';
            export type Output = {};
            export type Input = {};
        }
        export namespace OnboardingRegisterPost {
            export const url = '/onboarding/register';
            export type Output = {};
            export type Input = {
                email: string;
                password: string;
            };
        }
        export namespace OrderProductChangeRequestStatusPost {
            export const url = '/order-product/changeRequestStatus';
            export type Input = InputProducts | InputCourse;
            type InputProducts = {
                orderProductIds: number[];
                requestStatus: OrderProductRequestStatus;
            };
            type InputCourse = {
                zoneId: number;
                courseId: number;
            };
            export type Output = {};
        }
        export namespace OrderProductCreatePaymentPost {
            export const url = '/order-product/createPayment';
            export type Output = {};
            export type Input = {};
            export type CreatePaymentInput = {
                zoneId: number;
                balanceId: number;
                orderProductIds: number[];
            };
            export type CreatePaymentOutput = {};
        }
        export namespace OrderOrderIdGet {
            export const url = '/order/{orderId}.[get]';
            export type Input = {
                orderId: number;
            };
            export type Output = Order & {
                products: Pick<Product, 'id' | 'name' | 'type'>[];
                receiptProducts;
            };
        }
        export namespace OrderOrderIdReceiptGet {
            export const url = '/order/{orderId}.receipt.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace OrderCancelPost {
            export const url = '/order/cancel';
            export type Input = {
                orderId: number;
            };
            export type Output = void;
        }
        export namespace OutletMenuCrudPost {
            export const url = '/outlet-menu/crud';
            export type Input = {
                action: 'create' | 'read' | 'update' | 'delete';
                outletId?: number;
                menuId?: number;
                type: OutletMenuType;
            };
            export type Output = OutletMenu[];
        }
        export namespace OutletPost {
            export const url = '/outlet/[post]';
            export type Output = {};
            export type Input = {};
        }
        export namespace OutletGetActiveMenuPost {
            export const url = '/outlet/getActiveMenu';
            export type Output = {};
            export type Input = {};
            export type GetActiveMenuInput = {
                outletId: number;
                menuId?: number;
            };
            export type GetActiveMenuOutput = {
                outlet: GetActiveMenuOutputOutlet;
                menu: GetActiveMenuOutputMenu;
            };
            export type GetActiveMenuOutputOutlet = Pick<Outlet, 'id' | 'name' | 'locationId' | 'menuId'> & {
                location: GetActiveMenuOutputOutletLocation;
            };
            export type GetActiveMenuOutputOutletLocation = Pick<Location, 'id' | 'name'> & {
                products: GetActiveMenuOutputOutletLocationProduct[];
                menus: GetActiveMenuOutputOutletLocationMenu[];
                miniInventories: GetActiveMenuOutputOutletLocationMiniInventory[];
            };
            export type GetActiveMenuOutputOutletLocationProduct = Pick<
                Product,
                'id' | 'name' | 'isHidden' | 'isOutOfStock'
            >;
            export type GetActiveMenuOutputOutletLocationMenu = Pick<Menu, 'id' | 'name'>;
            export type GetActiveMenuOutputOutletLocationMiniInventory = Pick<
                MiniInventory,
                'id' | 'isActive' | 'productCountByProductId'
            >;
            export type GetActiveMenuOutputMenu = Pick<Menu, 'id' | 'name'> & {
                menuProducts: OutletGetActiveMenuOutputMenuMenuProduct[];
            };
            export type OutletGetActiveMenuOutputMenuMenuProduct = Pick<
                MenuProduct,
                'menuId' | 'productId' | 'position' | 'isHidden'
            > & {
                product: OutletGetActiveMenuOutputMenuMenuProductProduct;
            };
            export type OutletGetActiveMenuOutputMenuMenuProductProduct = Pick<
                Product,
                'id' | 'name' | 'isOutOfStock' | 'isHidden'
            >;
        }
        export namespace OutletMenuChangeDeletePost {
            export const url = '/outlet/menu-change/delete';
            export type Input = {
                outletId: number;
                ids: number[];
            };
            export type Output = void;
        }
        export namespace OutletMenuChangeGetPost {
            export const url = '/outlet/menu-change/get';
            export type Input = {
                outletId: number;
                model?: Partial<OutletMenuChange>;
            };
            export type Output = {
                outletMenuChanges: OutletMenuChangeGetOutletMenuChange[];
                menus: OutletMenuChangeGetMenu[];
            };
            export type OutletMenuChangeGetOutletMenuChange = Pick<
                OutletMenuChange,
                'id' | 'day' | 'minutesOffset' | 'isActive' | 'menuId'
            >;
            export type OutletMenuChangeGetMenu = Pick<Menu, 'id' | 'name'>;
        }
        export namespace OutletMenuChangeUpdatePost {
            export const url = '/outlet/menu-change/update';
            export type Input = {
                ids: number[];
                outletId: number;
                isActive: boolean;
                menuId: number;
                days: number[];
                minutesOffset: number;
            };
            export type Output = void;
        }
        export namespace OutletOpenTimeGetPost {
            export const url = '/outlet/open-time/get';
            export type Input = {
                outletId: number;
                model?: Partial<OutletOpenTime>;
            };
            export type Output = OutletOpenTimeGetOutletOpenTime[];
            export type OutletOpenTimeGetOutletOpenTime = Pick<
                OutletOpenTime,
                'id' | 'day' | 'minutesFrom' | 'minutesTo' | 'isActive'
            >;
        }
        export namespace OutletOpenTimeUpdatePost {
            export const url = '/outlet/open-time/update';
            export type Input = {
                outletId: number;
                action: 'UPDATE' | 'DELETE';
                ids?: number[];
                models?: Partial<OutletOpenTime>[];
            };
            export type Output = void;
        }
        export namespace PaymentPaymentIdReceiptGet {
            export const url = '/payment/{paymentId}.receipt.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace PaymentBamboraProviderOrderIdGet {
            export const url = '/payment/bambora.{providerOrderId}.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace PaymentDownloadReceiptPost {
            export const url = '/payment/download-receipt';
            export type Input = {
                paymentId: number;
            };
            export type Output = {
                url: string;
            };
        }
        export namespace PaymentFindPost {
            export const url = '/payment/find';
            export type Input = {
                locationId: number;
                from: string;
                to: string;
                providerOrderId?: string;
                cardNumber?: string;
                amount?: number;
                take?: number;
                provider?: PaymentProvider;
                isRefundsOnly?: boolean;
            };
            export type Output = Payment[];
        }
        export namespace PaymentGetPaymentPost {
            export const url = '/payment/getPayment';
            export type Output = {};
            export type Input = {
                paymentId: number;
            };
        }
        export namespace PaymentGetReceiptPost {
            export const url = '/payment/getReceipt';
            export type Input = {
                paymentId: number;
                isDownload?: boolean;
            };
            export type Output = {
                rows: {
                    left?: string;
                    center?: string;
                    right?: string;
                    bold?: boolean;
                }[];
                url?: string;
            };
        }
        export namespace PaymentPrintReceiptPost {
            export const url = '/payment/printReceipt';
            export type Input = {
                paymentId: number;
                terminalId?: number;
            };
            export type Output = void;
        }
        export namespace PaymentProviderStatsPost {
            export const url = '/payment/provider-stats';
            export type Output = {};
            export type Input = {
                locationId: number;
                from: string;
                to: string;
            };
        }
        export namespace PayoutConfirmPayoutPost {
            export const url = '/payout/confirmPayout';
            export type Input = {
                settlementId: number;
            };
            export type Output = {};
        }
        export namespace PayoutDownloadReportPost {
            export const url = '/payout/downloadReport';
            export type Input = {
                locationId: number;
                month: string;
            };
            export type Output = {
                url: string;
            };
        }
        export namespace PayoutGetActivePayoutPost {
            export const url = '/payout/getActivePayout';
            export type Input = {
                locationId: number;
            };
            export type Output = any;
        }
        export namespace PayoutGetDetailsPost {
            export const url = '/payout/getDetails';
            export type Input = {
                locationId: number;
            };
            export type Output = {};
            type PayoutGetDetailsItem = {};
        }
        export namespace PayoutGetHistoryPost {
            export const url = '/payout/getHistory';
            export type Output = {};
            export type Input = {};
        }
        export namespace PayoutGetReportPost {
            export const url = '/payout/getReport';
            export type Input = {
                locationId: number;
                month: string;
            };
            export type Output = any;
        }
        export namespace PluginAutoPayPreparePost {
            export const url = '/plugin/auto-pay/prepare';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                terminals: PluginAutoPayPrepareTerminal[];
            };
            export type PluginAutoPayPrepareTerminal = Pick<Terminal, 'id' | 'name'>;
        }
        export namespace PosBootstrapPost {
            export const url = '/pos/bootstrap';
            export type Output = {};
            export type Input = {};
        }
        export namespace PosClientGetLocationClientsPost {
            export const url = '/pos/client/getLocationClients';
            export type Input = {
                locationId: number;
            };
            export type Output = PosClientGetLocationClientsOutputClient[];
            export type PosClientGetLocationClientsOutputClient = Pick<Client, 'id' | 'name' | 'type' | 'group'> & {
                balances: PosClientGetLocationClientsOutputBalance[];
            };
            export type PosClientGetLocationClientsOutputBalance = Pick<Balance, 'id' | 'name' | 'amountRemaining'>;
        }
        export namespace PosDeliveryHistoryPost {
            export const url = '/pos/delivery/history';
            export type Output = {};
            export type Input = {
                zoneIds: number[];
                take: number;
                skip: number;
            };
        }
        export namespace PosDeliveryOrdersPost {
            export const url = '/pos/delivery/orders';
            export type Input = {
                zoneIds: number[];
                orderProductStatuses: OrderProductStatus[];
                productRootCategory?: ProductCategoryRoot;
            };
            export type Output = {
                orders: PosDeliveryOrdersOrder[];
                orderTerminalPaymentRequired: Record<number, boolean>;
                terminalsByOutletId: Record<
                    number,
                    (Pick<Terminal, 'id' | 'isActive' | 'name' | 'outletId'> & {
                        terminalPayment: Payment;
                    })[]
                >;
            };
            export type PosDeliveryOrdersOrder = Pick<
                Order,
                'id' | 'sequence' | 'placedAt' | 'placedBy' | 'takeawayAt'
            > & {
                location: PosDeliveryOrdersLocation;
                outlet: PosDeliveryOrdersOutlet;
                zone: PosDeliveryOrdersZone;
                orderProducts: PosDeliveryOrdersOrderProduct[];
            };
            export type PosDeliveryOrdersLocation = Pick<Location, 'id' | 'name'>;
            export type PosDeliveryOrdersOutlet = Pick<Outlet, 'id' | 'name'>;
            export type PosDeliveryOrdersZone = Pick<Zone, 'id' | 'name'>;
            export type PosDeliveryOrdersOrderProduct = Pick<
                OrderProduct,
                | 'id'
                | 'orderId'
                | 'productId'
                | 'productName'
                | 'status'
                | 'currency'
                | 'comment'
                | 'productRootCategory'
                | 'priceCombined'
                | 'paymentStatus'
                | 'zoneId'
                | 'outletId'
            > & {
                orderProductModifiers: PosDeliveryOrdersOrderProductModifier[];
            };
            export type PosDeliveryOrdersOrderProductModifier = Pick<
                OrderProductModifier,
                | 'id'
                | 'modifierGroupName'
                | 'modifierName'
                | 'priceFinal'
                | 'productId'
                | 'productName'
                | 'productUnitAmount'
                | 'productBaseUnit'
                | 'productContainer'
            >;
        }
        export namespace PosDeliveryPreparePost {
            export const url = '/pos/delivery/prepare';
            export type Output = {};
            export type Input = {};
        }
        export namespace PosDeviceRegisterPost {
            export const url = '/pos/device/register';
            export type Input = {
                id: string;
                locationId: number;
            };
            export type Output = {
                pointOfSaleId: string;
                // @DEPRECATED
                id: string;
            };
        }
        export namespace PosLoadCreateDetailsPost {
            export const url = '/pos/loadCreateDetails';
            export type Input = {
                outletId: number;
                isTakeaway?: boolean;
            };
            export type Output = {
                outlet: Pick<Outlet, 'id'>;
                zones: Zone[];
                menuProducts: PosLoadCreateDetailsMenuProduct[];
                discounts: Pick<Discount, 'id' | 'name' | 'percent'>[];
                terminals: Terminal[];
            };
            export type PosLoadCreateDetailsMenuProduct = Pick<
                MenuProduct,
                'menuId' | 'price' | 'priceTakeaway' | 'productId'
            > & {
                product: PosLoadCreateDetailsProduct;
            };
            export type PosLoadCreateDetailsProduct = Pick<
                Product,
                | 'id'
                | 'name'
                | 'description'
                | 'rootCategory'
                | 'category'
                | 'subCategory'
                | 'price'
                | 'priceTakeaway'
                | 'icon'
                | 'position'
                | 'isOutOfStock'
                | 'isCommentAllowed'
                | 'allergens'
                | 'type'
                | 'alcoholPercent'
                | 'variantGroupId'
            > & {
                variantGroup: PosLoadCreateDetailsVariantGroup;
                productModifierGroups: (Pick<ProductModifierGroup, 'modifierGroupId'> & {
                    modifierGroup: PosLoadCreateDetailsModifierGroup;
                })[];
            };
            export type PosLoadCreateDetailsVariantGroup = Pick<VariantGroup, 'id' | 'name' | 'description'> & {
                variantGroupProducts: PosLoadCreateDetailsVariantGroupProduct[];
            };
            export type PosLoadCreateDetailsVariantGroupProduct = Pick<
                VariantGroupProduct,
                'id' | 'productId' | 'price' | 'position'
            > & {
                product: PosLoadCreateDetailsProduct;
            };
            export type PosLoadCreateDetailsModifierGroup = Pick<
                ModifierGroup,
                | 'id'
                | 'presentationType'
                | 'name'
                | 'description'
                | 'autoSelectModifierId'
                | 'autoSelectFirstModifier'
                | 'createSeparateProducts'
                | 'minAllowed'
                | 'maxAllowed'
            > & {
                modifierGroupItems: PosLoadCreateDetailsModifierGroupItem[];
            };
            export type PosLoadCreateDetailsModifierGroupItem = Pick<
                ModifierGroupItem,
                'id' | 'modifierGroupId' | 'modifierId' | 'price' | 'unitAmount' | 'position' | 'productId'
            > & {
                modifier: Pick<Modifier, 'id' | 'name'>;
                product: PosLoadCreateDetailsProduct;
            };
        }
        export namespace PosLocationBootstrapPost {
            export const url = '/pos/location/bootstrap';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                location: PosLocationBootstrapLocation;
                outlets: PosLocationBootstrapOutlet[];
                features: FeatureType[];
                discounts: Pick<Discount, 'id' | 'name' | 'percent'>[];
                integrations: IntegrationType[];
            };
            export type PosLocationBootstrapLocation = Pick<
                Location,
                'id' | 'name' | 'currency' | 'imageBackground' | 'imageLogo'
            >;
            export type PosLocationBootstrapOutlet = Pick<Outlet, 'id' | 'name' | 'image'>;
        }
        export namespace PosOrderCreatePost {
            export const url = '/pos/order/create';
            export type Output = {};
            export type Input = {
                zoneId: number;
                orderProducts: {
                    priceCombined: number;
                    priceFinal: number;
                    priceInitial: number;
                    productId: number;
                    productName: string;
                }[];
            };
        }
        export namespace PosOrderHistoryPost {
            export const url = '/pos/order/history';
            export type Input = {
                outletId: number;
            };
            export type Output = Order[];
        }
        export namespace PosOrderProductChangeDiscountPost {
            export const url = '/pos/order/product/changeDiscount';
            export type Input = {
                action: 'add' | 'remove';
                orderProductIds: number[];
                discountId?: number;
            };
            export type Output = void;
        }
        export namespace PosOrderProductHandlePrint {
            export const url = '/pos/order/product/handlePrint';
            export type Output = {};
            export type Input = {
                orderProducts: OrderProduct[];
                printFromPrinterId: number;
                isPrintModifiersSeparately?: boolean;
            };
        }
        export namespace PosOrderProductUpdateStatusPost {
            export const url = '/pos/order/product/update-status';
            export type Input = {
                orderProductIds: number[];
                status: OrderProductStatus;
                printFromPrinterId?: number;
                isPrintModifiersSeparately?: boolean;
                version?: 'v2';
            };
            export type Output = {
                orderProducts: OrderProduct[];
                status: OrderProductStatus;
                orderIds: number[];
            };
        }
        export namespace PosOutletConfigPost {
            export const url = '/pos/outlet/config';
            export type Output = {};
            enum Action {
                ZONE_OPEN_ALL = 'ZONE_OPEN_ALL',
                ZONE_CLOSE_ALL = 'ZONE_CLOSE_ALL',
                ZONE_SHOW_ALL = 'ZONE_SHOW_ALL',
                ZONE_HIDE_ALL = 'ZONE_HIDE_ALL',
            }
            export type Input = {
                outletId: number;
                action: Action;
            };
        }
        export namespace PosOutletGetZonesPost {
            export const url = '/pos/outlet/getZones';
            export type Output = {};
            export type Input = {};
            export type PosOutletGetZonesInput = {
                outletId: number;
                zoneIds?: number[];
            };
            export type PosOutletGetZonesOutput = {
                outlet: PosOutletGetZonesOutlet;
                zones: PosOutletGetZonesZone[];
                terminals: PosOutletGetZonesTerminal[];
                courses: PosOutletGetZonesCourse[];
            };
            export type PosOutletGetZonesOutlet = Pick<Outlet, 'id' | 'name' | 'locationId'>;
            export type PosOutletGetZonesZone = Pick<
                Zone,
                'id' | 'name' | 'isClosed' | 'isHidden' | 'orderDeliveryType'
            > & {
                isClearable: boolean;
                courses: (Pick<Course, 'id' | 'name'> & {
                    timestamp?: string;
                    status: PosOutletGetZonesTerminalCourseStatus;
                    orderProducts: PosOutletGetZonesOrderProduct[];
                })[];
                paymentAmount: {
                    paid: number;
                    remaining: number;
                    total: number;
                };
                orderProductsPaymentRequired: PosOutletGetZonesOrderProduct[];
                orders: PosOutletGetZonesOrder[];
            };
            export type PosOutletGetZonesCourse = Pick<Course, 'id' | 'name'>;
            export type PosOutletGetZonesOrder = Pick<Order, 'id' | 'zoneId'> & {
                orderProducts: PosOutletGetZonesOrderProduct[];
            };
            export type PosOutletGetZonesOrderProduct = Pick<
                OrderProduct,
                | 'id'
                | 'updatedAt'
                | 'status'
                | 'paymentStatus'
                | 'productId'
                | 'productName'
                | 'productRootCategory'
                | 'priceCombined'
                | 'requestStatus'
                | 'zoneId'
                | 'courseId'
                | 'orderProductPayments'
            >;
            export type PosOutletGetZonesTerminal = Pick<Terminal, 'id' | 'name'>;
            export enum PosOutletGetZonesTerminalCourseStatus {
                EMPTY = 'EMPTY',
                CAN_REQUEST = 'CAN_REQUEST',
                REQUESTED = 'REQUESTED',
                READY = 'READY',
                WAIT = 'WAIT',
                FINISHED = 'FINISHED',
            }
        }
        export namespace PosOutletProductPost {
            export const url = '/pos/outlet/product';
            export type Output = {};
            export type Input = {
                outletId: number;
                productId: number;
                field: any;
                value: any;
            };
        }
        export namespace PosOutletViewPost {
            export const url = '/pos/outlet/view';
            export type Output = {};
            export type Input = {
                outletId: number;
            };
            export type ApiPosOutletView = {
                outlet: Omit<Outlet, 'zones' | 'outletConfigurations'>;
                outletConfigurations: OutletConfiguration[];
                terminals: (Pick<Terminal, 'id' | 'pOIID' | 'isActive' | 'name' | 'terminalPaymentId'> & {
                    terminalPayment?: Pick<Payment, 'id' | 'status' | 'amount' | 'currency' | 'createdAt'>;
                })[];
                zones: ApiPosOutletViewZone[];
                zoneGroups: {
                    id: number;
                    name: string;
                    zones: Pick<Zone, 'id' | 'name' | 'position' | 'isClosed' | 'isHidden'>[];
                }[];
            };
            export type ApiPosOutletViewZone = {
                id: number;
                name: string;
                hash: string;
                isClosed: boolean;
                isHidden: boolean;
                orderDeliveryType: ZoneOrderDeliveryType;
                outletId: number;
                amountNotPaid: number;
                amountPaid: number;
                amountTotal: number;
                canClearTable: boolean;
                zoneOrders: number;
                productsInFinalStatus: number;
                orderProductsNotPaid: OrderProduct[];
            };
        }
        export namespace PosPaymentGetDetailsPost {
            export const url = '/pos/payment/getDetails';
            export type Input = {
                paymentId: number;
            };
            export type Output = PosPaymentGetDetailsPayment;
            export type PosPaymentGetDetailsPayment = Pick<Payment, 'id'> & {
                orderProducts: (Pick<OrderProduct, 'id' | 'productId' | 'productName'> & {
                    orderProductModifiers: Pick<OrderProductModifier, 'id' | 'productId' | 'productName'>[];
                })[];
            };
        }
        export namespace PosPaymentGetHistoryPost {
            export const url = '/pos/payment/getHistory';
            export type Output = {};
            export type Input = {
                paymentIds: number[];
                locationId?: number;
                outletId?: number;
            };
        }
        export namespace PosPaymentRequestPhoneForReceiptPost {
            export const url = '/pos/payment/requestPhoneForReceipt';
            export type Input = {
                paymentId: number;
                terminalId?: number;
            };
            export type Output = void;
        }
        export namespace PosPaymentShowQrPost {
            export const url = '/pos/payment/showQr';
            export type Input = {
                paymentId: number;
                terminalId?: number;
            };
            export type Output = void;
        }
        export namespace PosPlaceOrderPost {
            export const url = '/pos/placeOrder';
            export type Output = {};
            export type Input = {};
            export type PosPlaceOrderInput = {
                outletId: number;
                zoneId: number;
                orderProducts: OrderProduct[];
                terminalId?: number;
                requestTip?: boolean;
                isTakeaway?: boolean;
                balanceId?: number;
            };
            export type PosPlaceOrderOutput = {
                order: Order;
                payment?: Payment;
            };
            type ConvertOrderProductsToActiveOrderProductsInput = {
                orderProducts: OrderProduct[];
                zoneId: number;
            };
        }
        export namespace PosStationBootstrapCourseViewPost {
            export const url = '/pos/station/bootstrapCourseView';
            export type Input = {
                outletId: number;
            };
            export type Output = {
                zones: Pick<Zone, 'id' | 'name' | 'position'>[];
                courses: Pick<Course, 'id' | 'name' | 'position'>[];
                productMeta: Record<string, { name: string }>;
                styles?: any;
            };
        }
        export namespace PosStationFindOrderPost {
            export const url = '/pos/station/find-order';
            export type Output = {};
            export type Input = {
                orderId: number;
                outletId: number;
                orderProductStatuses?: OrderProductStatus[];
                category?: string;
            };
        }
        export namespace PosStationGetPrintersPost {
            export const url = '/pos/station/getPrinters';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                items: PosStationGetPrintersItem[];
            };
            export type PosStationGetPrintersItem = Pick<StarPrinter, 'id' | 'name'>;
        }
        export namespace PosStationOrderCountPost {
            export const url = '/pos/station/order-count';
            export type Input = {
                outletIds: number[];
                orderPlacedBy?: OrderPlacedBy[];
            };
            export type Output = {
                count: number;
            };
        }
        export namespace PosStationViewPost {
            export const url = '/pos/station/view';
            export type Input = {
                orderProductStatuses?: OrderProductStatus[];
                rootCategory?: string | string[];
                zoneIds?: number[];
                tagIds?: number[];
                orderPlacedFrom?: OrderPlacedFrom;
                orderPlacedBy?: OrderPlacedBy;
                outletIds: number[];
                take?: number;
                countOnly?: boolean;
                filterByCategoryAndStatus?: {
                    rootCategories: ProductCategoryRoot[];
                    statuses: OrderProductStatus[];
                };
            };
            export type Output = {
                orders: PosStationViewOrder[];
                allowedProductStatuses: OrderProductStatus[];
                outletZoneGroups: any;
                orderMeta: Record<
                    string,
                    {
                        placedBy?: OrderPlacedBy;
                        operatorName?: string;
                    }
                >;
            };
            export type PosStationViewOrder = Pick<
                Order,
                'id' | 'sequence' | 'zoneId' | 'placedAt' | 'placedBy' | 'zone' | 'takeawayAt'
            > & {
                orderProducts: PosStationViewOrderProduct[];
                operatorName?: string;
            };
            export type PosStationViewOrderProduct = Pick<
                OrderProduct,
                | 'id'
                | 'orderId'
                | 'productId'
                | 'productName'
                | 'productCategory'
                | 'status'
                | 'currency'
                | 'comment'
                | 'productRootCategory'
                | 'priceCombined'
                | 'paymentStatus'
                | 'zoneId'
                | 'outletId'
                | 'orderProductModifiers'
                | 'courseId'
                | 'requestStatus'
            >;
        }
        export namespace PosUpdateZonesPost {
            export const url = '/pos/updateZones';
            export type Output = {};
            export type Input = {
                zoneIds: number[];
                isHidden?: boolean;
                isClosed?: boolean;
                isPayMode?: boolean;
            };
        }
        export namespace PosZoneClearPost {
            export const url = '/pos/zone/clear';
            export type Output = {};
            export type Input = {
                zoneId: number;
            };
        }
        export namespace PosZoneCreateTerminalPaymentPost {
            export const url = '/pos/zone/createTerminalPayment';
            export type Output = {};
            export type Input = {
                zoneId: number;
                terminalId: number;
                orderProductIds: number[];
                requestTip?: boolean;
            };
        }
        export namespace PosZoneMoveZoneDataPost {
            export const url = '/pos/zone/move-zone-data';
            export type Input = {
                zoneId: number;
            };
            export type Output = Pick<Zone, 'id' | 'name'>[];
        }
        export namespace PosZoneMoveZonePost {
            export const url = '/pos/zone/move-zone';
            export type Input = {
                zoneId: number;
                zoneIdTarget: number;
                orderIds?: number[];
            };
            export type Output = void;
        }
        export namespace PosZoneProductMarkAsPaidPost {
            export const url = '/pos/zone/product-mark-as-paid';
            export type Input = {
                zoneId: number;
                orderProductIds: number[];
            };
            export type Output = void;
        }
        export namespace PosZoneViewPost {
            export const url = '/pos/zone/view';
            export type Output = {};
            export type Input = {};
            export type PosZoneViewInput = {
                zoneId: number;
            };
            export type PosZoneViewOutput = {
                zone: Zone;
                orders: Order[];
                canClearTable: boolean;
                isAllProductsPaid: boolean;
                productsInFinalStatus: number;
                orderProducts: OrderProduct[];
                terminals: Terminal[];
            };
        }
        export namespace PosOperatorAuthenticatePost {
            export const url = '/posOperator/authenticate';
            export type Input = {
                locationId: number;
                code: string;
                authorise?: {
                    code: string;
                    role: PosOperatorRoleValue;
                };
            };
            export type Output = Pick<PosOperator, 'uuid' | 'code' | 'name' | 'description'> & {
                sessionLengthMinutes: number;
                roles: PosOperatorRoleValue[];
            };
        }
        export namespace PosOperatorGetPost {
            export const url = '/posOperator/get';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                isRequired: boolean;
            };
        }
        export namespace PosOperatorManagePost {
            export const url = '/posOperator/manage';
            export type Input = {
                locationId: number;
                action:
                    | PosOperatorManageActionCreate
                    | PosOperatorManageActionRead
                    | PosOperatorManageActionImport
                    | PosOperatorManageActionUpdate
                    | PosOperatorManageActionDelete;
            };
            export type PosOperatorManageActionCreate = {
                type: 'CREATE';
                roleGroupId: number;
                posOperators: Pick<PosOperator, 'code' | 'name'>[];
            };
            export type PosOperatorManageActionRead = {
                type: 'READ';
            };
            export type PosOperatorManageActionImport = {
                type: 'IMPORT';
                values: Pick<PosOperator, 'code' | 'name' | 'description'>[];
            };
            export type PosOperatorManageActionUpdate = {
                type: 'UPDATE';
                ids: number[];
                values: Partial<PosOperator>;
            };
            export type PosOperatorManageActionDelete = {
                type: 'DELETE';
                posOperatorIds: number[];
            };
            export type Output = {
                operators: PosOperatorManageOperator[];
                roleGroups: PosOperatorManageRoleGroup[];
            };
            export type PosOperatorManageOperator = Pick<PosOperator, 'id' | 'code' | 'name' | 'description'> & {
                roleGroup?: Pick<PosOperatorRoleGroup, 'id' | 'name'>;
            };
            export type PosOperatorManageRoleGroup = Pick<PosOperatorRoleGroup, 'id' | 'name'>;
        }
        export namespace PosOperatorRoleGroupManagePost {
            export const url = '/posOperator/roleGroup/manage';
            export type Input = {
                locationId: number;
                action:
                    | PosOperatorGroupManageActionFindAll
                    | PosOperatorGroupManageActionCreate
                    | PosOperatorGroupManageActionAddRoles
                    | PosOperatorGroupManageActionRemoveRoles
                    | PosOperatorGroupManageActionUpdate
                    | PosOperatorGroupManageActionDelete;
            };
            export type Output = {
                groups: (Pick<PosOperatorRoleGroup, 'id' | 'ref' | 'name' | 'sessionLengthMinutes'> & {
                    operators: Pick<PosOperator, 'id' | 'name'>[];
                    roles: Pick<PosOperatorRole, 'id' | 'value'>[];
                })[];
                roles: Pick<PosOperatorRole, 'id' | 'value' | 'description'>[];
                operators: Pick<PosOperator, 'id' | 'name'>[];
            };
            export type PosOperatorGroupManageActionFindAll = {
                type: 'FIND_ALL';
            };
            export type PosOperatorGroupManageActionCreate = {
                type: 'CREATE';
                name: string;
                roleIds: number[];
                ref?: string;
            };
            export type PosOperatorGroupManageActionAddRoles = {
                type: 'ADD_ROLES';
                roleGroupIds: number[];
                roleIds: number[];
            };
            export type PosOperatorGroupManageActionRemoveRoles = {
                type: 'REMOVE_ROLES';
                roleGroupIds: number[];
                roleIds: number[];
            };
            export type PosOperatorGroupManageActionUpdate = {
                type: 'UPDATE';
                ids: number[];
                values: Partial<PosOperatorRoleGroup>;
            };
            export type PosOperatorGroupManageActionDelete = {
                type: 'DELETE';
                ids: number[];
            };
        }
        export namespace ProductPost {
            export const url = '/product/[post]';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProductAdminGetPost {
            export const url = '/product/admin/get';
            export type Output = {};
            export type Input = {};
            export type ProductAdminGetInput = {
                locationId: number;
            };
            export type ProductAdminGetOutput = {
                products: ProductAdminGetProduct[];
                accounts: ProductAdminGetAccount[];
                courses: ProductAdminGetCourse[];
                variantGroups: ProductAdminGetVariantGroup[];
                modifierGroups: ProductAdminGetModifierGroup[];
                productTags: ProductAdminGetProductTag[];
                stations: Station[];
            };
            export type ProductAdminGetProduct = Product & {
                productProductTags: {
                    productTag: Pick<ProductTag, 'id' | 'type'>;
                }[];
            };
            export type ProductAdminGetAccount = Pick<Account, 'id' | 'name' | 'code' | 'vatPercent' | 'type'>;
            export type ProductAdminGetCourse = Pick<Course, 'id' | 'name'>;
            export type ProductAdminGetVariantGroup = Pick<VariantGroup, 'id' | 'name' | 'nameInternal'>;
            export type ProductAdminGetModifierGroup = Pick<ModifierGroup, 'id' | 'name' | 'nameInternal'>;
            export type ProductAdminGetProductTag = Pick<ProductTag, 'id' | 'type' | 'name'>;
        }
        export namespace ProductBatchUpdatePost {
            export const url = '/product/batchUpdate';
            export type Input = {
                locationId: number;
                productIds: number[];
                variantGroupId: number;
                modifierGroupIds: number[];
                productTagIds: number[];
                removeVariantGroup?: boolean;
                removeModifierGroups?: boolean;
                removeTags?: boolean;
            };
            export type Output = void;
        }
        export namespace ProductGetAllProductsPost {
            export const url = '/product/getAllProducts';
            export type Output = {};
            export type Input = {
                locationId: number;
            };
        }
        export namespace ProductGetBatchUpdateDataPost {
            export const url = '/product/getBatchUpdateData';
            export type Output = {};
            export type Input = {};
            export type ProductGetBatchUpdateDataInput = {
                locationId: number;
            };
            export type ProductGetBatchUpdateDataOutput = {
                courses: Pick<Course, 'id' | 'name'>[];
            };
        }
        export namespace ProductImportPost {
            export const url = '/product/import';
            export type Output = {};
            export type Input = {
                locationId: number;
                products: Product[];
            };
        }
        export namespace ProductUpdatePost {
            export const url = '/product/update';
            export type Input = {
                menuProducts: Pick<MenuProduct, 'menuId' | 'productId' | 'position'>[];
            };
            export type Output = void;
        }
        export namespace ProductUpdateProductsPost {
            export const url = '/product/updateProducts';
            export type Output = {};
            export type Input = {};
            export type UpdateProductInput = {
                productIds: number[];
                properties: Partial<Product>;
            };
        }
        export namespace ProviderAdyenCheckoutCreatePaymentPost {
            export const url = '/provider/adyen/checkout/createPayment';
            export type Input = {
                paymentMethod: any;
                meta: {
                    paymentId?: number;
                    orderId?: number;
                    amount: any;
                    hostname: string;
                    browserInfo?: any;
                    origin?: any;
                };
                isDesktop: boolean;
                takeawayAt?: string;
            };
            export type Output = {
                orderId?: number;
                paymentId?: number;
                successTitle?: string;
                successDescription?: string;
                type: 'SUCCESS' | 'REDIRECT' | 'ERROR';
                data?: any;
                redirectData?: any;
            };
        }
        export namespace ProviderAdyenCheckoutGetAdditionalDetailsPost {
            export const url = '/provider/adyen/checkout/getAdditionalDetails';
            export type Input = {
                zoneId: number;
                meta: any;
                paymentMethod: any;
            };
            export type Output = any;
        }
        export namespace ProviderAdyenCheckoutHandleRedirectResultPost {
            export const url = '/provider/adyen/checkout/handleRedirectResult';
            export type Output = {};
            export type Input = {
                checkoutResponse: {
                    paymentId: number;
                    orderId?: number;
                    data: {
                        paymentData?: string;
                    };
                };
                redirectResult?: string;
                payload?: string;
            };
        }
        export namespace ProviderAdyenGetCompanyOverviewPost {
            export const url = '/provider/adyen/getCompanyOverview';
            export type Input = {
                companyId: number;
            };
            export type Output = any;
        }
        export namespace ProviderAdyenGetPaymentDetailsPost {
            export const url = '/provider/adyen/getPaymentDetails';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderAdyenGetPaymentsPost {
            export const url = '/provider/adyen/getPayments';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderAdyenPayoutsGetCompanyPayoutDetailsPost {
            export const url = '/provider/adyen/payouts/getCompanyPayoutDetails';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderAdyenPayoutsGetPayoutHistoryPost {
            export const url = '/provider/adyen/payouts/getPayoutHistory';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderAdyenWebhooksHandleNotificationWebhookTypePost {
            export const url = '/provider/adyen/webhooks/handleNotification.{webhookType}';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderAdyenWebhooksHandlePlatformNotificationPost {
            export const url = '/provider/adyen/webhooks/handlePlatformNotification';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderAdyenWebhooksHandleTerminalEventPost {
            export const url = '/provider/adyen/webhooks/handleTerminalEvent';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderAdyenWebhooksHandleTerminalNotificationPost {
            export const url = '/provider/adyen/webhooks/handleTerminalNotification';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderKdrSyncPreparePost {
            export const url = '/provider/kdr/sync/prepare';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderKdrSyncUpdateConfigPost {
            export const url = '/provider/kdr/sync/update-config';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderMunuGetOrdersPost {
            export const url = '/provider/munu/getOrders';
            export type Input = {
                locationId: number;
                limit?: number;
            };
            export type Output = {
                data: ProviderMunuGetOrdersDataItem[];
            };
            export type ProviderMunuGetOrdersDataItem = {
                order: ProviderMunuGetOrdersOrder;
                munuOrder?: ProviderMunuGetOrdersMunuOrder;
            };
            export type ProviderMunuGetOrdersOrder = Pick<Order, 'id' | 'hash' | 'createdAt'> & {
                orderProducts: Pick<OrderProduct, 'id' | 'productName' | 'priceCombined'>[];
            };
            export type ProviderMunuGetOrdersMunuOrder = Pick<
                MunuOrder,
                'id' | 'orderId' | 'createdAt' | 'isSuccess' | 'request' | 'munuOrderId'
            >;
        }
        export namespace ProviderMunuSyncPreparePost {
            export const url = '/provider/munu/sync/prepare';
            export type Input = { locationId: number };
            export type Output = {
                products: Pick<Product, 'id' | 'externalId' | 'name'>[];
                articleGroups: {
                    id: number;
                    name: string;
                    lastModified: string;
                    articles: {
                        munuId: number;
                        munuName: string;
                        munuPrice: string;
                        rdxName: string;
                        rdxPrice: string;
                        isSynced: boolean;
                    }[];
                }[];
            };
        }
        export namespace ProviderMunuSyncSyncArticlesPost {
            export const url = '/provider/munu/sync/syncArticles';
            export type Input = {
                locationId: number;
                articleIds: number[];
            };
            export type Output = void;
        }
        export namespace ProviderMunuTestConnectionPost {
            export const url = '/provider/munu/testConnection';
            export type Input = IntegrationDataMunu;
            export type Output = { isSuccess: boolean };
        }
        export namespace ProviderPaymentBamboraCallbackGet {
            export const url = '/provider/payment/bambora/callback.[get]';
            export type Output = {};
            export type Input = {};
            type BamboraOrderId = string;
            type MinorUnits = number;
            type Query =
                | {
                      orderid: BamboraOrderId;
                      hash: string;
                      amount: MinorUnits;
                      cardno: string;
                      currency: string;
                      date: string;
                      eci: string;
                      feeid: string;
                      issuercountry: string;
                      paymenttype: string;
                      reference: string;
                      time: string;
                      txnfee: string;
                      txnid: string;
                  }
                | {
                      amount: '100';
                      cardno: '494656XXXXXX8636';
                      currency: 'NOK';
                      date: '20190527';
                      eci: '7';
                      feeid: '186013';
                      hash: 'f8ee7ef5addbfd13a4df562961f22526';
                      issuercountry: 'NOR';
                      orderid: 'b8939e51de984574b092';
                      paymenttype: '2';
                      reference: '445000896896';
                      time: '1444';
                      txnfee: '0';
                      txnid: '165032700345108480';
                  };
        }
        export namespace ProviderPaymentBamboraPreparePost {
            export const url = '/provider/payment/bambora/prepare';
            export type Output = {};
            export type Input = {
                zoneId: number;
                orderId?: number;
                paymentId?: number;
                tipAmount: number;
                provider: PaymentProvider;
                totalCost: number;
            };
        }
        export namespace ProviderPaymentDevelopmentPaymentPost {
            export const url = '/provider/payment/development/payment';
            export type Output = {};
            export type Input = {
                orderId?: number;
                paymentId?: number;
            };
        }
        export namespace ProviderPaymentVippsPreparePost {
            export const url = '/provider/payment/vipps/prepare';
            export type Output = {};
            export type Input = {
                orderId?: number;
                paymentId?: number;
            };
        }
        export namespace ProviderPaymentVippsV2ConsentsUserIdDelete {
            export const url = '/provider/payment/vipps/v2/consents.{userId}.[delete]';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderPaymentVippsV2PaymentsProviderOrderIdPost {
            export const url = '/provider/payment/vipps/v2/payments.{providerOrderId}';
            export type Output = {};
            type MerchantId6Chars = string;
            type ProviderOrderId = string;
            type AmountMinorUnits = number;
            type DateTime = string;
            enum VippsInitiateTransactionStatus {
                RESERVED = 'RESERVED',
                SALE = 'SALE',
            }
            export type Input = {
                merchantSerialNumber: MerchantId6Chars;
                orderId: ProviderOrderId;
                transactionInfo: {
                    transactionId: string;
                    amount: AmountMinorUnits;
                    status: VippsInitiateTransactionStatus;
                    timeStamp: DateTime;
                };
            };
        }
        export namespace ProviderPaymentVippsV2PaymentsProviderOrderIdShippingDetailsPost {
            export const url = '/provider/payment/vipps/v2/payments.{providerOrderId}.shippingDetails';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderPosKdrMenuGet {
            export const url = '/provider/pos/kdr/menu.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderPosKdrMerchantsMerchantIdVouchersVoucherIdCapturePost {
            export const url = '/provider/pos/kdr/merchants.{merchantId}.vouchers.{voucherId}.capture';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderPosKdrOrderGet {
            export const url = '/provider/pos/kdr/order.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderPosKdrPreparePost {
            export const url = '/provider/pos/kdr/prepare';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderPosKdrSyncPost {
            export const url = '/provider/pos/kdr/sync';
            export type Output = {};
            export type Input = {};
        }
        export namespace ProviderVismaTestConnectionPost {
            export const url = '/provider/visma/testConnection';
            export type Output = {};
            export type Input = {};
            export type ProviderVismaTestConnectionInput = {
                locationId: number;
                apiUrl?: string;
                username?: string;
                password?: string;
            };
            export type ProviderVismaTestConnectionOutput = {
                isSuccess: boolean;
            };
        }
        export namespace PublicBrowseFeedGet {
            export const url = '/public/browse-feed.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace PublicBrowsePost {
            export const url = '/public/browse';
            export type Output = {};
            export type Input = {};
        }
        export namespace PublicCovidRegisterPost {
            export const url = '/public/covid/register';
            export type Output = {};
            export type Input = {};
        }
        export namespace PublicLocationLocationIdGet {
            export const url = '/public/location/{locationId}/[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace PublicOutletOutletIdGet {
            export const url = '/public/outlet/{outletId}.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace PublicTagIdGet {
            export const url = '/public/tag.{id}.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace PublicZonePost {
            export const url = '/public/zone/[post]';
            export type Input = {
                zoneId: string | number;
                tagIdsClaimed?: string[];
            };
            export type Output = {
                id: number;
                hash: string;
                name: string;
                image: string;
                currency: any;
                isClosed: boolean;
                isHidden: boolean;
                hasTakeaway: boolean;
                isQueueLimitReached: boolean;
                zone: Zone;
                outlet: Outlet;
                location: {
                    id: number;
                    name: string;
                    isDevelopment: boolean;
                    serviceFeePercent: number;
                    serviceFeeAmount: number;
                    isServiceFeeDisplayedInList: boolean;
                };
                menu: MenuProduct[];
                tip?: {
                    presets: number[];
                    productId: number;
                };
                payments: {
                    isPaymentRequired: boolean;
                    paid: number;
                    total: number;
                };
                orders: {
                    id: number;
                    status: OrderStatus;
                    products: {
                        id: number;
                        name: string;
                        description: string;
                        icon: string;
                        priceFinal: number;
                        priceInitial: number;
                    }[];
                }[];
                productsPaymentRequired: OrderProduct[];
                covidRegistration?: {
                    outlets: {
                        id: number;
                        name: string;
                        zones: {
                            id: number;
                            name: string;
                        }[];
                    }[];
                };
                serviceFeeConfig?: LocationConfig & {
                    data: LocationConfigDataServiceFeeGroups;
                };
                style?: string;
                idleState?: LocationConfigDataZoneIdleState;
            };
        }
        export namespace QueryPost {
            export const url = '/query';
            export type Output = {};
            export type Input = {};
            export enum QueryBodyAction {
                CREATE = 'CREATE',
                READ_ALL = 'READ_ALL',
                READ_ONE = 'READ_ONE',
                READ_ONE_OR_FAIL = 'READ_ONE_OR_FAIL',
                UPDATE = 'UPDATE',
                DELETE = 'DELETE',
            }
            type QueryBody = {
                action: QueryBodyAction;
                entity: string;
                entityOptions?: any;
                form?: any;
            };
        }
        export namespace ReportingGetLocationOverviewGet {
            export const url = '/reporting/getLocationOverview.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace ReportingGetSalesPost {
            export const url = '/reporting/getSales';
            export type Output = {};
            export type Input = {};
            export type ReportingGetSalesInput = {
                from: string;
                to: string;
                locationIds?: number[];
                outletIds?: number[];
                zoneIds?: number[];
            };
            export type ReportingGetSalesOutput = {
                value: any;
                chart: {
                    xAxisLabels: string[];
                    series: {
                        name: string;
                        type: string;
                        barWidth: string;
                        data: number[];
                        smooth?: boolean;
                        areaStyle?: any;
                    }[];
                };
            };
        }
        export namespace SettlementGetReportPost {
            export const url = '/settlement/getReport';
            export type Output = {};
            export type Input = {
                type: 'EXCEL' | 'PDF' | 'DATA' | 'SETTLEMENT';
                from: string;
                to: string;
                locationId: number;
                outletId: number;
                outletIds: number[];
                settlementId: number;
                version: string;
                excelOutputType: ExcelOutputType;
            };
            export enum ExcelOutputType {
                SINGLE_SHEET = 'SINGLE_SHEET',
                ROW_PER_DAY = 'ROW_PER_DAY',
                SHEET_PER_DAY = 'SHEET_PER_DAY',
            }
        }
        export namespace SettlementUpdatePost {
            export const url = '/settlement/update';
            export type Input = {
                settlementId: number;
                data: Pick<Settlement, 'description'>;
            };
            export type Output = {};
        }
        export namespace SpcPublicBootstrapPost {
            export const url = '/spc/public/Bootstrap';
            export type Output = {};
            export type Input = {};
        }
        export namespace SpcPublicCheckoutPost {
            export const url = '/spc/public/Checkout';
            export type Output = {};
            enum Action {
                PLACE_ORDER = 'PLACE_ORDER',
                CHOOSE_PRODUCTS = 'CHOOSE_PRODUCTS',
                CHOOSE_TIP = 'CHOOSE_TIP',
                ACCEPT_TERMS = 'ACCEPT_TERMS',
                CHANGE_COURSE = 'CHANGE_COURSE',
                CHOOSE_PAYMENT_PROVIDER = 'CHOOSE_PAYMENT_PROVIDER',
                ORDER_PLACED = 'ORDER_PLACED',
            }
            export type Input = {
                zoneId: number;
                action: Action;
                provider: PaymentProvider;
                appVersion: string;
                products?: any[];
                orderProducts?: any[];
                tipAmount?: number;
                isTermsAccepted?: boolean;
                productCourse?: Record<number, number>;
                productRequestStatus: Record<number, OrderProductRequestStatus>;
                isDesktop?: boolean;
                takeawayAt?: string;
                areaCode?: string;
                phone?: string;
            };
        }
        export namespace SpcPublicConnectPost {
            export const url = '/spc/public/Connect';
            export type Output = {};
            export type Input = {};
        }
        export namespace StatsGet {
            export const url = '/stats.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace SuperAdminAdyenAccountHolderPost {
            export const url = '/super-admin/adyen/account-holder';
            export type Output = {};
            export type Input = {};
        }
        export namespace SuperAdminAdyenAccountHolderCodePost {
            export const url = '/super-admin/adyen/account-holder.{code}';
            export type Output = {};
            export type Input = {};
        }
        export namespace SuperAdminAdyenAssignTerminalsPost {
            export const url = '/super-admin/adyen/assignTerminals';
            export type Output = {};
            export type Input = {};
        }
        export namespace SuperAdminAdyenCreateAccountHolderPost {
            export const url = '/super-admin/adyen/create-account-holder';
            export type Output = {};
            export type Input = {
                companyId: number;
                accountHolderCode?: string;
                doingBusinessAs: string;
                legalBusinessName: string;
                email: string;
                fullPhoneNumber: string;
                shareholders: {
                    firstName: string;
                    lastName: string;
                    gender: any; // ViasName.GenderEnum
                }[];
            };
        }
        export namespace SuperAdminAdyenLoadTerminalLogsPost {
            export const url = '/super-admin/adyen/loadTerminalLogs';
            export type Output = {};
            export type Input = {};
        }
        export namespace SuperAdminAdyenLoadTerminalsPost {
            export const url = '/super-admin/adyen/loadTerminals';
            export type Input = {};
            export type Output = {
                table;
            };
        }
        export namespace SuperAdminDataQueryGetPaymentsPost {
            export const url = '/super-admin/dataQuery/getPayments';
            export type Input = void;
            export type Output = SuperAdminDataQueryGetPaymentsItem;
            export type SuperAdminDataQueryGetPaymentsItem = Pick<
                Payment,
                | 'id'
                | 'createdAt'
                | 'status'
                | 'merchantReference'
                | 'provider'
                | 'cardNumber'
                | 'amountInitial'
                | 'amountRefund'
                | 'currency'
                | 'locationId'
            > & {
                location: Pick<Location, 'name'>;
            };
        }
        export namespace SuperAdminDataQueryGetSystemNotificationsPost {
            export const url = '/super-admin/dataQuery/getSystemNotifications';
            export type Input = void;
            export type Output = SuperAdminDataQueryGetSystemNotificationSystemNotification;
            export type SuperAdminDataQueryGetSystemNotificationSystemNotification = Pick<
                SystemNotification,
                'id' | 'type' | 'event' | 'message' | 'data' | 'createdAt' | 'isHandled'
            >;
        }
        export namespace SuperAdminDocumentGetPost {
            export const url = '/super-admin/document/get';
            export type Input = {
                id: string;
            };
            export type Output = any;
        }
        export namespace SuperAdminDocumentUpdatePost {
            export const url = '/super-admin/document/update';
            export type Input = {
                id: string;
                value?: any;
            };
            export type Output = any;
        }
        export namespace SuperAdminFeatureGetPost {
            export const url = '/super-admin/feature/get';
            export type Output = {};
            export type Input = {};
            export type SuperAdminFeatureGetInput = {};
            export type SuperAdminFeatureGetOutput = {
                locations: SuperAdminFeatureGetLocation[];
                features: SuperAdminFeatureGetFeature[];
            };
            export type SuperAdminFeatureGetLocation = Pick<Location, 'id' | 'name'> & {
                features: SuperAdminFeatureGetFeature[];
            };
            export type SuperAdminFeatureGetFeature = Pick<
                Feature,
                'id' | 'type' | 'isActive' | 'name' | 'description'
            >;
        }
        export namespace SuperAdminFeatureTogglePost {
            export const url = '/super-admin/feature/toggle';
            export type Output = {};
            export type Input = {};
            export type SuperAdminFeatureToggleInput = {
                type: FeatureType;
                action: 'create' | 'update' | 'delete';
                isActive?: boolean;
                locationId?: number;
            };
            export type SuperAdminFeatureToggleOutput = void;
        }
        export namespace SuperAdminGetOrderOrPaymentPost {
            export const url = '/super-admin/getOrderOrPayment';
            export type Output = {};
            export type Input = {
                type: 'ORDER' | 'PAYMENT';
                id: string;
            };
        }
        export namespace SuperAdminGetTransactionsDataPost {
            export const url = '/super-admin/getTransactionsData';
            export type Output = {};
            export type Input = {
                from: string;
                to: string;
                paymentProviders?: PaymentProvider[];
                txnAmountFrom?: number;
                txnAmountTo?: number;
            };
        }
        export namespace SuperAdminLegacyLocationGet {
            export const url = '/super-admin/legacy-location.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace SuperAdminLocationGetAllLocationsPost {
            export const url = '/super-admin/location/getAllLocations';
            export type Output = {};
            export type Input = {};
        }
        export namespace SuperAdminLocationGetCoursesPost {
            export const url = '/super-admin/location/getCourses';
            export type Output = {};
            export type Input = {};
            export type SuperAdminLocationGetCoursesInput = {};
            export type SuperAdminLocationGetCoursesOutput = {
                locations: SuperAdminLocationGetCoursesLocation[];
            };
            export type SuperAdminLocationGetCoursesLocation = Pick<Location, 'id' | 'name'> & {
                courses: SuperAdminLocationGetCoursesLocationCourse[];
            };
            export type SuperAdminLocationGetCoursesLocationCourse = Pick<Course, 'id' | 'name'>;
        }
        export namespace SuperAdminLocationGetCovidExportLinkPost {
            export const url = '/super-admin/location/getCovidExportLink';
            export type Output = {};
            export type Input = {
                locationId: number;
                from: string;
                to: string;
            };
        }
        export namespace SuperAdminLocationGetOverviewPost {
            export const url = '/super-admin/location/getOverview';
            export type Input = {
                locationId: number;
            };
            export type Output = any;
        }
        export namespace SuperAdminServiceFeeGetAllPost {
            export const url = '/super-admin/service-fee/getAll';
            export type Output = {};
            export type Input = {};
        }
        export namespace SuperAdminSettlementAnalyzeSettlementPost {
            export const url = '/super-admin/settlement/analyzeSettlement';
            export type Output = {};
            export type Input = {
                settlementId: number;
            };
        }
        export namespace SuperAdminSettlementGetDataPost {
            export const url = '/super-admin/settlement/getData';
            export type Output = {};
            export type Input = {
                settlementId: number;
            };
        }
        export namespace SuperAdminSettlementSettlePost {
            export const url = '/super-admin/settlement/settle';
            export type Input = {
                locationId: number;
            };
            export type Output = any;
        }
        export namespace SuperAdminStarPrinterManagePost {
            export const url = '/super-admin/starPrinter/manage';
            export type Input = V2StarPrinterUpdate;
            export type V2StarPrinterUpdate = {
                action: 'CREATE_OR_UPDATE';
                data: Partial<StarPrinter>;
            };
            export type Output = any;
        }
        export namespace SuperAdminTerminalChangeCompanyPost {
            export const url = '/super-admin/terminal/changeCompany';
            export type Input = {
                terminalId: number | number[];
                companyId: number;
            };
            export type Output = void;
        }
        export namespace SuperAdminTerminalGetUpdateFormPost {
            export const url = '/super-admin/terminal/getUpdateForm';
            export type Input = {};
            export type Output = {
                locations: Pick<Location, 'id' | 'name'>[];
                stores: {
                    description: string;
                    merchantAccountCode: string;
                    status: 'Active';
                    store: string;
                }[];
            };
        }
        export namespace SuperAdminTerminalUpdateTerminalsPost {
            export const url = '/super-admin/terminal/updateTerminals';
            export type Input = {
                terminalIds: number[];
                values: {
                    locationId: number;
                    store: string;
                };
            };
            export type Output = void;
        }
        export namespace SuperAdminUserLoginPost {
            export const url = '/super-admin/user-login';
            export type Input = {
                userId: number;
            };
            export type Output = {
                token: string;
            };
        }
        export namespace SuperAdminUserPost {
            export const url = '/super-admin/user';
            export type Output = {};
            export type Input = {};
        }
        export namespace TagIdGet {
            export const url = '/tag/{id}.[get]';
            export type Output = {};
            export type Input = {};
        }
        export namespace TagImportPost {
            export const url = '/tag/import/[post]';
            export type Output = {};
            export type Input = {};
        }
        export namespace TagSearchPost {
            export const url = '/tag/search';
            export type Input = {
                id: number;
                type: TagType;
                name: string;
                description: string;
            };
            export type Output = Tag[];
        }
        export namespace TerminalLoadPaymentHistoryPost {
            export const url = '/terminal/loadPaymentHistory';
            export type Output = {};
            export type Input = {
                outletId: number;
                terminalId: number;
            };
        }
        export namespace TerminalLoadTerminalEventsPost {
            export const url = '/terminal/loadTerminalEvents';
            export type Output = {};
            export type Input = {
                terminalId: number;
            };
        }
        export namespace TerminalLoadTerminalsPost {
            export const url = '/terminal/loadTerminals';
            export type Output = {};
            export type Input = {
                companyId: number;
            };
        }
        export namespace TerminalPresetAddTerminalsPost {
            export const url = '/terminal/preset/addTerminals';
            export type Output = {};
            export type Input = {
                companyId: number;
                terminalPresetId: number;
                terminalIds: number[];
            };
        }
        export namespace TerminalPresetCreatePost {
            export const url = '/terminal/preset/create';
            export type Output = {};
            export type Input = {
                companyId: number;
                locationId: number;
                name: string;
            };
        }
        export namespace TerminalPresetDeletePost {
            export const url = '/terminal/preset/delete';
            export type Input = {
                locationId: number;
                id: number;
            };
            export type Output = void;
        }
        export namespace TerminalPresetDeleteTerminalsPost {
            export const url = '/terminal/preset/deleteTerminals';
            export type Output = {};
            export type Input = {
                terminalPresetId: number;
                terminalIds: number[];
            };
        }
        export namespace TerminalPresetGetLocationsPresetsPost {
            export const url = '/terminal/preset/getLocationsPresets';
            export type Input = {
                companyId: number;
            };
            export type Output = {
                terminals: PresetTerminal[];
                locations: PresetLocation[];
            };
            export type PresetTerminal = Pick<Terminal, 'id' | 'referenceId' | 'name' | 'locationId'>;
            export type PresetLocation = Pick<Location, 'id' | 'name'> & {
                outlets: PresetLocationOutlet[];
                terminalPresets: PresetLocationTerminalPreset[];
            };
            export type PresetLocationOutlet = Pick<Outlet, 'id' | 'name'> & {
                outletTerminalPresets: PresetLocationOutletTerminalPreset[];
            };
            export type PresetLocationOutletTerminalPreset = Pick<
                OutletTerminalPreset,
                'outletId' | 'terminalPresetId'
            >;
            export type PresetLocationTerminalPreset = Pick<TerminalPreset, 'id' | 'name'> & {
                terminalPresetTerminals: PresetTerminalPresetTerminal[];
            };
            export type PresetTerminalPresetTerminal = Pick<TerminalPresetTerminal, 'position'> & {
                terminal: Pick<Terminal, 'id' | 'referenceId' | 'pOIID' | 'name' | 'isActive'>;
            };
        }
        export namespace TerminalPresetUpdatePost {
            export const url = '/terminal/preset/update';
            export type Output = {};
            export type Input = Partial<TerminalPreset> & {
                outletId?: number;
            };
        }
        export namespace TerminalPresetUpdatePositionPost {
            export const url = '/terminal/preset/updatePosition';
            export type Output = {};
            export type Input = {};
            export type TerminalPresetUpdatePositionInput = {
                companyId: number;
                terminalPresetTerminals: Pick<TerminalPresetTerminal, 'terminalPresetId' | 'terminalId' | 'position'>[];
            };
            export type TerminalPresetUpdatePositionOutput = void;
        }
        export namespace TerminalRetryPaymentPost {
            export const url = '/terminal/retryPayment';
            export type Output = {};
            export type Input = {
                paymentId: number;
                terminalId: number;
            };
        }
        export namespace TerminalSendTestAmountPost {
            export const url = '/terminal/sendTestAmount';
            export type Output = {};
            export type Input = {
                pOIID: string;
            };
        }
        export namespace TerminalSyncAdyenPost {
            export const url = '/terminal/syncAdyen';
            export type Output = {};
            export type Input = {};
        }
        export namespace V2AdminLocationGetOverviewPost {
            export const url = '/v2/admin/location/getOverview';
            export type Input = {
                locationId: number;
                from: string;
                to: string;
            };
            export type Output = {
                filter: {
                    timezone?: string;
                    from: string;
                    to: string;
                };
                kpi: {
                    openOrder: V2AdminLocationGetOverviewKpiOpenOrder;
                    payment: V2AdminLocationGetOverviewKpiPayment;
                    product: V2AdminLocationGetOverviewKpiProduct;
                    accounts: V2AdminLocationGetOverviewKpiAccount[];
                    averagePaymentAmount: number;
                };
            };
            export type V2AdminLocationGetOverviewKpiOpenOrder = {
                count: number;
                zones: V2AdminLocationGetOverviewKpiOpenOrderZone[];
            };
            export type V2AdminLocationGetOverviewKpiOpenOrderZone = Pick<
                Zone,
                'id' | 'name' | 'position' | 'outletId'
            > & {
                outlet: Pick<Outlet, 'name'>;
                count: number;
            };
            export type V2AdminLocationGetOverviewKpiPayment = {
                revenue: number;
                count: number;
                items: V2AdminLocationGetOverviewKpiPaymentItem[];
            };
            export type V2AdminLocationGetOverviewKpiPaymentItem = Pick<
                Payment,
                'status' | 'provider' | 'amount' | 'txnMerchantGross'
            > & {
                count: number;
            };
            export type V2AdminLocationGetOverviewKpiProduct = {
                amount: number;
                count: number;
                items: V2AdminLocationGetOverviewKpiProductItem[];
            };
            export type V2AdminLocationGetOverviewKpiProductItem = Pick<
                OrderProduct,
                'productName' | 'priceCombined' | 'productId'
            > & {
                count: number;
            };
            export type V2AdminLocationGetOverviewKpiAccount = Pick<
                Account,
                'id' | 'name' | 'code' | 'vatPercent' | 'type'
            > & {
                count: number;
                amount: number;
                percentage: number;
            };
        }
        export namespace V2AdminMenuProductRemovePost {
            export const url = '/v2/admin/menuProduct/remove';
            export type Input = {
                menuId: number;
                productIds: number[];
            };
            export type Output = void;
        }
        export namespace V2AdminProductGetProductAccountsPost {
            export const url = '/v2/admin/product/getProductAccounts';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                productAccounts: ProductAccount[];
                accounts: Account[];
            };
        }
        export namespace V2AdminProductManageProductAccountPost {
            export const url = '/v2/admin/product/manageProductAccount';
            export type Input = {
                locationId: number;
                action: 'add' | 'remove';
                productIds: number[];
                accountId: number;
            };
            export type Output = void;
        }
        export namespace V2AdminReportingPeriodOverPeriodDownloadPost {
            export const url = '/v2/admin/reporting/periodOverPeriod/download';
            export type Input = {
                locationIds: number[];
                outletIds: number[];
                unit: 'month' | 'week' | 'day';
                from: string;
                to: string;
                filterByIsoWeekday?: number;
                combineData?: boolean;
            };
            export type Output = { url: string };
        }
        export namespace V2AdminReportingPeriodOverPeriodGetPost {
            export const url = '/v2/admin/reporting/periodOverPeriod/get';
            export type Input = {
                locationIds: number[];
                outletIds: number[];
                unit: 'month' | 'week' | 'day';
                from: string;
                to: string;
                filterByIsoWeekday?: number;
                combineData?: boolean;
            };
            export type Output = {
                query;
                dateFormat: string;
                dateFormats: string[];
                items: {
                    id: number;
                    name: string;
                    periods: {
                        from: string;
                        to: string;
                        amount: number;
                        accounts: { id: number; displayName: string; amount: number; percent: number }[];
                        discountAccounts: { id: number; displayName: string; amount: number; percent: number }[];
                        productsMissingAccount: { id: number; displayName: string; amount: number }[];
                    }[];
                }[];
            };
        }
        export namespace V2AdminReportingSalesGetPost {
            export const url = '/v2/admin/reporting/sales/get';
            export type Input = {
                locationIds: number[];
                unit: 'month' | 'week' | 'day';
                from: string;
                to: string;
                filterByIsoWeekday?: number;
            };
            export type Output = {
                locations: V2AdminReportingSalesGetProductItem[];
                chart;
            };
            export type V2AdminReportingSalesGetProductItem = {
                id: number;
                name: string;
                count: number;
                amount: number;
                orderCount: number;
                outlets: V2AdminReportingSalesGetProductItem[];
                zones: V2AdminReportingSalesGetProductItem[];
            };
            type ResultItem = Pick<
                OrderProduct,
                | 'locationId'
                | 'locationName'
                | 'outletId'
                | 'outletName'
                | 'zoneId'
                | 'zoneName'
                | 'productId'
                | 'productName'
            > & {
                count: number;
                amount: number;
                date: string;
            };
        }
        export namespace V2AdminTerminalGetTerminalsPost {
            export const url = '/v2/admin/terminal/getTerminals';
            export type Input = {
                companyId: number;
            };
            export type Output = {
                terminals: Terminal[];
                locations: Location[];
            };
        }
        export namespace V2PaymentMethodCreateOrUpdatePost {
            export const url = '/v2/paymentMethod/createOrUpdate';
            export type Input =
                | {
                      action: 'CREATE';
                      locationId: number;
                      values: Partial<PaymentMethod>[];
                  }
                | {
                      action: 'UPDATE';
                      locationId: number;
                      ids: number[];
                      values: Partial<PaymentMethod>;
                  };
            export type Output = void;
        }
        export namespace V2PaymentMethodGetOverviewPost {
            export const url = '/v2/paymentMethod/getOverview';
            export type Input = Pick<PaymentMethod, 'locationId'>;
            export type Output = {
                paymentMethods: PaymentMethod[];
            };
        }
        export namespace V2PaymentMethodGetReportPost {
            export const url = '/v2/paymentMethod/getReport';
            export type Input = {
                locationId: number;
                from: string;
                to: string;
                downloadAs?: 'EXCEL';
            };
            export type Output = {
                overview;
                transactions: (Pick<
                    Payment,
                    'id' | 'amount' | 'methodType' | 'hash' | 'provider' | 'providerTransactionId'
                > & {
                    methodName: string;
                    createdAt: string;
                    operatorName?: string;
                })[];
                url: string;
                chart?;
            };
        }
        export namespace V2PosCreatePaymentPost {
            export const url = '/v2/pos/createPayment';
            export type Input =
                | V2PosCreatePaymentBalance
                | V2PosCreatePaymentTerminal
                | V2PosCreatePaymentGiftCard
                | V2PosCreatePaymentExternal
                | V2PosCreatePaymentCustom
                | V2PosCreatePaymentVisbook;
            export type CreatePaymentInput = Input;
            export type Output = {
                other?: any;
                payment: Pick<Payment, 'id' | 'status'>;
            };
            export type V2PosCreateShared = {
                zoneId: number;
                orderProductIds: number[];
                split?: {
                    amount: number;
                };
                requestTip?: boolean;
                tipAmount?: number;
            };
            export type V2PosCreatePaymentBalance = V2PosCreateShared & {
                type: 'balance';
                balanceId: number;
                representationPeople?: { name: string }[];
                representationPurpose?: string;
            };
            export type V2PosCreatePaymentTerminal = V2PosCreateShared & {
                type: 'terminal';
                terminalId: number;
            };
            export type V2PosCreatePaymentGiftCard = V2PosCreateShared & {
                type: 'GIFT_CARD';
                code?: string;
            };
            export type V2PosCreatePaymentExternal = V2PosCreateShared & {
                type: 'EXTERNAL';
            };
            export type V2PosCreatePaymentCustom = V2PosCreateShared & {
                type: 'CUSTOM';
                paymentMethod: Pick<PaymentMethod, 'id' | 'name' | 'value' | 'data'>;
                code?: string;
            };
            export type V2PosCreatePaymentVisbook = V2PosCreateShared & {
                type: 'VISBOOK';
                roomId: number;
            };
        }
        export namespace V2PosGetQueueLimiterPost {
            export const url = '/v2/pos/getQueueLimiter';
            export type Input = {
                outletId: number;
            };
            export type Output = {
                isActive: boolean;
                count: number;
                limit: number;
            };
        }
        export namespace V2PosModuleAppBootstrapPost {
            export const url = '/v2/pos/module/app/bootstrap';
            export type Input = {
                outletId: number;
                zoneId?: number;
            };
            export type Output = {
                outlet: Pick<Outlet, 'id' | 'name' | 'image'>;
                location: Pick<Location, 'id' | 'name' | 'imageBackground' | 'imageLogo'>;
                zones: Zone[];
                features: FeatureType[];
                action?: 'OPERATOR_AUTH_REQUIRED';
            };
        }
        export namespace V2PosModuleDeviceEventGetPost {
            export const url = '/v2/pos/module/device/event/get';
            export type Input = {
                deviceFingerprint: string;
                label?: string;
                updatedAtMoreThan?;
                limit?: number;
            };
            export type Output = PosDeviceEvent[];
        }
        export namespace V2PosModuleDeviceEventRetrievePost {
            export const url = '/v2/pos/module/device/event/retrieve';
            export type Input = {
                deviceFingerprint: string;
            };
            export type Output = void;
        }
        export namespace V2PosModuleDeviceEventSendPost {
            export const url = '/v2/pos/module/device/event/send';
            export type Input = {
                deviceFingerprint: string;
                events: V2PosModuleDeviceEventSendItem[];
            };
            export type V2PosModuleDeviceEventSendItem = Pick<PosDeviceEvent, 'id' | 'label' | 'date' | 'ref' | 'data'>;
            export type Output = void;
        }
        export namespace V2PosModulePosBootstrapPost {
            export const url = '/v2/pos/module/pos/bootstrap';
            export type Input = {
                outletId: number;
            };
            export type Output = {
                location: V2PosModulePosLocation;
                features: FeatureType[];
                outlet: V2PosModulePosOutlet;
                zones: V2PosModulePosZone[];
                discounts: V2PosModulePosDiscount[];
                terminals: V2PosModulePosTerminal[];
                balances: V2PosModulePosBalance[];
                products: V2PosModulePosProduct[];
                variantGroups: V2PosModulePosVariantGroup[];
                modifierGroups: V2PosModulePosModifierGroup[];
                config: {
                    categoryStyle: Record<string, any>;
                };
            };
            export type V2PosModulePosLocation = Pick<Location, 'id' | 'name' | 'currency'>;
            export type V2PosModulePosOutlet = Pick<
                Outlet,
                'id' | 'name' | 'queueLimiterActive' | 'queueLimiterActiveLimit'
            >;
            export type V2PosModulePosZone = Pick<Zone, 'id' | 'name'>;
            export type V2PosModulePosDiscount = Pick<Discount, 'id' | 'name' | 'percent'>;
            export type V2PosModulePosTerminal = Pick<
                Terminal,
                'id' | 'pOIID' | 'isActive' | 'name' | 'terminalPaymentId'
            > & {
                terminalPayment?: Pick<Payment, 'id' | 'status' | 'amount' | 'currency' | 'createdAt'>;
            };
            export type V2PosModulePosBalance = Pick<Balance, 'id' | 'name'>;
            export type V2PosModulePosVariantGroup = Pick<VariantGroup, 'id' | 'name'> & {
                products: V2PosModulePosProduct[];
            };
            export type V2PosModulePosModifierGroup = Pick<
                ModifierGroup,
                | 'id'
                | 'name'
                | 'description'
                | 'autoSelectModifierId'
                | 'autoSelectFirstModifier'
                | 'createSeparateProducts'
                | 'minAllowed'
                | 'maxAllowed'
                | 'presentationType'
            > & {
                items: V2PosModulePosModifierGroupItem[];
            };
            export type V2PosModulePosModifierGroupItem = Pick<ModifierGroupItem, 'id' | 'price'> & {
                modifier: Pick<Modifier, 'id' | 'name'>;
                product: V2PosModulePosProduct;
            };
            export type V2PosModulePosProduct = Pick<
                Product,
                | 'id'
                | 'name'
                | 'icon'
                | 'rootCategory'
                | 'category'
                | 'subCategory'
                | 'variantGroupId'
                | 'price'
                | 'priceTakeaway'
            > & {
                menuId?: number;
                productModifierGroups: Pick<ProductModifierGroup, 'modifierGroupId'>[];
            };
        }
        export namespace V2PosModulePosGetOrderByCodePost {
            export const url = '/v2/pos/module/pos/getOrderByCode';
            export type Input = {
                locationId: number;
                outletId: number;
                code: number;
            };
            export type Output = {
                orders: V2PosModuleOrderCodeGetOrderOrder[];
            };
            export type V2PosModuleOrderCodeGetOrderOrder = Pick<Order, 'id' | 'sequence' | 'status' | 'createdAt'> & {
                outlet: Pick<Outlet, 'id' | 'name'>;
                zone: Pick<Zone, 'id' | 'name'>;
                orderProducts: (Pick<OrderProduct, 'id' | 'priceCombined' | 'productId' | 'productName' | 'status'> & {
                    orderProductModifiers: Pick<OrderProductModifier, 'id' | 'productName' | 'modifierName'>[];
                })[];
            };
        }
        export namespace V2PosModulePosGetOrderHistoryPost {
            export const url = '/v2/pos/module/pos/getOrderHistory';
            export type Input = {
                outletId: number;
                history: {
                    orderId: number;
                    paymentId?: number;
                }[];
            };
            export type Output = {
                order: Pick<Order, 'id' | 'sequence'> & { zone?: Pick<Zone, 'name'> };
                payment?: Pick<Payment, 'id' | 'status' | 'amount'> & {
                    terminal?: Pick<Terminal, 'name' | 'model'>;
                };
            }[];
        }
        export namespace V2PosModulePosGetOrdersPost {
            export const url = '/v2/pos/module/pos/getOrders';
            export type Input = {
                outletId: number;
                limit?: number;
                offset?: number;
            };
            export type Output = {
                data: V2PosModulePosGetOrdersItem[];
            };
            export type V2PosModulePosGetOrdersItem = {
                order: Pick<Order, 'id' | 'sequence' | 'createdAt'> & { zone?: Pick<Zone, 'name'> };
                products: Pick<Product, 'id' | 'name'>[];
                payment?: V2PosModulePosGetOrdersItemPayment;
            };
            export type V2PosModulePosGetOrdersItemPayment = Pick<Payment, 'id' | 'status' | 'amount'> & {
                terminal?: Pick<Terminal, 'name' | 'model'>;
            };
        }
        export namespace V2PosModulePosPlaceOrderPost {
            export const url = '/v2/pos/module/pos/placeOrder';
            export type Input = {
                outletId: number;
                products: V2PosModulePosPlaceOrderProduct[];
                zoneId?: number;
                terminalId?: number;
                balanceId?: number;
                balanceRepresentationPeople?: { name: string }[];
                balanceRepresentationPurpose?: string;
                requestTip?: boolean;
                isTakeaway?: boolean;
                isTerminalManualKeyEntry?: boolean;
                customDiscountAmount?: number;
                customDynamicAmount?: number;
                customDynamicAmountComment?: string;
            };
            export type Output = {
                orderId: number;
                orderSequence: number;
                paymentId?: number;
            };
            export type V2PosModulePosPlaceOrderProduct = {
                id: number;
                name: string;
                price: number;
                comment?: string;
                variantGroup?: V2PosModulePosPlaceOrderProductVariantGroup;
                modifierGroupProducts?: Record<number, number[]>;
                discountId?: number;
                discountAmount?: number;
                menuId?: number;
                courseId?: number;
            };
            export type V2PosModulePosPlaceOrderProductVariantGroup = {
                id: number;
                productId: number;
            };
            type UseLocationOutput = {
                locationId: number;
                locationName: string;
                outletId: number;
                outletName: string;
                zoneId: number;
                zoneName: string;
                currency: string;
                formatCurrency(amount: number): number;
            };
        }
        export namespace V2PosModuleZoneGetZoneDataPost {
            export const url = '/v2/pos/module/zone/getZoneData';
            export type Input = {
                zoneIds?: number[];
                outletId?: number;
            };
            export type Output = {
                zones: V2ZoneModuleZoneGetZoneDataZone[];
                orderMeta: V2ZoneModuleZoneGetZoneDataOrderMeta;
                orderProductMeta: V2ZoneModuleZoneGetZoneDataOrderProductMeta;
                terminals: V2ZoneModuleZoneGetZoneDataTerminal[];
                paymentMethods: PaymentMethod[];
            };
            export type V2ZoneModuleZoneGetZoneDataZone = V2ZoneModuleZoneGetZoneDataZoneZone & {
                amount: {
                    paid: number;
                    missing: number;
                    total: number;
                };
                location: V2ZoneModuleZoneGetZoneDataZoneLocation;
                outlet: V2ZoneModuleZoneGetZoneDataZoneOutlet;
                orders: Order[];
                isClearable: boolean;
                courses: (Pick<Course, 'id' | 'name'> & {
                    timestamp?: string;
                    status: PosOutletGetZonesTerminalCourseStatus;
                    orderProducts: PosOutletGetZonesOrderProduct[];
                })[];
            };
            export type V2ZoneModuleZoneGetZoneDataZoneLocation = Pick<Location, 'id' | 'name' | 'currency'>;
            export type V2ZoneModuleZoneGetZoneDataZoneOutlet = Pick<Outlet, 'id' | 'name'>;
            export type V2ZoneModuleZoneGetZoneDataZoneZone = Pick<
                Zone,
                'id' | 'name' | 'isClosed' | 'isHidden' | 'isPayMode'
            >;
            export type V2ZoneModuleZoneGetZoneDataOrderMeta = Record<
                number,
                {
                    operatorName?: string;
                }
            >;
            export type V2ZoneModuleZoneGetZoneDataOrderProductMeta = Record<
                number,
                {
                    amountTotal: number;
                    amountPaid: number;
                    amountMissing: number;
                    amountDiscounted: number;
                    isPaid: boolean;
                    isPaymentRequired: boolean;
                }
            >;
            export type V2ZoneModuleZoneGetZoneDataTerminal = Pick<
                Terminal,
                'id' | 'pOIID' | 'isActive' | 'name' | 'terminalPaymentId'
            > & {
                terminalPayment?: Pick<Payment, 'id' | 'status' | 'amount' | 'currency' | 'createdAt'>;
            };
            type PosOutletGetZonesOrderProduct = Pick<
                OrderProduct,
                | 'id'
                | 'updatedAt'
                | 'status'
                | 'paymentStatus'
                | 'productId'
                | 'productName'
                | 'productRootCategory'
                | 'priceCombined'
                | 'requestStatus'
                | 'zoneId'
                | 'courseId'
                | 'orderProductPayments'
            >;
            enum PosOutletGetZonesTerminalCourseStatus {
                EMPTY = 'EMPTY',
                CAN_REQUEST = 'CAN_REQUEST',
                REQUESTED = 'REQUESTED',
                READY = 'READY',
                WAIT = 'WAIT',
                FINISHED = 'FINISHED',
            }
        }
        export namespace V2ProviderTripletexGetAccountsPost {
            export const url = '/v2/provider/tripletex/getAccounts';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                tripletexAccount;
                account?: Account;
            }[];
        }
        export namespace V2ProviderTripletexMatchLocationAccountsPost {
            export const url = '/v2/provider/tripletex/matchLocationAccounts';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                isMissingAccounts: boolean;
                accounts: {
                    account: Account;
                    tripletexAccount?;
                    isCompleteMatch: boolean;
                }[];
            };
        }
        export namespace V2ProviderTripletexSendSettlementPost {
            export const url = '/v2/provider/tripletex/sendSettlement';
            export type Input = {
                settlementId: number;
            };
            export type Output = any;
        }
        export namespace V2ProviderTripletexSyncAccountsPost {
            export const url = '/v2/provider/tripletex/syncAccounts';
            export type Input = {
                locationId: number;
                accountNumbers: number[];
            };
            export type Output = any;
        }
        export namespace V2ProviderTripletexTestConnectionPost {
            export const url = '/v2/provider/tripletex/testConnection';
            export type Input = IntegrationDataTripletex & {
                locationId: number;
            };
            export type Output = { isConnected: boolean };
        }
        export namespace V2ProviderVismaPreparePost {
            export const url = '/v2/provider/visma/prepare';
            export type Input = {
                locationId: number;
            };
            export type Output = {
                accounts: {
                    code: string;
                    name: string;
                    type: string;
                    vismaCode?: string;
                    vismaType?: 'CREDIT' | 'DEBIT';
                }[];
            };
            export type V2ProviderVismaPrepareAccount = Pick<Account, 'id' | 'name' | 'code' | 'vatPercent'>;
        }
        export namespace V2ReportGetPost {
            export const url = '/v2/report/get';
            export type Input = {
                reportId: number;
            };
            export type Output = {
                report: V2ReportGetReport;
            };
            export type V2ReportGetReport = Pick<Report, 'id' | 'description' | 'type' | 'data' | 'locationId'>;
        }
        export namespace V2SettlementCreateReportPost {
            export const url = '/v2/settlement/createReport';
            export type Input = any;
            export type Output = {
                id: number;
            };
        }
        export namespace V2SpillageCreateReportPost {
            export const url = '/v2/spillage/createReport';
            export type Input = {
                locationId: number;
                outletId: number;
                reason: string;
                productIds: number[];
            };
            export type Output = void;
        }
        export namespace V2SpillageGetReportPost {
            export const url = '/v2/spillage/getReport';
            export type Input = {
                locationId: number;
                settlementId?: number;
            };
            export type Output = {
                input;
                reports: SpillageReport[];
                component: {
                    product;
                    account;
                };
                productCostPrice: Record<number, number>;
            };
        }
        export namespace V2SpillageUpdateReportItemPost {
            export const url = '/v2/spillage/updateReportItem';
            export type Input = {
                locationId: number;
                ids: SpillageReportItem['id'][];
                updateCostPrice?: {
                    price: number;
                    productId?: number;
                };
                updateCreditAccount?: {
                    id: number;
                };
            };
            export type Output = void;
        }
        export namespace V2SuperGetOverviewPost {
            export const url = '/v2/super/getOverview';
            export type Input = void;
            export type Output = {
                openOrder: {
                    count: number;
                    items: {
                        zoneId: number;
                        zoneName: string;
                        outletId: number;
                        outletName: string;
                        locationId: number;
                        locationName: string;
                        count: number;
                        minCreatedAt: string;
                        maxCreatedAt: string;
                    }[];
                };
                settlementsWithoutPayout: {
                    settlementId: number;
                    settlementSequence: number;
                    settlementSettledAt: Date;
                    locationId: number;
                    locationName: string;
                    payoutAmount: number;
                }[];
            };
        }
        export namespace V2TempCreateOrderPost {
            export const url = '/v2/temp/createOrder';
            export type Input = {
                terminalId: number;
                outletId: number;
                productId: number;
                price: number;
            };
            export type Output = any;
        }
        export namespace V2TempInvalidateTicketPost {
            export const url = '/v2/temp/invalidateTicket';
            export type Input = {
                guid: string;
            };
            export type Output = void;
        }
        export namespace XrComponentPost {
            export const url = '/xr/component';
            export type Input = XRComponentChartLine | XRComponentTable;
            export type Output = {};
            export type XRComponentChartLine = {
                type: 'CHART_LINE';
                xAxisLabels: string[];
                series: {
                    key: string;
                    data: number[];
                }[];
                valueType?: 'CURRENCY' | string;
                height?: number;
            };
            export type XRComponentTable = {
                type: 'table';
                columns: {
                    field: string;
                    label?;
                    value?;
                    type?: 'number' | 'currency';
                    align?: 'center' | 'right';
                    sum?: boolean;
                    bold?: boolean;
                }[];
                items;
            };
        }
        export namespace ZonePrintBillPost {
            export const url = '/zone/printBill';
            export type Input = {
                zoneId: number;
                terminalId: number;
                orderProductIds?: number[];
            };
            export type Output = void;
        }
    }

    export type API_IO = {
        [API.AdminAdyenCompanyPost.url]: [API.AdminAdyenCompanyPost.Input, API.AdminAdyenCompanyPost.Output];
        [API.AdminAdyenCompanyHopPost.url]: [API.AdminAdyenCompanyHopPost.Input, API.AdminAdyenCompanyHopPost.Output];
        [API.AdminAdyenLocationAccountPost.url]: [
            API.AdminAdyenLocationAccountPost.Input,
            API.AdminAdyenLocationAccountPost.Output,
        ];
        [API.AdminLocationBootstrapPost.url]: [
            API.AdminLocationBootstrapPost.Input,
            API.AdminLocationBootstrapPost.Output,
        ];
        [API.AdminLocationGetPost.url]: [API.AdminLocationGetPost.Input, API.AdminLocationGetPost.Output];
        [API.AdminLocationSettlementActionPost.url]: [
            API.AdminLocationSettlementActionPost.Input,
            API.AdminLocationSettlementActionPost.Output,
        ];
        [API.AdminLocationSettlementGetPost.url]: [
            API.AdminLocationSettlementGetPost.Input,
            API.AdminLocationSettlementGetPost.Output,
        ];
        [API.AdminLocationSettlementGetPendingPost.url]: [
            API.AdminLocationSettlementGetPendingPost.Input,
            API.AdminLocationSettlementGetPendingPost.Output,
        ];
        [API.AdminLocationSettlementGetReportPost.url]: [
            API.AdminLocationSettlementGetReportPost.Input,
            API.AdminLocationSettlementGetReportPost.Output,
        ];
        [API.AdminOnboardingPost.url]: [API.AdminOnboardingPost.Input, API.AdminOnboardingPost.Output];
        [API.AdminReportingGetOperatorSalesPost.url]: [
            API.AdminReportingGetOperatorSalesPost.Input,
            API.AdminReportingGetOperatorSalesPost.Output,
        ];
        [API.AdminReportingGetTerminalUsagePost.url]: [
            API.AdminReportingGetTerminalUsagePost.Input,
            API.AdminReportingGetTerminalUsagePost.Output,
        ];
        [API.AdminReportingSalesPost.url]: [API.AdminReportingSalesPost.Input, API.AdminReportingSalesPost.Output];
        [API.AdminSettlementConfirmPost.url]: [
            API.AdminSettlementConfirmPost.Input,
            API.AdminSettlementConfirmPost.Output,
        ];
        [API.AdminSettlementGetPost.url]: [API.AdminSettlementGetPost.Input, API.AdminSettlementGetPost.Output];
        [API.AnalyticsGet.url]: [API.AnalyticsGet.Input, API.AnalyticsGet.Output];
        [API.AnalyticsSalesPost.url]: [API.AnalyticsSalesPost.Input, API.AnalyticsSalesPost.Output];
        [API.AuthPost.url]: [API.AuthPost.Input, API.AuthPost.Output];
        [API.BalanceAdminGetTablePost.url]: [API.BalanceAdminGetTablePost.Input, API.BalanceAdminGetTablePost.Output];
        [API.BalanceUpdatePost.url]: [API.BalanceUpdatePost.Input, API.BalanceUpdatePost.Output];
        [API.CheckoutTipDataPost.url]: [API.CheckoutTipDataPost.Input, API.CheckoutTipDataPost.Output];
        [API.ClientAddBalancePost.url]: [API.ClientAddBalancePost.Input, API.ClientAddBalancePost.Output];
        [API.ClientAdminBalanceGetPost.url]: [
            API.ClientAdminBalanceGetPost.Input,
            API.ClientAdminBalanceGetPost.Output,
        ];
        [API.ClientAdminCreateInvoicePost.url]: [
            API.ClientAdminCreateInvoicePost.Input,
            API.ClientAdminCreateInvoicePost.Output,
        ];
        [API.ClientAdminGetPost.url]: [API.ClientAdminGetPost.Input, API.ClientAdminGetPost.Output];
        [API.ClientAdminGetInvoiceDataPost.url]: [
            API.ClientAdminGetInvoiceDataPost.Input,
            API.ClientAdminGetInvoiceDataPost.Output,
        ];
        [API.ClientAdminGetOverviewPost.url]: [
            API.ClientAdminGetOverviewPost.Input,
            API.ClientAdminGetOverviewPost.Output,
        ];
        [API.ClientAdminUpdateInvoicePost.url]: [
            API.ClientAdminUpdateInvoicePost.Input,
            API.ClientAdminUpdateInvoicePost.Output,
        ];
        [API.ClientCreatePost.url]: [API.ClientCreatePost.Input, API.ClientCreatePost.Output];
        [API.ClientImportBalancesPost.url]: [API.ClientImportBalancesPost.Input, API.ClientImportBalancesPost.Output];
        [API.ClientInvoiceDownloadPost.url]: [
            API.ClientInvoiceDownloadPost.Input,
            API.ClientInvoiceDownloadPost.Output,
        ];
        [API.ClientInvoiceMarkAsInvoicedPost.url]: [
            API.ClientInvoiceMarkAsInvoicedPost.Input,
            API.ClientInvoiceMarkAsInvoicedPost.Output,
        ];
        [API.ClientUpdatePost.url]: [API.ClientUpdatePost.Input, API.ClientUpdatePost.Output];
        [API.CompanyCompanyIdUserPost.url]: [API.CompanyCompanyIdUserPost.Input, API.CompanyCompanyIdUserPost.Output];
        [API.CompanyAdyenAddBankAccountPost.url]: [
            API.CompanyAdyenAddBankAccountPost.Input,
            API.CompanyAdyenAddBankAccountPost.Output,
        ];
        [API.CompanyAdyenCreateAccountPost.url]: [
            API.CompanyAdyenCreateAccountPost.Input,
            API.CompanyAdyenCreateAccountPost.Output,
        ];
        [API.CompanyGetAdyenHopUrlPost.url]: [
            API.CompanyGetAdyenHopUrlPost.Input,
            API.CompanyGetAdyenHopUrlPost.Output,
        ];
        [API.CronEJournalSyncPaymentsGet.url]: [
            API.CronEJournalSyncPaymentsGet.Input,
            API.CronEJournalSyncPaymentsGet.Output,
        ];
        [API.CronEJournalSyncSettlementsGet.url]: [
            API.CronEJournalSyncSettlementsGet.Input,
            API.CronEJournalSyncSettlementsGet.Output,
        ];
        [API.CronKdrSyncOrdersGet.url]: [API.CronKdrSyncOrdersGet.Input, API.CronKdrSyncOrdersGet.Output];
        [API.CronLocationConfigAutoPayoutGet.url]: [
            API.CronLocationConfigAutoPayoutGet.Input,
            API.CronLocationConfigAutoPayoutGet.Output,
        ];
        [API.CronLocationConfigAutoSettleGet.url]: [
            API.CronLocationConfigAutoSettleGet.Input,
            API.CronLocationConfigAutoSettleGet.Output,
        ];
        [API.CronOrderProductInventorySyncGet.url]: [
            API.CronOrderProductInventorySyncGet.Input,
            API.CronOrderProductInventorySyncGet.Output,
        ];
        [API.CronOutletEventsGet.url]: [API.CronOutletEventsGet.Input, API.CronOutletEventsGet.Output];
        [API.CronTerminalCheckLiveConnectionGet.url]: [
            API.CronTerminalCheckLiveConnectionGet.Input,
            API.CronTerminalCheckLiveConnectionGet.Output,
        ];
        [API.DataQueryGetCountingReportSummaryHistoryPost.url]: [
            API.DataQueryGetCountingReportSummaryHistoryPost.Input,
            API.DataQueryGetCountingReportSummaryHistoryPost.Output,
        ];
        [API.DataQueryGetLocationSettlementReportsPost.url]: [
            API.DataQueryGetLocationSettlementReportsPost.Input,
            API.DataQueryGetLocationSettlementReportsPost.Output,
        ];
        [API.DataQueryGetLocationSettlementsPost.url]: [
            API.DataQueryGetLocationSettlementsPost.Input,
            API.DataQueryGetLocationSettlementsPost.Output,
        ];
        [API.DataQueryGetOutletPaymentsPost.url]: [
            API.DataQueryGetOutletPaymentsPost.Input,
            API.DataQueryGetOutletPaymentsPost.Output,
        ];
        [API.DataQueryGetPaymentsPost.url]: [API.DataQueryGetPaymentsPost.Input, API.DataQueryGetPaymentsPost.Output];
        [API.DataQueryLocationClientsPost.url]: [
            API.DataQueryLocationClientsPost.Input,
            API.DataQueryLocationClientsPost.Output,
        ];
        [API.DataQueryLocationMunuOrdersPost.url]: [
            API.DataQueryLocationMunuOrdersPost.Input,
            API.DataQueryLocationMunuOrdersPost.Output,
        ];
        [API.DataQueryLocationSettlementHistoryPost.url]: [
            API.DataQueryLocationSettlementHistoryPost.Input,
            API.DataQueryLocationSettlementHistoryPost.Output,
        ];
        [API.DataQueryPosHistoryGetOrdersPost.url]: [
            API.DataQueryPosHistoryGetOrdersPost.Input,
            API.DataQueryPosHistoryGetOrdersPost.Output,
        ];
        [API.DataQueryPosHistoryGetPaymentsPost.url]: [
            API.DataQueryPosHistoryGetPaymentsPost.Input,
            API.DataQueryPosHistoryGetPaymentsPost.Output,
        ];
        [API.DataQueryStarPrinterPost.url]: [API.DataQueryStarPrinterPost.Input, API.DataQueryStarPrinterPost.Output];
        [API.DataQuerySuperAdminGetTerminalsPost.url]: [
            API.DataQuerySuperAdminGetTerminalsPost.Input,
            API.DataQuerySuperAdminGetTerminalsPost.Output,
        ];
        [API.DevAdyenGet.url]: [API.DevAdyenGet.Input, API.DevAdyenGet.Output];
        [API.DevAssertConfigGet.url]: [API.DevAssertConfigGet.Input, API.DevAssertConfigGet.Output];
        [API.DevErrorGet.url]: [API.DevErrorGet.Input, API.DevErrorGet.Output];
        [API.DevImportVenueGet.url]: [API.DevImportVenueGet.Input, API.DevImportVenueGet.Output];
        [API.DevPayoutsGet.url]: [API.DevPayoutsGet.Input, API.DevPayoutsGet.Output];
        [API.DevPingGet.url]: [API.DevPingGet.Input, API.DevPingGet.Output];
        [API.DevPowerOfficeGet.url]: [API.DevPowerOfficeGet.Input, API.DevPowerOfficeGet.Output];
        [API.DevSyncOpGet.url]: [API.DevSyncOpGet.Input, API.DevSyncOpGet.Output];
        [API.DevTerminalGet.url]: [API.DevTerminalGet.Input, API.DevTerminalGet.Output];
        [API.DevTestGet.url]: [API.DevTestGet.Input, API.DevTestGet.Output];
        [API.DevTripletexDelGet.url]: [API.DevTripletexDelGet.Input, API.DevTripletexDelGet.Output];
        [API.DevTripletexGetGet.url]: [API.DevTripletexGetGet.Input, API.DevTripletexGetGet.Output];
        [API.DevTripletexNewGet.url]: [API.DevTripletexNewGet.Input, API.DevTripletexNewGet.Output];
        [API.DiscountGetDetailsPost.url]: [API.DiscountGetDetailsPost.Input, API.DiscountGetDetailsPost.Output];
        [API.EJournalSettlementGet.url]: [API.EJournalSettlementGet.Input, API.EJournalSettlementGet.Output];
        [API.EntityCompanyPost.url]: [API.EntityCompanyPost.Input, API.EntityCompanyPost.Output];
        [API.EntityLocationInventoryPost.url]: [
            API.EntityLocationInventoryPost.Input,
            API.EntityLocationInventoryPost.Output,
        ];
        [API.EntityLocationPost.url]: [API.EntityLocationPost.Input, API.EntityLocationPost.Output];
        [API.InternalAbortTerminalPaymentPost.url]: [
            API.InternalAbortTerminalPaymentPost.Input,
            API.InternalAbortTerminalPaymentPost.Output,
        ];
        [API.InternalSendOrderToTerminalPost.url]: [
            API.InternalSendOrderToTerminalPost.Input,
            API.InternalSendOrderToTerminalPost.Output,
        ];
        [API.InventoryActionHistoryPost.url]: [
            API.InventoryActionHistoryPost.Input,
            API.InventoryActionHistoryPost.Output,
        ];
        [API.InventoryCountingReportSummaryConfirmPost.url]: [
            API.InventoryCountingReportSummaryConfirmPost.Input,
            API.InventoryCountingReportSummaryConfirmPost.Output,
        ];
        [API.InventoryCountingReportSummaryPost.url]: [
            API.InventoryCountingReportSummaryPost.Input,
            API.InventoryCountingReportSummaryPost.Output,
        ];
        [API.InventoryCountingReportPost.url]: [
            API.InventoryCountingReportPost.Input,
            API.InventoryCountingReportPost.Output,
        ];
        [API.InventoryCountingReportConfirmPost.url]: [
            API.InventoryCountingReportConfirmPost.Input,
            API.InventoryCountingReportConfirmPost.Output,
        ];
        [API.InventoryCountingReportPreparePost.url]: [
            API.InventoryCountingReportPreparePost.Input,
            API.InventoryCountingReportPreparePost.Output,
        ];
        [API.InventoryDownloadReportPost.url]: [
            API.InventoryDownloadReportPost.Input,
            API.InventoryDownloadReportPost.Output,
        ];
        [API.InventoryMenuProductPost.url]: [API.InventoryMenuProductPost.Input, API.InventoryMenuProductPost.Output];
        [API.InventoryMoveInventoryConfirmPost.url]: [
            API.InventoryMoveInventoryConfirmPost.Input,
            API.InventoryMoveInventoryConfirmPost.Output,
        ];
        [API.InventoryMoveInventoryDataPost.url]: [
            API.InventoryMoveInventoryDataPost.Input,
            API.InventoryMoveInventoryDataPost.Output,
        ];
        [API.InventoryProcessActionsGet.url]: [
            API.InventoryProcessActionsGet.Input,
            API.InventoryProcessActionsGet.Output,
        ];
        [API.InventoryPurchaseOrderVendorGet.url]: [
            API.InventoryPurchaseOrderVendorGet.Input,
            API.InventoryPurchaseOrderVendorGet.Output,
        ];
        [API.InventoryPurchaseOrderPost.url]: [
            API.InventoryPurchaseOrderPost.Input,
            API.InventoryPurchaseOrderPost.Output,
        ];
        [API.InventoryPurchaseOrderCreatePost.url]: [
            API.InventoryPurchaseOrderCreatePost.Input,
            API.InventoryPurchaseOrderCreatePost.Output,
        ];
        [API.InventoryPurchaseOrderPreparePost.url]: [
            API.InventoryPurchaseOrderPreparePost.Input,
            API.InventoryPurchaseOrderPreparePost.Output,
        ];
        [API.InventoryRecipeProductPost.url]: [
            API.InventoryRecipeProductPost.Input,
            API.InventoryRecipeProductPost.Output,
        ];
        [API.IotPublishPost.url]: [API.IotPublishPost.Input, API.IotPublishPost.Output];
        [API.LandingContactPost.url]: [API.LandingContactPost.Input, API.LandingContactPost.Output];
        [API.LandingGetDocumentPost.url]: [API.LandingGetDocumentPost.Input, API.LandingGetDocumentPost.Output];
        [API.LandingGetMerchantTermsPost.url]: [
            API.LandingGetMerchantTermsPost.Input,
            API.LandingGetMerchantTermsPost.Output,
        ];
        [API.LegacyBrowseGet.url]: [API.LegacyBrowseGet.Input, API.LegacyBrowseGet.Output];
        [API.LegacyTagTagIdGet.url]: [API.LegacyTagTagIdGet.Input, API.LegacyTagTagIdGet.Output];
        [API.LocationLocationIdProductCategoryGet.url]: [
            API.LocationLocationIdProductCategoryGet.Input,
            API.LocationLocationIdProductCategoryGet.Output,
        ];
        [API.LocationLocationIdStaffPost.url]: [
            API.LocationLocationIdStaffPost.Input,
            API.LocationLocationIdStaffPost.Output,
        ];
        [API.LocationConfigGetPost.url]: [API.LocationConfigGetPost.Input, API.LocationConfigGetPost.Output];
        [API.LocationConfigUpdatePost.url]: [API.LocationConfigUpdatePost.Input, API.LocationConfigUpdatePost.Output];
        [API.LocationCourseCreatePost.url]: [API.LocationCourseCreatePost.Input, API.LocationCourseCreatePost.Output];
        [API.LocationCreateStorePost.url]: [API.LocationCreateStorePost.Input, API.LocationCreateStorePost.Output];
        [API.LocationUpdateMiniInventoryPost.url]: [
            API.LocationUpdateMiniInventoryPost.Input,
            API.LocationUpdateMiniInventoryPost.Output,
        ];
        [API.LocationsLocationIdAnalyticsSalesPost.url]: [
            API.LocationsLocationIdAnalyticsSalesPost.Input,
            API.LocationsLocationIdAnalyticsSalesPost.Output,
        ];
        [API.LocationsLocationIdStaffRolesDelete.url]: [
            API.LocationsLocationIdStaffRolesDelete.Input,
            API.LocationsLocationIdStaffRolesDelete.Output,
        ];
        [API.LocationsLocationIdStaffGet.url]: [
            API.LocationsLocationIdStaffGet.Input,
            API.LocationsLocationIdStaffGet.Output,
        ];
        [API.LocationsLocationIdStaffPost.url]: [
            API.LocationsLocationIdStaffPost.Input,
            API.LocationsLocationIdStaffPost.Output,
        ];
        [API.MeGet.url]: [API.MeGet.Input, API.MeGet.Output];
        [API.MeClaimPaymentPost.url]: [API.MeClaimPaymentPost.Input, API.MeClaimPaymentPost.Output];
        [API.MeCompanyPost.url]: [API.MeCompanyPost.Input, API.MeCompanyPost.Output];
        [API.MeDiscountPost.url]: [API.MeDiscountPost.Input, API.MeDiscountPost.Output];
        [API.MeDownloadReceiptPost.url]: [API.MeDownloadReceiptPost.Input, API.MeDownloadReceiptPost.Output];
        [API.MeGetOrderHistoryPost.url]: [API.MeGetOrderHistoryPost.Input, API.MeGetOrderHistoryPost.Output];
        [API.MeGetPaymentPost.url]: [API.MeGetPaymentPost.Input, API.MeGetPaymentPost.Output];
        [API.MeGetPaymentHistoryPost.url]: [API.MeGetPaymentHistoryPost.Input, API.MeGetPaymentHistoryPost.Output];
        [API.MeGetReceiptPost.url]: [API.MeGetReceiptPost.Input, API.MeGetReceiptPost.Output];
        [API.MeIotGet.url]: [API.MeIotGet.Input, API.MeIotGet.Output];
        [API.MeLocationsPost.url]: [API.MeLocationsPost.Input, API.MeLocationsPost.Output];
        [API.MeLocationsLocationIdGet.url]: [API.MeLocationsLocationIdGet.Input, API.MeLocationsLocationIdGet.Output];
        [API.MeOrderHistoryPost.url]: [API.MeOrderHistoryPost.Input, API.MeOrderHistoryPost.Output];
        [API.MeOrderUpdatePost.url]: [API.MeOrderUpdatePost.Input, API.MeOrderUpdatePost.Output];
        [API.MeOrderPost.url]: [API.MeOrderPost.Input, API.MeOrderPost.Output];
        [API.MePasswordChangePost.url]: [API.MePasswordChangePost.Input, API.MePasswordChangePost.Output];
        [API.MePayPost.url]: [API.MePayPost.Input, API.MePayPost.Output];
        [API.MenuProductAddToMenuPost.url]: [API.MenuProductAddToMenuPost.Input, API.MenuProductAddToMenuPost.Output];
        [API.MenuProductRemoveFromMenuPost.url]: [
            API.MenuProductRemoveFromMenuPost.Input,
            API.MenuProductRemoveFromMenuPost.Output,
        ];
        [API.MenuProductUpdatePost.url]: [API.MenuProductUpdatePost.Input, API.MenuProductUpdatePost.Output];
        [API.MetaPost.url]: [API.MetaPost.Input, API.MetaPost.Output];
        [API.OnboardingRegisterPost.url]: [API.OnboardingRegisterPost.Input, API.OnboardingRegisterPost.Output];
        [API.OrderProductChangeRequestStatusPost.url]: [
            API.OrderProductChangeRequestStatusPost.Input,
            API.OrderProductChangeRequestStatusPost.Output,
        ];
        [API.OrderProductCreatePaymentPost.url]: [
            API.OrderProductCreatePaymentPost.Input,
            API.OrderProductCreatePaymentPost.Output,
        ];
        [API.OrderOrderIdGet.url]: [API.OrderOrderIdGet.Input, API.OrderOrderIdGet.Output];
        [API.OrderOrderIdReceiptGet.url]: [API.OrderOrderIdReceiptGet.Input, API.OrderOrderIdReceiptGet.Output];
        [API.OrderCancelPost.url]: [API.OrderCancelPost.Input, API.OrderCancelPost.Output];
        [API.OutletMenuCrudPost.url]: [API.OutletMenuCrudPost.Input, API.OutletMenuCrudPost.Output];
        [API.OutletPost.url]: [API.OutletPost.Input, API.OutletPost.Output];
        [API.OutletGetActiveMenuPost.url]: [API.OutletGetActiveMenuPost.Input, API.OutletGetActiveMenuPost.Output];
        [API.OutletMenuChangeDeletePost.url]: [
            API.OutletMenuChangeDeletePost.Input,
            API.OutletMenuChangeDeletePost.Output,
        ];
        [API.OutletMenuChangeGetPost.url]: [API.OutletMenuChangeGetPost.Input, API.OutletMenuChangeGetPost.Output];
        [API.OutletMenuChangeUpdatePost.url]: [
            API.OutletMenuChangeUpdatePost.Input,
            API.OutletMenuChangeUpdatePost.Output,
        ];
        [API.OutletOpenTimeGetPost.url]: [API.OutletOpenTimeGetPost.Input, API.OutletOpenTimeGetPost.Output];
        [API.OutletOpenTimeUpdatePost.url]: [API.OutletOpenTimeUpdatePost.Input, API.OutletOpenTimeUpdatePost.Output];
        [API.PaymentPaymentIdReceiptGet.url]: [
            API.PaymentPaymentIdReceiptGet.Input,
            API.PaymentPaymentIdReceiptGet.Output,
        ];
        [API.PaymentBamboraProviderOrderIdGet.url]: [
            API.PaymentBamboraProviderOrderIdGet.Input,
            API.PaymentBamboraProviderOrderIdGet.Output,
        ];
        [API.PaymentDownloadReceiptPost.url]: [
            API.PaymentDownloadReceiptPost.Input,
            API.PaymentDownloadReceiptPost.Output,
        ];
        [API.PaymentFindPost.url]: [API.PaymentFindPost.Input, API.PaymentFindPost.Output];
        [API.PaymentGetPaymentPost.url]: [API.PaymentGetPaymentPost.Input, API.PaymentGetPaymentPost.Output];
        [API.PaymentGetReceiptPost.url]: [API.PaymentGetReceiptPost.Input, API.PaymentGetReceiptPost.Output];
        [API.PaymentPrintReceiptPost.url]: [API.PaymentPrintReceiptPost.Input, API.PaymentPrintReceiptPost.Output];
        [API.PaymentProviderStatsPost.url]: [API.PaymentProviderStatsPost.Input, API.PaymentProviderStatsPost.Output];
        [API.PayoutConfirmPayoutPost.url]: [API.PayoutConfirmPayoutPost.Input, API.PayoutConfirmPayoutPost.Output];
        [API.PayoutDownloadReportPost.url]: [API.PayoutDownloadReportPost.Input, API.PayoutDownloadReportPost.Output];
        [API.PayoutGetActivePayoutPost.url]: [
            API.PayoutGetActivePayoutPost.Input,
            API.PayoutGetActivePayoutPost.Output,
        ];
        [API.PayoutGetDetailsPost.url]: [API.PayoutGetDetailsPost.Input, API.PayoutGetDetailsPost.Output];
        [API.PayoutGetHistoryPost.url]: [API.PayoutGetHistoryPost.Input, API.PayoutGetHistoryPost.Output];
        [API.PayoutGetReportPost.url]: [API.PayoutGetReportPost.Input, API.PayoutGetReportPost.Output];
        [API.PluginAutoPayPreparePost.url]: [API.PluginAutoPayPreparePost.Input, API.PluginAutoPayPreparePost.Output];
        [API.PosBootstrapPost.url]: [API.PosBootstrapPost.Input, API.PosBootstrapPost.Output];
        [API.PosClientGetLocationClientsPost.url]: [
            API.PosClientGetLocationClientsPost.Input,
            API.PosClientGetLocationClientsPost.Output,
        ];
        [API.PosDeliveryHistoryPost.url]: [API.PosDeliveryHistoryPost.Input, API.PosDeliveryHistoryPost.Output];
        [API.PosDeliveryOrdersPost.url]: [API.PosDeliveryOrdersPost.Input, API.PosDeliveryOrdersPost.Output];
        [API.PosDeliveryPreparePost.url]: [API.PosDeliveryPreparePost.Input, API.PosDeliveryPreparePost.Output];
        [API.PosDeviceRegisterPost.url]: [API.PosDeviceRegisterPost.Input, API.PosDeviceRegisterPost.Output];
        [API.PosLoadCreateDetailsPost.url]: [API.PosLoadCreateDetailsPost.Input, API.PosLoadCreateDetailsPost.Output];
        [API.PosLocationBootstrapPost.url]: [API.PosLocationBootstrapPost.Input, API.PosLocationBootstrapPost.Output];
        [API.PosOrderCreatePost.url]: [API.PosOrderCreatePost.Input, API.PosOrderCreatePost.Output];
        [API.PosOrderHistoryPost.url]: [API.PosOrderHistoryPost.Input, API.PosOrderHistoryPost.Output];
        [API.PosOrderProductChangeDiscountPost.url]: [
            API.PosOrderProductChangeDiscountPost.Input,
            API.PosOrderProductChangeDiscountPost.Output,
        ];
        [API.PosOrderProductHandlePrint.url]: [
            API.PosOrderProductHandlePrint.Input,
            API.PosOrderProductHandlePrint.Output,
        ];
        [API.PosOrderProductUpdateStatusPost.url]: [
            API.PosOrderProductUpdateStatusPost.Input,
            API.PosOrderProductUpdateStatusPost.Output,
        ];
        [API.PosOutletConfigPost.url]: [API.PosOutletConfigPost.Input, API.PosOutletConfigPost.Output];
        [API.PosOutletGetZonesPost.url]: [API.PosOutletGetZonesPost.Input, API.PosOutletGetZonesPost.Output];
        [API.PosOutletProductPost.url]: [API.PosOutletProductPost.Input, API.PosOutletProductPost.Output];
        [API.PosOutletViewPost.url]: [API.PosOutletViewPost.Input, API.PosOutletViewPost.Output];
        [API.PosPaymentGetDetailsPost.url]: [API.PosPaymentGetDetailsPost.Input, API.PosPaymentGetDetailsPost.Output];
        [API.PosPaymentGetHistoryPost.url]: [API.PosPaymentGetHistoryPost.Input, API.PosPaymentGetHistoryPost.Output];
        [API.PosPaymentRequestPhoneForReceiptPost.url]: [
            API.PosPaymentRequestPhoneForReceiptPost.Input,
            API.PosPaymentRequestPhoneForReceiptPost.Output,
        ];
        [API.PosPaymentShowQrPost.url]: [API.PosPaymentShowQrPost.Input, API.PosPaymentShowQrPost.Output];
        [API.PosPlaceOrderPost.url]: [API.PosPlaceOrderPost.Input, API.PosPlaceOrderPost.Output];
        [API.PosStationBootstrapCourseViewPost.url]: [
            API.PosStationBootstrapCourseViewPost.Input,
            API.PosStationBootstrapCourseViewPost.Output,
        ];
        [API.PosStationFindOrderPost.url]: [API.PosStationFindOrderPost.Input, API.PosStationFindOrderPost.Output];
        [API.PosStationGetPrintersPost.url]: [
            API.PosStationGetPrintersPost.Input,
            API.PosStationGetPrintersPost.Output,
        ];
        [API.PosStationOrderCountPost.url]: [API.PosStationOrderCountPost.Input, API.PosStationOrderCountPost.Output];
        [API.PosStationViewPost.url]: [API.PosStationViewPost.Input, API.PosStationViewPost.Output];
        [API.PosUpdateZonesPost.url]: [API.PosUpdateZonesPost.Input, API.PosUpdateZonesPost.Output];
        [API.PosZoneClearPost.url]: [API.PosZoneClearPost.Input, API.PosZoneClearPost.Output];
        [API.PosZoneCreateTerminalPaymentPost.url]: [
            API.PosZoneCreateTerminalPaymentPost.Input,
            API.PosZoneCreateTerminalPaymentPost.Output,
        ];
        [API.PosZoneMoveZoneDataPost.url]: [API.PosZoneMoveZoneDataPost.Input, API.PosZoneMoveZoneDataPost.Output];
        [API.PosZoneMoveZonePost.url]: [API.PosZoneMoveZonePost.Input, API.PosZoneMoveZonePost.Output];
        [API.PosZoneProductMarkAsPaidPost.url]: [
            API.PosZoneProductMarkAsPaidPost.Input,
            API.PosZoneProductMarkAsPaidPost.Output,
        ];
        [API.PosZoneViewPost.url]: [API.PosZoneViewPost.Input, API.PosZoneViewPost.Output];
        [API.PosOperatorAuthenticatePost.url]: [
            API.PosOperatorAuthenticatePost.Input,
            API.PosOperatorAuthenticatePost.Output,
        ];
        [API.PosOperatorGetPost.url]: [API.PosOperatorGetPost.Input, API.PosOperatorGetPost.Output];
        [API.PosOperatorManagePost.url]: [API.PosOperatorManagePost.Input, API.PosOperatorManagePost.Output];
        [API.PosOperatorRoleGroupManagePost.url]: [
            API.PosOperatorRoleGroupManagePost.Input,
            API.PosOperatorRoleGroupManagePost.Output,
        ];
        [API.ProductPost.url]: [API.ProductPost.Input, API.ProductPost.Output];
        [API.ProductAdminGetPost.url]: [API.ProductAdminGetPost.Input, API.ProductAdminGetPost.Output];
        [API.ProductBatchUpdatePost.url]: [API.ProductBatchUpdatePost.Input, API.ProductBatchUpdatePost.Output];
        [API.ProductGetAllProductsPost.url]: [
            API.ProductGetAllProductsPost.Input,
            API.ProductGetAllProductsPost.Output,
        ];
        [API.ProductGetBatchUpdateDataPost.url]: [
            API.ProductGetBatchUpdateDataPost.Input,
            API.ProductGetBatchUpdateDataPost.Output,
        ];
        [API.ProductImportPost.url]: [API.ProductImportPost.Input, API.ProductImportPost.Output];
        [API.ProductUpdatePost.url]: [API.ProductUpdatePost.Input, API.ProductUpdatePost.Output];
        [API.ProductUpdateProductsPost.url]: [
            API.ProductUpdateProductsPost.Input,
            API.ProductUpdateProductsPost.Output,
        ];
        [API.ProviderAdyenCheckoutCreatePaymentPost.url]: [
            API.ProviderAdyenCheckoutCreatePaymentPost.Input,
            API.ProviderAdyenCheckoutCreatePaymentPost.Output,
        ];
        [API.ProviderAdyenCheckoutGetAdditionalDetailsPost.url]: [
            API.ProviderAdyenCheckoutGetAdditionalDetailsPost.Input,
            API.ProviderAdyenCheckoutGetAdditionalDetailsPost.Output,
        ];
        [API.ProviderAdyenCheckoutHandleRedirectResultPost.url]: [
            API.ProviderAdyenCheckoutHandleRedirectResultPost.Input,
            API.ProviderAdyenCheckoutHandleRedirectResultPost.Output,
        ];
        [API.ProviderAdyenGetCompanyOverviewPost.url]: [
            API.ProviderAdyenGetCompanyOverviewPost.Input,
            API.ProviderAdyenGetCompanyOverviewPost.Output,
        ];
        [API.ProviderAdyenGetPaymentDetailsPost.url]: [
            API.ProviderAdyenGetPaymentDetailsPost.Input,
            API.ProviderAdyenGetPaymentDetailsPost.Output,
        ];
        [API.ProviderAdyenGetPaymentsPost.url]: [
            API.ProviderAdyenGetPaymentsPost.Input,
            API.ProviderAdyenGetPaymentsPost.Output,
        ];
        [API.ProviderAdyenPayoutsGetCompanyPayoutDetailsPost.url]: [
            API.ProviderAdyenPayoutsGetCompanyPayoutDetailsPost.Input,
            API.ProviderAdyenPayoutsGetCompanyPayoutDetailsPost.Output,
        ];
        [API.ProviderAdyenPayoutsGetPayoutHistoryPost.url]: [
            API.ProviderAdyenPayoutsGetPayoutHistoryPost.Input,
            API.ProviderAdyenPayoutsGetPayoutHistoryPost.Output,
        ];
        [API.ProviderAdyenWebhooksHandleNotificationWebhookTypePost.url]: [
            API.ProviderAdyenWebhooksHandleNotificationWebhookTypePost.Input,
            API.ProviderAdyenWebhooksHandleNotificationWebhookTypePost.Output,
        ];
        [API.ProviderAdyenWebhooksHandlePlatformNotificationPost.url]: [
            API.ProviderAdyenWebhooksHandlePlatformNotificationPost.Input,
            API.ProviderAdyenWebhooksHandlePlatformNotificationPost.Output,
        ];
        [API.ProviderAdyenWebhooksHandleTerminalEventPost.url]: [
            API.ProviderAdyenWebhooksHandleTerminalEventPost.Input,
            API.ProviderAdyenWebhooksHandleTerminalEventPost.Output,
        ];
        [API.ProviderAdyenWebhooksHandleTerminalNotificationPost.url]: [
            API.ProviderAdyenWebhooksHandleTerminalNotificationPost.Input,
            API.ProviderAdyenWebhooksHandleTerminalNotificationPost.Output,
        ];
        [API.ProviderKdrSyncPreparePost.url]: [
            API.ProviderKdrSyncPreparePost.Input,
            API.ProviderKdrSyncPreparePost.Output,
        ];
        [API.ProviderKdrSyncUpdateConfigPost.url]: [
            API.ProviderKdrSyncUpdateConfigPost.Input,
            API.ProviderKdrSyncUpdateConfigPost.Output,
        ];
        [API.ProviderMunuGetOrdersPost.url]: [
            API.ProviderMunuGetOrdersPost.Input,
            API.ProviderMunuGetOrdersPost.Output,
        ];
        [API.ProviderMunuSyncPreparePost.url]: [
            API.ProviderMunuSyncPreparePost.Input,
            API.ProviderMunuSyncPreparePost.Output,
        ];
        [API.ProviderMunuSyncSyncArticlesPost.url]: [
            API.ProviderMunuSyncSyncArticlesPost.Input,
            API.ProviderMunuSyncSyncArticlesPost.Output,
        ];
        [API.ProviderMunuTestConnectionPost.url]: [
            API.ProviderMunuTestConnectionPost.Input,
            API.ProviderMunuTestConnectionPost.Output,
        ];
        [API.ProviderPaymentBamboraCallbackGet.url]: [
            API.ProviderPaymentBamboraCallbackGet.Input,
            API.ProviderPaymentBamboraCallbackGet.Output,
        ];
        [API.ProviderPaymentBamboraPreparePost.url]: [
            API.ProviderPaymentBamboraPreparePost.Input,
            API.ProviderPaymentBamboraPreparePost.Output,
        ];
        [API.ProviderPaymentDevelopmentPaymentPost.url]: [
            API.ProviderPaymentDevelopmentPaymentPost.Input,
            API.ProviderPaymentDevelopmentPaymentPost.Output,
        ];
        [API.ProviderPaymentVippsPreparePost.url]: [
            API.ProviderPaymentVippsPreparePost.Input,
            API.ProviderPaymentVippsPreparePost.Output,
        ];
        [API.ProviderPaymentVippsV2ConsentsUserIdDelete.url]: [
            API.ProviderPaymentVippsV2ConsentsUserIdDelete.Input,
            API.ProviderPaymentVippsV2ConsentsUserIdDelete.Output,
        ];
        [API.ProviderPaymentVippsV2PaymentsProviderOrderIdPost.url]: [
            API.ProviderPaymentVippsV2PaymentsProviderOrderIdPost.Input,
            API.ProviderPaymentVippsV2PaymentsProviderOrderIdPost.Output,
        ];
        [API.ProviderPaymentVippsV2PaymentsProviderOrderIdShippingDetailsPost.url]: [
            API.ProviderPaymentVippsV2PaymentsProviderOrderIdShippingDetailsPost.Input,
            API.ProviderPaymentVippsV2PaymentsProviderOrderIdShippingDetailsPost.Output,
        ];
        [API.ProviderPosKdrMenuGet.url]: [API.ProviderPosKdrMenuGet.Input, API.ProviderPosKdrMenuGet.Output];
        [API.ProviderPosKdrMerchantsMerchantIdVouchersVoucherIdCapturePost.url]: [
            API.ProviderPosKdrMerchantsMerchantIdVouchersVoucherIdCapturePost.Input,
            API.ProviderPosKdrMerchantsMerchantIdVouchersVoucherIdCapturePost.Output,
        ];
        [API.ProviderPosKdrOrderGet.url]: [API.ProviderPosKdrOrderGet.Input, API.ProviderPosKdrOrderGet.Output];
        [API.ProviderPosKdrPreparePost.url]: [
            API.ProviderPosKdrPreparePost.Input,
            API.ProviderPosKdrPreparePost.Output,
        ];
        [API.ProviderPosKdrSyncPost.url]: [API.ProviderPosKdrSyncPost.Input, API.ProviderPosKdrSyncPost.Output];
        [API.ProviderVismaTestConnectionPost.url]: [
            API.ProviderVismaTestConnectionPost.Input,
            API.ProviderVismaTestConnectionPost.Output,
        ];
        [API.PublicBrowseFeedGet.url]: [API.PublicBrowseFeedGet.Input, API.PublicBrowseFeedGet.Output];
        [API.PublicBrowsePost.url]: [API.PublicBrowsePost.Input, API.PublicBrowsePost.Output];
        [API.PublicCovidRegisterPost.url]: [API.PublicCovidRegisterPost.Input, API.PublicCovidRegisterPost.Output];
        [API.PublicLocationLocationIdGet.url]: [
            API.PublicLocationLocationIdGet.Input,
            API.PublicLocationLocationIdGet.Output,
        ];
        [API.PublicOutletOutletIdGet.url]: [API.PublicOutletOutletIdGet.Input, API.PublicOutletOutletIdGet.Output];
        [API.PublicTagIdGet.url]: [API.PublicTagIdGet.Input, API.PublicTagIdGet.Output];
        [API.PublicZonePost.url]: [API.PublicZonePost.Input, API.PublicZonePost.Output];
        [API.QueryPost.url]: [API.QueryPost.Input, API.QueryPost.Output];
        [API.ReportingGetLocationOverviewGet.url]: [
            API.ReportingGetLocationOverviewGet.Input,
            API.ReportingGetLocationOverviewGet.Output,
        ];
        [API.ReportingGetSalesPost.url]: [API.ReportingGetSalesPost.Input, API.ReportingGetSalesPost.Output];
        [API.SettlementGetReportPost.url]: [API.SettlementGetReportPost.Input, API.SettlementGetReportPost.Output];
        [API.SettlementUpdatePost.url]: [API.SettlementUpdatePost.Input, API.SettlementUpdatePost.Output];
        [API.SpcPublicBootstrapPost.url]: [API.SpcPublicBootstrapPost.Input, API.SpcPublicBootstrapPost.Output];
        [API.SpcPublicCheckoutPost.url]: [API.SpcPublicCheckoutPost.Input, API.SpcPublicCheckoutPost.Output];
        [API.SpcPublicConnectPost.url]: [API.SpcPublicConnectPost.Input, API.SpcPublicConnectPost.Output];
        [API.StatsGet.url]: [API.StatsGet.Input, API.StatsGet.Output];
        [API.SuperAdminAdyenAccountHolderPost.url]: [
            API.SuperAdminAdyenAccountHolderPost.Input,
            API.SuperAdminAdyenAccountHolderPost.Output,
        ];
        [API.SuperAdminAdyenAccountHolderCodePost.url]: [
            API.SuperAdminAdyenAccountHolderCodePost.Input,
            API.SuperAdminAdyenAccountHolderCodePost.Output,
        ];
        [API.SuperAdminAdyenAssignTerminalsPost.url]: [
            API.SuperAdminAdyenAssignTerminalsPost.Input,
            API.SuperAdminAdyenAssignTerminalsPost.Output,
        ];
        [API.SuperAdminAdyenCreateAccountHolderPost.url]: [
            API.SuperAdminAdyenCreateAccountHolderPost.Input,
            API.SuperAdminAdyenCreateAccountHolderPost.Output,
        ];
        [API.SuperAdminAdyenLoadTerminalLogsPost.url]: [
            API.SuperAdminAdyenLoadTerminalLogsPost.Input,
            API.SuperAdminAdyenLoadTerminalLogsPost.Output,
        ];
        [API.SuperAdminAdyenLoadTerminalsPost.url]: [
            API.SuperAdminAdyenLoadTerminalsPost.Input,
            API.SuperAdminAdyenLoadTerminalsPost.Output,
        ];
        [API.SuperAdminDataQueryGetPaymentsPost.url]: [
            API.SuperAdminDataQueryGetPaymentsPost.Input,
            API.SuperAdminDataQueryGetPaymentsPost.Output,
        ];
        [API.SuperAdminDataQueryGetSystemNotificationsPost.url]: [
            API.SuperAdminDataQueryGetSystemNotificationsPost.Input,
            API.SuperAdminDataQueryGetSystemNotificationsPost.Output,
        ];
        [API.SuperAdminDocumentGetPost.url]: [
            API.SuperAdminDocumentGetPost.Input,
            API.SuperAdminDocumentGetPost.Output,
        ];
        [API.SuperAdminDocumentUpdatePost.url]: [
            API.SuperAdminDocumentUpdatePost.Input,
            API.SuperAdminDocumentUpdatePost.Output,
        ];
        [API.SuperAdminFeatureGetPost.url]: [API.SuperAdminFeatureGetPost.Input, API.SuperAdminFeatureGetPost.Output];
        [API.SuperAdminFeatureTogglePost.url]: [
            API.SuperAdminFeatureTogglePost.Input,
            API.SuperAdminFeatureTogglePost.Output,
        ];
        [API.SuperAdminGetOrderOrPaymentPost.url]: [
            API.SuperAdminGetOrderOrPaymentPost.Input,
            API.SuperAdminGetOrderOrPaymentPost.Output,
        ];
        [API.SuperAdminGetTransactionsDataPost.url]: [
            API.SuperAdminGetTransactionsDataPost.Input,
            API.SuperAdminGetTransactionsDataPost.Output,
        ];
        [API.SuperAdminLegacyLocationGet.url]: [
            API.SuperAdminLegacyLocationGet.Input,
            API.SuperAdminLegacyLocationGet.Output,
        ];
        [API.SuperAdminLocationGetAllLocationsPost.url]: [
            API.SuperAdminLocationGetAllLocationsPost.Input,
            API.SuperAdminLocationGetAllLocationsPost.Output,
        ];
        [API.SuperAdminLocationGetCoursesPost.url]: [
            API.SuperAdminLocationGetCoursesPost.Input,
            API.SuperAdminLocationGetCoursesPost.Output,
        ];
        [API.SuperAdminLocationGetCovidExportLinkPost.url]: [
            API.SuperAdminLocationGetCovidExportLinkPost.Input,
            API.SuperAdminLocationGetCovidExportLinkPost.Output,
        ];
        [API.SuperAdminLocationGetOverviewPost.url]: [
            API.SuperAdminLocationGetOverviewPost.Input,
            API.SuperAdminLocationGetOverviewPost.Output,
        ];
        [API.SuperAdminServiceFeeGetAllPost.url]: [
            API.SuperAdminServiceFeeGetAllPost.Input,
            API.SuperAdminServiceFeeGetAllPost.Output,
        ];
        [API.SuperAdminSettlementAnalyzeSettlementPost.url]: [
            API.SuperAdminSettlementAnalyzeSettlementPost.Input,
            API.SuperAdminSettlementAnalyzeSettlementPost.Output,
        ];
        [API.SuperAdminSettlementGetDataPost.url]: [
            API.SuperAdminSettlementGetDataPost.Input,
            API.SuperAdminSettlementGetDataPost.Output,
        ];
        [API.SuperAdminSettlementSettlePost.url]: [
            API.SuperAdminSettlementSettlePost.Input,
            API.SuperAdminSettlementSettlePost.Output,
        ];
        [API.SuperAdminStarPrinterManagePost.url]: [
            API.SuperAdminStarPrinterManagePost.Input,
            API.SuperAdminStarPrinterManagePost.Output,
        ];
        [API.SuperAdminTerminalChangeCompanyPost.url]: [
            API.SuperAdminTerminalChangeCompanyPost.Input,
            API.SuperAdminTerminalChangeCompanyPost.Output,
        ];
        [API.SuperAdminTerminalGetUpdateFormPost.url]: [
            API.SuperAdminTerminalGetUpdateFormPost.Input,
            API.SuperAdminTerminalGetUpdateFormPost.Output,
        ];
        [API.SuperAdminTerminalUpdateTerminalsPost.url]: [
            API.SuperAdminTerminalUpdateTerminalsPost.Input,
            API.SuperAdminTerminalUpdateTerminalsPost.Output,
        ];
        [API.SuperAdminUserLoginPost.url]: [API.SuperAdminUserLoginPost.Input, API.SuperAdminUserLoginPost.Output];
        [API.SuperAdminUserPost.url]: [API.SuperAdminUserPost.Input, API.SuperAdminUserPost.Output];
        [API.TagIdGet.url]: [API.TagIdGet.Input, API.TagIdGet.Output];
        [API.TagImportPost.url]: [API.TagImportPost.Input, API.TagImportPost.Output];
        [API.TagSearchPost.url]: [API.TagSearchPost.Input, API.TagSearchPost.Output];
        [API.TerminalLoadPaymentHistoryPost.url]: [
            API.TerminalLoadPaymentHistoryPost.Input,
            API.TerminalLoadPaymentHistoryPost.Output,
        ];
        [API.TerminalLoadTerminalEventsPost.url]: [
            API.TerminalLoadTerminalEventsPost.Input,
            API.TerminalLoadTerminalEventsPost.Output,
        ];
        [API.TerminalLoadTerminalsPost.url]: [
            API.TerminalLoadTerminalsPost.Input,
            API.TerminalLoadTerminalsPost.Output,
        ];
        [API.TerminalPresetAddTerminalsPost.url]: [
            API.TerminalPresetAddTerminalsPost.Input,
            API.TerminalPresetAddTerminalsPost.Output,
        ];
        [API.TerminalPresetCreatePost.url]: [API.TerminalPresetCreatePost.Input, API.TerminalPresetCreatePost.Output];
        [API.TerminalPresetDeletePost.url]: [API.TerminalPresetDeletePost.Input, API.TerminalPresetDeletePost.Output];
        [API.TerminalPresetDeleteTerminalsPost.url]: [
            API.TerminalPresetDeleteTerminalsPost.Input,
            API.TerminalPresetDeleteTerminalsPost.Output,
        ];
        [API.TerminalPresetGetLocationsPresetsPost.url]: [
            API.TerminalPresetGetLocationsPresetsPost.Input,
            API.TerminalPresetGetLocationsPresetsPost.Output,
        ];
        [API.TerminalPresetUpdatePost.url]: [API.TerminalPresetUpdatePost.Input, API.TerminalPresetUpdatePost.Output];
        [API.TerminalPresetUpdatePositionPost.url]: [
            API.TerminalPresetUpdatePositionPost.Input,
            API.TerminalPresetUpdatePositionPost.Output,
        ];
        [API.TerminalRetryPaymentPost.url]: [API.TerminalRetryPaymentPost.Input, API.TerminalRetryPaymentPost.Output];
        [API.TerminalSendTestAmountPost.url]: [
            API.TerminalSendTestAmountPost.Input,
            API.TerminalSendTestAmountPost.Output,
        ];
        [API.TerminalSyncAdyenPost.url]: [API.TerminalSyncAdyenPost.Input, API.TerminalSyncAdyenPost.Output];
        [API.V2AdminLocationGetOverviewPost.url]: [
            API.V2AdminLocationGetOverviewPost.Input,
            API.V2AdminLocationGetOverviewPost.Output,
        ];
        [API.V2AdminMenuProductRemovePost.url]: [
            API.V2AdminMenuProductRemovePost.Input,
            API.V2AdminMenuProductRemovePost.Output,
        ];
        [API.V2AdminProductGetProductAccountsPost.url]: [
            API.V2AdminProductGetProductAccountsPost.Input,
            API.V2AdminProductGetProductAccountsPost.Output,
        ];
        [API.V2AdminProductManageProductAccountPost.url]: [
            API.V2AdminProductManageProductAccountPost.Input,
            API.V2AdminProductManageProductAccountPost.Output,
        ];
        [API.V2AdminReportingPeriodOverPeriodDownloadPost.url]: [
            API.V2AdminReportingPeriodOverPeriodDownloadPost.Input,
            API.V2AdminReportingPeriodOverPeriodDownloadPost.Output,
        ];
        [API.V2AdminReportingPeriodOverPeriodGetPost.url]: [
            API.V2AdminReportingPeriodOverPeriodGetPost.Input,
            API.V2AdminReportingPeriodOverPeriodGetPost.Output,
        ];
        [API.V2AdminReportingSalesGetPost.url]: [
            API.V2AdminReportingSalesGetPost.Input,
            API.V2AdminReportingSalesGetPost.Output,
        ];
        [API.V2AdminTerminalGetTerminalsPost.url]: [
            API.V2AdminTerminalGetTerminalsPost.Input,
            API.V2AdminTerminalGetTerminalsPost.Output,
        ];
        [API.V2PaymentMethodCreateOrUpdatePost.url]: [
            API.V2PaymentMethodCreateOrUpdatePost.Input,
            API.V2PaymentMethodCreateOrUpdatePost.Output,
        ];
        [API.V2PaymentMethodGetOverviewPost.url]: [
            API.V2PaymentMethodGetOverviewPost.Input,
            API.V2PaymentMethodGetOverviewPost.Output,
        ];
        [API.V2PaymentMethodGetReportPost.url]: [
            API.V2PaymentMethodGetReportPost.Input,
            API.V2PaymentMethodGetReportPost.Output,
        ];
        [API.V2PosCreatePaymentPost.url]: [API.V2PosCreatePaymentPost.Input, API.V2PosCreatePaymentPost.Output];
        [API.V2PosGetQueueLimiterPost.url]: [API.V2PosGetQueueLimiterPost.Input, API.V2PosGetQueueLimiterPost.Output];
        [API.V2PosModuleAppBootstrapPost.url]: [
            API.V2PosModuleAppBootstrapPost.Input,
            API.V2PosModuleAppBootstrapPost.Output,
        ];
        [API.V2PosModuleDeviceEventGetPost.url]: [
            API.V2PosModuleDeviceEventGetPost.Input,
            API.V2PosModuleDeviceEventGetPost.Output,
        ];
        [API.V2PosModuleDeviceEventRetrievePost.url]: [
            API.V2PosModuleDeviceEventRetrievePost.Input,
            API.V2PosModuleDeviceEventRetrievePost.Output,
        ];
        [API.V2PosModuleDeviceEventSendPost.url]: [
            API.V2PosModuleDeviceEventSendPost.Input,
            API.V2PosModuleDeviceEventSendPost.Output,
        ];
        [API.V2PosModulePosBootstrapPost.url]: [
            API.V2PosModulePosBootstrapPost.Input,
            API.V2PosModulePosBootstrapPost.Output,
        ];
        [API.V2PosModulePosGetOrderByCodePost.url]: [
            API.V2PosModulePosGetOrderByCodePost.Input,
            API.V2PosModulePosGetOrderByCodePost.Output,
        ];
        [API.V2PosModulePosGetOrderHistoryPost.url]: [
            API.V2PosModulePosGetOrderHistoryPost.Input,
            API.V2PosModulePosGetOrderHistoryPost.Output,
        ];
        [API.V2PosModulePosGetOrdersPost.url]: [
            API.V2PosModulePosGetOrdersPost.Input,
            API.V2PosModulePosGetOrdersPost.Output,
        ];
        [API.V2PosModulePosPlaceOrderPost.url]: [
            API.V2PosModulePosPlaceOrderPost.Input,
            API.V2PosModulePosPlaceOrderPost.Output,
        ];
        [API.V2PosModuleZoneGetZoneDataPost.url]: [
            API.V2PosModuleZoneGetZoneDataPost.Input,
            API.V2PosModuleZoneGetZoneDataPost.Output,
        ];
        [API.V2ProviderTripletexGetAccountsPost.url]: [
            API.V2ProviderTripletexGetAccountsPost.Input,
            API.V2ProviderTripletexGetAccountsPost.Output,
        ];
        [API.V2ProviderTripletexMatchLocationAccountsPost.url]: [
            API.V2ProviderTripletexMatchLocationAccountsPost.Input,
            API.V2ProviderTripletexMatchLocationAccountsPost.Output,
        ];
        [API.V2ProviderTripletexSendSettlementPost.url]: [
            API.V2ProviderTripletexSendSettlementPost.Input,
            API.V2ProviderTripletexSendSettlementPost.Output,
        ];
        [API.V2ProviderTripletexSyncAccountsPost.url]: [
            API.V2ProviderTripletexSyncAccountsPost.Input,
            API.V2ProviderTripletexSyncAccountsPost.Output,
        ];
        [API.V2ProviderTripletexTestConnectionPost.url]: [
            API.V2ProviderTripletexTestConnectionPost.Input,
            API.V2ProviderTripletexTestConnectionPost.Output,
        ];
        [API.V2ProviderVismaPreparePost.url]: [
            API.V2ProviderVismaPreparePost.Input,
            API.V2ProviderVismaPreparePost.Output,
        ];
        [API.V2ReportGetPost.url]: [API.V2ReportGetPost.Input, API.V2ReportGetPost.Output];
        [API.V2SettlementCreateReportPost.url]: [
            API.V2SettlementCreateReportPost.Input,
            API.V2SettlementCreateReportPost.Output,
        ];
        [API.V2SpillageCreateReportPost.url]: [
            API.V2SpillageCreateReportPost.Input,
            API.V2SpillageCreateReportPost.Output,
        ];
        [API.V2SpillageGetReportPost.url]: [API.V2SpillageGetReportPost.Input, API.V2SpillageGetReportPost.Output];
        [API.V2SpillageUpdateReportItemPost.url]: [
            API.V2SpillageUpdateReportItemPost.Input,
            API.V2SpillageUpdateReportItemPost.Output,
        ];
        [API.V2SuperGetOverviewPost.url]: [API.V2SuperGetOverviewPost.Input, API.V2SuperGetOverviewPost.Output];
        [API.V2TempCreateOrderPost.url]: [API.V2TempCreateOrderPost.Input, API.V2TempCreateOrderPost.Output];
        [API.V2TempInvalidateTicketPost.url]: [
            API.V2TempInvalidateTicketPost.Input,
            API.V2TempInvalidateTicketPost.Output,
        ];
        [API.XrComponentPost.url]: [API.XrComponentPost.Input, API.XrComponentPost.Output];
        [API.ZonePrintBillPost.url]: [API.ZonePrintBillPost.Input, API.ZonePrintBillPost.Output];
    };

    export async function req<U extends keyof API_IO>(url: U, input: API_IO[U][0], config?): Promise<API_IO[U][1]> {
        const baseURL =
            process.env.NODE_ENV === 'production' || localStorage.getItem('isLive')
                ? 'https://api.orderx.eu'
                : `${window.location.protocol}//${window.location.hostname}:9000`;

        const headers: Record<string, any> = {};
        const token = localStorage.getItem('token')?.replace?.(/"/g, '');

        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }

        let fp = localStorage.getItem('deviceFingerprint');

        if (!fp) {
            try {
                fp = JSON.parse(localStorage.getItem('Device$') || '')?.fingerprint;
            } catch (error) {}
        }

        if (!fp) {
            fp = localStorage.getItem('legacy_v1_fp');
        }

        if (localStorage.getItem('legacy_v1_fp') || fp) {
            headers['device-fingerprint'] = localStorage.getItem('legacy_v1_fp') || fp;
        }

        if (fp) {
            headers['pos-id'] = fp;
        }

        return axios
            .post(url, input, {
                baseURL,
                ...config,
                headers: headers,
            })
            .then((result) => result.data);
    }
}

enum AccountType {
    SALES = 'SALES',
    PURCHASE = 'PURCHASE',
    DISCOUNT = 'DISCOUNT',
    SERVICE_FEE = 'SERVICE_FEE',
    SPILLAGE = 'SPILLAGE',
}
type Account = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    code: string;
    vatPercent: number;
    type: AccountType;
    externalId: string;
    location: Location;
    locationId: number;
    products: Product[];
    purchaseAccountProducts: Product[];
    takeawayAccountProducts: Product[];
    discounts: Discount[];
    productAccounts: ProductAccount[];
};
enum AdyenAccountHolderEnvironment {
    TEST = 'TEST',
    LIVE = 'LIVE',
}
type AdyenAccountHolderPayoutStatus = 'Active' | 'Closed' | 'Inactive' | 'Suspended' | string;
type AdyenAccountHolder = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    code: string;
    status: AdyenAccountHolderPayoutStatus;
    statusReason: string;
    payoutAllowed: boolean;
    payoutNotAllowedReason: string;
    payoutDisabled: boolean;
    payoutDisabledReason: string;
    environment: AdyenAccountHolderEnvironment;
    company: Company;
    companyId: number;
    adyenAccounts: AdyenAccount[];
    balances: AdyenBalance[];
};
type AdyenAccount = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    code: string;
    locations: Location[];
    adyenAccountHolder: AdyenAccountHolder;
    adyenAccountHolderId: number;
};
type AdyenEvent = {
    id: string;
    createdAt: Date;
};
type AdyenNotificationPlatform = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    eventDate: string;
    eventType: string;
    pspReference: string;
    live: boolean;
    accountCode: string;
    merchantAccountCode: string;
    data: any;
};
type AdyenNotificationTerminalEventToNotify =
    | 'BeginMaintenance'
    | 'EndMaintenance'
    | 'Shutdown'
    | 'Initialised'
    | 'OutOfOrder'
    | 'Completed'
    | 'Abort'
    | 'SaleWakeUp'
    | 'SaleAdmin'
    | 'CustomerLanguage'
    | 'KeyPressed'
    | 'SecurityAlarm'
    | 'StopAssistance'
    | 'CardInserted'
    | 'CardRemoved'
    | 'Reject';
type AdyenNotificationTerminal = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    pOIID: string;
    saleID: string;
    deviceID: string;
    serviceID: string;
    messageType: string;
    messageClass: string;
    messageCategory: string;
    protocolVersion: string;
    timeStamp: string;
    eventDetails: string;
    rejectedMessage: string;
    eventToNotify: AdyenNotificationTerminalEventToNotify | string;
    data: any;
    terminal: Terminal;
    terminalId: number;
};
enum AdyenNotificationWebhookType {
    BANK_TRANSFER_PENDING = 'BANK_TRANSFER_PENDING',
    REPORT = 'REPORT',
    STANDARD = 'STANDARD',
    TERMINAL = 'TERMINAL',
}
type AdyenNotification = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    webhookType: AdyenNotificationWebhookType;
    eventCode: string;
    success: boolean;
    reason: string;
    eventDate: string;
    merchantAccountCode: string;
    amount: { currency: string; value: string };
    paymentMethod: string;
    merchantReference: string;
    pspReference: string;
    live: boolean;
    additionalData: any;
    notificationRequestItem: any;
};
type AdyenPayoutStatus =
    | string
    | 'SUCCESS'
    | 'PAYOUT_THIRDPARTY'
    | 'PAYOUT_DECLINE'
    | 'PAYOUT_EXPIRE'
    | 'PAIDOUT_REVERSED';
type AdyenPayoutPayoutParams = {
    accountCode: string;
    accountHolderCode: string;
    description: string;
    amount: number;
    currency: string;
    bankAccountUUID: string;
};
type AdyenPayout = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    merchantReference: string;
    guid: string;
    amount: number;
    currency: string;
    accountCode: string;
    accountHolderCode: string;
    bankAccountIban: string;
    bankAccountUuid: string;
    status: AdyenPayoutStatus;
    statusReason: string;
    payoutParams: AdyenPayoutPayoutParams;
    payoutAccountHolderResponse: any;
    notificationCallbacks: any[];
    company: Company;
    companyId: number;
    location: Location;
    locationId: number;
    payments: Payment[];
    settlements: Settlement[];
    zReport: ZReport;
};
type AdyenStore = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    merchantAccount: string;
    merchantCategoryCode: string;
    storeReference: string;
    store?: string;
    storeName?: string;
    fullPhoneNumber?: string;
    phoneAreaCode?: string;
    phone?: string;
    addressCountry?: string;
    addressCity?: string;
    addressStreet?: string;
    addressHouseNumberOrName?: string;
    addressPostalCode?: string;
    location: Location;
};
type AdyenBalance = {
    id: number;
    accountHolder: AdyenAccountHolder;
    accountHolderId: number;
    amount: number;
    amountPending: number;
    amountHold: number;
    response: any;
    isVisible: boolean;
    createdAt: Date;
};
enum AnalyticsSaleItemType {
    REVENUE = 'REVENUE',
    TIP = 'TIP',
    SERVICE_FEE = 'SERVICE_FEE',
}
type AnalyticsSaleItem = {
    id: string;
    groupingId: string;
    orderId: number;
    createdAt: Date;
    name: string;
    type: AnalyticsSaleItemType;
    locationId: number;
    locationName: string;
    outletId: number;
    outletName: string;
    zoneId: number;
    zoneName: string;
    priceExcludingVat: number;
    priceVat: number;
    price: number;
    date: Date;
    dateMonth: string;
    dateDay: string;
    dateHour: string;
    dateMinute: string;
};
type BalanceClaim = {
    id: number;
    balance: Balance;
    balanceId: number;
    areaCode: string;
    phone: string;
};
type BalanceProduct = {
    balance: Balance;
    balanceId: number;
    product: Product;
    productId: number;
    count: number;
};
enum BalanceType {
    CREDIT = 'CREDIT',
    INVOICE = 'INVOICE',
}
type Balance = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    hash?: string;
    name?: string;
    namePayment?: string;
    namePublic?: string;
    nameInternal?: string;
    type?: BalanceType;
    amountInitial: number;
    amountRemaining: number;
    isActive: boolean;
    validFrom?: Date;
    validTo?: Date;
    client: Client;
    clientId?: number;
    userBalances: UserBalance[];
    balanceProducts: BalanceProduct[];
    balanceClaims: BalanceClaim[];
    payments: Payment[];
    locationBalances: LocationBalance[];
};
type BaseModel = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
};
type Cache = {
    id: string;
    value: any;
    createdAt: Date;
    updatedAt: Date;
};
type ClientInvoice = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    ref: string;
    amount: number;
    periodFrom: Date;
    periodTo: Date;
    isInvoiced: boolean;
    customFields?: { key: string; value: string }[];
    client: Client;
    clientId: number;
    payments: Payment[];
};
type ClientType = 'representation';
type Client = {
    id: number;
    name: string;
    type?: ClientType;
    isActive: boolean;
    description: string;
    contactName: string;
    contactEmail: string;
    companyRegNr: string;
    location: Location;
    locationId: number;
    group: ClientGroup;
    groupId?: number;
    createdAt: Date;
    updatedAt: Date;
    balances: Balance[];
    clientInvoices: ClientInvoice[];
    clientDiscounts: ClientDiscount[];
};
type ClientDiscount = {
    client: Client;
    clientId: number;
    discount: Discount;
    discountId: number;
};
type ClientGroup = {
    id: number;
    name: string;
    externalProvider?: 'tripletex' | '24_seven_office' | string;
    externalProviderCustomerId?: number;
    tripletexCustomerId?: number;
    location: Location;
    locationId: number;
    clients: Client[];
};
enum CompanyMode {
    TEST = 'TEST',
    LIVE = 'LIVE',
}
type Company = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    mode: CompanyMode;
    countryCode: string;
    currencyCode: string;
    email: string;
    legalAddress: string;
    registrationNumber: string;
    addressRegion: string;
    addressCity: string;
    addressStreetName: string;
    addressStreetNumber: string;
    addressStreetPostalCode: string;
    locations: Location[];
    adyenAccountHolders: AdyenAccountHolder[];
    adyenPayouts: AdyenPayout[];
    userCompanyRoles: UserCompanyRole[];
    terminals: Terminal[];
    externalId: string;
    adyenLegalEntityId: string;
    adyenAccountHolderId: string;
    country: string;
};
enum ConfigId {
    ADYEN_CONFIG_TEST = 'ADYEN_CONFIG_TEST',
    ADYEN_CONFIG_LIVE = 'ADYEN_CONFIG_LIVE',
    ADYEN_CONFIG = 'ADYEN_CONFIG',
    Z_REPORT_START_DATE = 'Z_REPORT_START_DATE',
    POS_VERSION = 'POS_VERSION',
}
type ConfigDataAdyenConfig = {
    accountCodeTransactionFee: string;
    accountCodeServiceFee: string;
    environment: 'LIVE' | 'TEST';
    merchantAccountPlatforms: string;
    merchantAccountPos: string;
    userReport: {
        userName: string;
        apiKey: string;
        password: string;
    };
    userWebService: {
        userName: string;
        apiKey: string;
        clientKey: string;
        basicAuthPassword: string;
        basicAuthPosPassword: string;
    };
    userPlatform: {
        userName: string;
        apiKey: string;
    };
    googlePayMerchantId?: string;
    liveEndpointUrlPrefix?: string;
    /**
     * @deprecated
     */
    accountCodeLiableAccount: string;
};
type ConfigData = ConfigDataAdyenConfig | any;
type Config = {
    id: ConfigId;
    data: ConfigData;
};
type Course = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    position: number;
    location: Location;
    locationId: number;
    products: Product[];
    orderProducts: OrderProduct[];
    modifierGroupItems: ModifierGroupItem[];
};
type CovidRegistration = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    areaCode: string;
    phone: string;
    deviceFingerprint: string;
    zoneId: number;
    zoneName: string;
    user: User;
    userId: number;
    outlet: Outlet;
    outletId: number;
    outletName: string;
    locationId: number;
    locationName: string;
};
type Cron = {
    id: string;
    pattern: string;
    isActive: boolean;
    isMaxMemory: boolean;
};
type DiscountProduct = {
    discount: Discount;
    discountId: number;
    product: Product;
    productId: number;
    percent: number;
};
type DiscountUser = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    discount: Discount;
    discountId: number;
    user: User;
    userId: number;
};
type Discount = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    displayName: string;
    percent: number;
    validFrom: Date;
    validTo: Date;
    hoursValidFor: number;
    revokedAt: Date;
    location: Location;
    locationId: number;
    account: Account;
    accountId: number;
    discountProducts: DiscountProduct[];
    discountUsers: DiscountUser[];
    clientDiscounts: ClientDiscount[];
};
type EJournalCashRegister = {
    registerID: string;
    description: string;
    cashTransactions: EJournalCashTransaction[];
    createdAt: Date;
    updatedAt: Date;
};
type ECSequentialNumber = number;
type ECTotalSalesIncludingVat = number;
type ECTotalSalesExcludingVat = number;
type ECYearMonthDay = string;
type ECHoursMinutesSeconds = string;
type ECDecimalPrecision2 = string;
enum EJournalCashTransactionAmountType {
    DEBIT = 'D',
    CREDIT = 'C',
}
enum EJournalCashTransactionKeyVersion {
    E_JOURNAL_KEY_V1 = 'eJournalKey.V1',
}
type EJournalCashTransactionCtLine = {
    nr: ECSequentialNumber;
    // Transaction line number. Should be a unique sequential number within a transaction.
    lineID: any;
    // Reference to ticketline codes. Description of the code must be stated in the table 'Basics'.
    // lineType: any;
    lineAmntIn: ECDecimalPrecision2;
    lineAmntEx: ECDecimalPrecision2;
    amntTp: EJournalCashTransactionAmountType;
    cashTransLineDescr: string;
    vat: {
        vatCode: any;
        vatPerc: ECDecimalPrecision2;
        vatAmnt: ECDecimalPrecision2;
    };
};
type EJournalCashTransaction = {
    id: string;
    nr: ECSequentialNumber;
    transID: ECSequentialNumber;
    transAmntIn: ECDecimalPrecision2;
    transAmntEx: ECDecimalPrecision2;
    amntTp: EJournalCashTransactionAmountType;
    transDate: ECYearMonthDay;
    transTime: ECHoursMinutesSeconds;
    signature: string;
    keyVersion: EJournalCashTransactionKeyVersion;
    payment: Payment;
    order: Order;
    cashRegister: EJournalCashRegister;
    registerID: string;
    ctLine: EJournalCashTransactionCtLine[];
    createdAt: Date;
    updatedAt: Date;
    eventEJournalCashTransactions: SettlementEventEJournalCashTransaction[];
};
type EJournalEventReportArticleGroup = {
    artGroupID: number; // account ID
    artGroupNum: number; // precision 2; total sales count
    artGroupAmnt: number; // precision 2; total sales including VAT
    accDesc?: string;
};
type EJournalEventReportReportPayment = {
    paymentType: string;
    paymentNum: number; // precision 2; total sales count
    paymentAmnt: number; // precision 2; total sales including VAT
};
type EJournalEventReportVatGroup = {
    vatPerc: number;
    cashSaleAmnt: number; // precision 2; total sales excluding VAT
    vatAmnt: number; // precision 2; total sales VAT
};
enum EJournalEventReportReportType {
    Z_REPORT = 'Z report',
    X_REPORT = 'X report',
}
type EJournalEventReportReportTotalCashSales = {
    totalCashSaleAmnt: number; // TerminalTotalSalesIncludingVat
};
type EJournalEventReportReportCorrLines = {
    corrLineType: null;
    corrLineNum: 0;
    corrLineAmnt: 0.0;
};
type EJrounalEventReportReportPriceInquiries = {
    priceInquiryGroup: null;
    priceInquiryNum: 0;
    priceInquiryAmnt: 0.0;
};
type EJrounalEventReportReportReportOtherCorrs = {
    otherCorrType: null;
    otherCorrNum: 0;
    otherCorrAmnt: 0.0;
};
type EJournalEventReport = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    eventID: string;
    eventType: string;
    eventDate: string | '2020-01-01';
    eventTime: string | '00:00:00';
    reportID: number; // SettlementSequenceNumber
    reportType: EJournalEventReportReportType;
    companyIdent: string; // CompanyRegNumber
    companyName: string;
    reportDate: string | '2020-01-01';
    reportTime: string | '00:00:00';
    registerID: string; // CashRegisterId
    reportTotalCashSales: EJournalEventReportReportTotalCashSales;
    reportArtGroups: EJournalEventReportArticleGroup[];
    reportPayments: EJournalEventReportReportPayment[];
    reportCashSalesVat: EJournalEventReportVatGroup[];
    reportOpeningChangeFloat: number;
    reportReceiptNum: number;
    reportOpenCashBoxNum: number;
    reportReceiptCopyNum: number;
    reportReceiptCopyAmnt: number;
    reportReceiptProformaNum: number;
    reportReceiptProformaAmnt: number;
    reportReturnNum: number;
    reportReturnAmnt: number;
    reportDiscountNum: number;
    reportDiscountAmnt: number;
    reportVoidTransNum: number;
    reportVoidTransAmnt: number;
    reportCorrLines: EJournalEventReportReportCorrLines[];
    reportPriceInquiries: EJrounalEventReportReportPriceInquiries[];
    reportOtherCorrs: EJrounalEventReportReportReportOtherCorrs[];
    reportReceiptDeliveryNum: number;
    reportReceiptDeliveryAmnt: number;
    reportTrainingNum: number;
    reportTrainingAmnt: number;
    reportGrandTotalSales: number; // TerminalTotalSalesIncludingVat
    reportGrandTotalReturn: number;
    reportGrandTotalSalesNet: number; // TerminalTotalSalesExcludingVat
    settlement: Settlement;
    settlementId: number;
    eventEJournalEventReports: SettlementEventEJournalEventReport[];
};
enum EventHistoryType {
    OUTLET_OPENING_TIME = 'OUTLET_OPENING_TIME',
    OUTLET_CHANGE_MENU = 'OUTLET_CHANGE_MENU',
    SETTLEMENT_S3_DATA_QUERY = 'SETTLEMENT_S3_DATA_QUERY',
    SETTLEMENT_ADYEN_PAYOUT_REQUIRED_QUERY = 'SETTLEMENT_ADYEN_PAYOUT_REQUIRED_QUERY',
    SETTLEMENT_VISMA_SYNC = 'SETTLEMENT_VISMA_SYNC',
    ORDER_MUNU_SYNC = 'ORDER_MUNU_SYNC',
    SETTLEMENT_AUTO_SETTLE = 'SETTLEMENT_AUTO_SETTLE',
    SETTLEMENT_AUTO_PAY_OUT = 'SETTLEMENT_AUTO_PAY_OUT',
    EMAIL_SYSTEM_REPORT = 'EMAIL_SYSTEM_REPORT',
    EMAIL = 'EMAIL',
}
type EventHistory = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    eventId: string;
    idValue: number;
    outletId: number;
    data: any;
    type: EventHistoryType;
};
type ExternalRequestType =
    | 'AZURE_SEND_TO_STORAGE_QUEUE'
    | 'SYNC_ARCHIVED_ORDER'
    | 'TRIPLETEX_SEND_INVOICE'
    | '24_SEVEN_OFFICE_SEND_INVOICE'
    | 'EMAIL';
type ExternalRequestResponseStatus = 'error' | 'success';
type ExternalRequest = {
    id: number;
    type: ExternalRequestType;
    numValue: number;
    strValue: string;
    request: any;
    response: any;
    responseStatus: ExternalRequestResponseStatus;
    location: Location;
    locationId: number;
    createdAt: Date;
};
enum FeatureType {
    ADMIN_V2_ACCESS = 'ADMIN_V2_ACCESS',
    ZONE_PAY = 'ZONE_PAY',
    POS_BALANCE = 'POS_BALANCE',
    POS_MARK_AS_PAID = 'POS_MARK_AS_PAID',
    POS_MODULE = 'POS_MODULE',
    POS_LOCATION_OPERATOR = 'POS_LOCATION_OPERATOR',
    POS_DISCOUNT_CUSTOM = 'POS_DISCOUNT_CUSTOM',
    POS_COURSE_V2 = 'POS_COURSE_V2',
    POS_ZONE_LIST_COURSE_DIALOG_V2 = 'POS_ZONE_LIST_COURSE_DIALOG_V2',
    POS_OUTLET_V2 = 'POS_OUTLET_V2',
    POS_ZONES_V2 = 'POS_ZONES_V2',
    POS_STATION_V2 = 'POS_STATION_V2',
    POS_POS_V2 = 'POS_POS_V2',
    POS_IOT_V2 = 'POS_IOT_V2',
    POS_PAYMENT_BALANCE = 'POS_PAYMENT_BALANCE',
    POS_LAYOUT = 'POS_LAYOUT',
    POS_TERMINAL_PAYMENT_FORCE_SELECT_ZONE_FOR_FOOD_AND_OTHER = 'POS_TERMINAL_PAYMENT_FORCE_SELECT_ZONE_FOR_FOOD_AND_OTHER',
    POS_ANALYTICS_V2 = 'POS_ANALYTICS_V2',
    POS_ZONE_DIALOG = 'POS_ZONE_DIALOG',
    SETTLEMENT_DAILY = 'SETTLEMENT_DAILY',
    PAYMENT_METHOD_GIFT_CARD = 'PAYMENT_METHOD_GIFT_CARD',
    SPILLAGE = 'SPILLAGE',
    GIFT_CARD_REQUIRE_CODE = 'GIFT_CARD_REQUIRE_CODE',
    CUSTOM_PAYMENT_METHODS = 'CUSTOM_PAYMENT_METHODS',
    API_ORDER_ZONE_TERMINAL_DRINK_TO_DELIVERED = 'API_ORDER_ZONE_TERMINAL_DRINK_TO_DELIVERED',
}
type Feature = {
    id: number;
    type: FeatureType;
    name?: string;
    description?: string;
    isActive: boolean;
    location: Location;
    locationId: number;
};
type I18nLang = 'en' | 'no' | string;
type I18nEntity = 'Product';
type I18n = {
    id: number;
    lang: I18nLang;
    key: string;
    value: string;
    entity: I18nEntity;
    entityId: number;
    location: Location;
    locationId: number;
};
type Ingredient = {
    id: number;
    name: string;
    location: Location;
    locationId: number;
    productIngredients: ProductIngredient[];
    stationIngredients: StationIngredient[];
    orderProductIngredients: OrderProductIngredient[];
};
enum IntegrationType {
    KDR_OPEN = 'KDR_OPEN',
    VISMA = 'VISMA',
    MUNU = 'MUNU',
    TRIPLETEX = 'TRIPLETEX',
    VISBOOK = 'VISBOOK',
    SEVEN_OFFICE_24 = 'SEVEN_OFFICE_24',
    AZURE_QUEUE = 'AZURE_QUEUE',
}
type IntegrationData =
    | IntegrationDataKdrOpen
    | IntegrationDataVisma
    | IntegrationDataMunu
    | IntegrationDataTripletex
    | IntegrationDataVisbook
    | IntegrationData24SevenOffice
    | IntegrationDataAzureQueue
    | any;
type IntegrationDataKdrOpen = {
    origin: string;
    merchantId: string;
    userId: string;
    departmentId: string;
    partnerId: string;
    menuId: number;
    isActive: boolean;
    outletData: {
        [outletId: number]: {
            departmentId: string;
            menuId: number;
        };
    };
};
type IntegrationDataVisma = {
    apiUrl: string;
    username: string;
    password: string;
    voucherSeriesNo?: number;
    voucherType?: number;
    accountType?: number;
    account?: {
        [key: string]: {
            code?: string;
            type?: 'CREDIT' | 'DEBIT';
        };
    };
};
type IntegrationDataMunu = {
    clientId?: string;
    clientSecret?: string;
    tokenUrl?: string;
    baseUrl?: string;
    articleToProductIdMap?: Record<number, number>;
    syncMenuPrices?: boolean;
};
type IntegrationDataTripletex = {
    consumerToken: string;
    employeeToken: string;
    baseUrl?: string;
    tripletexAccount: {
        [key: string]: {
            displayName: string;
            number: number;
            type: 'DEBIT' | 'CREDIT';
        };
    };
    isConnected?: boolean;
    autoSyncActive?: boolean;
};
type IntegrationDataVisbook = {
    credentials: {
        username: string;
        password: string;
        companyId: number;
    };
    isConnected?: boolean;
    isValidConfiguration?: boolean;
    accountUnitMap?: Record<string, number>;
};
type IntegrationData24SevenOffice = {
    isConnected?: boolean;
    credentials: {
        applicationId: string;
        username: string;
        password: string;
    };
    accountMap?: Record<
        string,
        {
            id: number;
            number: number;
            type?: 'CREDIT' | 'DEBIT';
            taxNo?: string;
        }
    >;
    typeId?: number;
    autoSyncActive?: boolean;
    autoSyncAccounts?: boolean;
    accountCategoryMap?: Record<string, number>;
};
type IntegrationDataAzureQueue = {
    connectionString?: string;
    queueName?: string;
    isConnected?: boolean;
    autoSyncActive?: boolean;
};
type Integration = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: IntegrationType;
    isActive: boolean;
    data: IntegrationData;
    location: Location;
    locationId: number;
};
type InventoryActionDataProcessPurchaseOrderProduct = {
    unitAmount: number;
    containerPrice: number;
    purchaseOrderId: number;
    productId: number;
    inventoryId: number;
    meta?: any;
};
type InventoryActionDataProcessCountingReportProduct = {
    unitAmountCorrection: number;
    unitAmountBefore: number;
    unitAmountAfter: number;
    productId: number;
    inventoryId: number;
    meta?: any;
    countingReportId: number;
};
type InventoryActionDataInventoryMoveProduct = {
    productId: number;
    unitAmount: number;
    sourceInventoryId: number;
    sourceInventory: Inventory;
    targetInventoryId: number;
    targetInventory: Inventory;
    meta?: any;
};
type InventoryActionDataProcessInventoryMoveProduct = {
    unitAmountCorrection: number;
    unitAmountBefore: number;
    unitAmountAfter: number;
    productId: number;
    product: Product;
    sourceInventory: Inventory;
    targetInventory: Inventory;
};
enum InventoryActionType {
    INVENTORY_MOVE_CREATE = 'INVENTORY_MOVE_CREATE',
    INVENTORY_MOVE_PRODUCT_PROCESS = 'INVENTORY_MOVE_PRODUCT_PROCESS',
    PURCHASE_ORDER_PRODUCT_PROCESS = 'PURCHASE_ORDER_PRODUCT_PROCESS',
    COUNTING_REPORT_PRODUCT_PROCESS = 'COUNTING_REPORT_PRODUCT_PROCESS',
}
type InventoryAction = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: InventoryActionType;
    description: string;
    isProcessed: boolean;
    processedAt: Date;
    data:
        | InventoryActionDataProcessCountingReportProduct
        | InventoryActionDataProcessPurchaseOrderProduct
        | InventoryActionDataInventoryMoveProduct
        | InventoryActionDataProcessInventoryMoveProduct;
    inventory: Inventory;
    inventoryId: number;
    user: User;
    userId: number;
};
type InventoryCountingReportProduct = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    inventoryCountingReport: InventoryCountingReport;
    inventoryCountingReportId: number;
    product: Product;
    productId: number;
    unitAmountBefore: number;
    unitAmountAfter: number;
    unitAmountCorrection: number;
};
type InventoryCountingReportSummary = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    data: any;
    inventory: Inventory;
    inventoryId: number;
    user: User;
    userId: number;
    inventoryCountingReports: InventoryCountingReport[];
};
enum InventoryCountingReportType {
    SPILLAGE = 'SPILLAGE',
}
type InventoryCountingReport = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type?: InventoryCountingReportType;
    date: Date;
    description: string;
    isConfirmed: boolean;
    data: any;
    inventory: Inventory;
    inventoryId: number;
    inventoryCountingReportSummary: InventoryCountingReportSummary;
    inventoryCountingReportSummaryId: number;
    user: User;
    userId: number;
    inventoryCountingReportProducts: InventoryCountingReportProduct[];
};
type InventoryProduct = {
    inventory: Inventory;
    inventoryId: number;
    product: Product;
    productId: number;
    expectedUnitAmount: number;
    lastContainerPurchasePrice: number;
};
type InventoryPurchaseOrderProduct = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    inventoryPurchaseOrder: InventoryPurchaseOrder;
    inventoryPurchaseOrderId: number;
    product: Product;
    productId: number;
    unitAmount: number;
    containerPrice: number;
};
type InventoryPurchaseOrderVendor = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    inventoryPurchaseOrders: InventoryPurchaseOrder[];
    location: Location;
    locationId: number;
};
type InventoryPurchaseOrder = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    description: string;
    date: Date;
    inventory: Inventory;
    inventoryId: number;
    inventoryPurchaseOrderVendor: InventoryPurchaseOrderVendor;
    inventoryPurchaseOrderVendorId: number;
    user: User;
    userId: number;
    inventoryPurchaseOrderProducts: InventoryPurchaseOrderProduct[];
};
type Inventory = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    location: Location;
    locationId: number;
    inventoryProducts: InventoryProduct[];
    inventoryPurchaseOrders: InventoryPurchaseOrder[];
    inventoryActions: InventoryAction[];
    inventoryCountingReports: InventoryCountingReport[];
    inventoryCountingReportSummaries: InventoryCountingReportSummary[];
    outlets: Outlet[];
};
enum InventoryOrderProductSyncType {
    SYNC = 'SYNC',
    REVERT = 'REVERT',
}
type InventoryOrderProductSync = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    orderProduct: OrderProduct;
    orderProductId: number;
    isSynced: boolean;
    type: InventoryOrderProductSyncType;
};
type IpData = {
    ip: string;
    latitude: number | 59.433;
    longitude: number | 24.7323;
    currencyCode: string | 'EUR';
    areaCode: string | '372';
    timeZone: string | 'Europe/Tallinn';
    city: string | 'Tallinn';
    region: string | 'Harjumaa';
    countryName: string | 'Estonia';
    countryCode: string | 'EE';
    continentCode: string | 'EU';
    isValid: boolean;
};
type KdrSyncedOrder = {
    id: string;
    orderId: number;
    isSuccess: boolean;
    request?: any;
    response?: any;
    syncedAt: Date;
    errorCode?: number;
    errorMessage?: string;
    order: Order;
};
type KioskDevice = {
    id: number;
    fingerprint: string;
    name: string;
    terminal: Terminal;
    terminalId: number;
    location: Location;
    locationId: number;
    outlet: Outlet;
    outletId: number;
    zone: Zone;
    zoneId: number;
};
type LocationBalance = {
    location: Location;
    locationId: number;
    balance: Balance;
    balanceId: number;
};
enum LocationConfigType {
    KDR_PRODUCT_SYNC = 'KDR_PRODUCT_SYNC',
    SERVICE_FEE_GROUPS = 'SERVICE_FEE_GROUPS',
    AUTO_SETTLE = 'AUTO_SETTLE',
    AUTO_PAYOUT = 'AUTO_PAYOUT',
    OUTLET_ZONE_GROUPS = 'OUTLET_ZONE_GROUPS',
    COUNT_BALANCE_PAYMENT_AS_REVENUE = 'COUNT_BALANCE_PAYMENT_AS_REVENUE',
    AUTO_PAY = 'AUTO_PAY',
    POS_MODULE_CONFIG = 'POS_MODULE_CONFIG',
    POS_COURSE_STYLES = 'POS_COURSE_STYLES',
    SETTLEMENT_VISMA_SYNC = 'SETTLEMENT_VISMA_SYNC',
    SETTLEMENT_E_JOURNAL_SYNC = 'SETTLEMENT_E_JOURNAL_SYNC',
    SETTLEMENT_ADYEN_PAYOUT = 'SETTLEMENT_ADYEN_PAYOUT',
    ORDER_AUTO_ARCHIVE = 'ORDER_AUTO_ARCHIVE',
    ZONE_IDLE_STATE = 'ZONE_IDLE_STATE',
    EXTERNAL_PAYMENT_METHOD_FEE = 'EXTERNAL_PAYMENT_METHOD_FEE',
    /**
     * @deprecated
     */
    OUTLET_GROUPS = 'OUTLET_GROUPS',
}
type LocationConfigData =
    | LocationConfigDataKdrProductSync
    | LocationConfigDataServiceFeeGroups
    | LocationConfigDataAutoSettle
    | LocationConfigDataOutletZoneGroups
    | LocationConfigDataAutoPay
    | LocationConfigDataPosModuleConfig
    | LocationConfigDataPosCourseStyles
    | LocationConfigDataSettlementVismaSync
    | LocationConfigDataSettlementEJournalSync
    | LocationConfigDataSettlementAdyenPayout
    | LocationConfigDataOrderAutoArchive
    | LocationConfigDataZoneIdleState
    | LocationConfigDataExternalPaymentMethodFee;
type LocationConfigDataKdrProductSync = {
    kdrProductIdsPreventSync: number[];
};
type LocationConfigDataServiceFeeGroups = {
    defaultFee: number;
    groups: {
        id: number;
        from: number;
        to: number;
        feeAmount: number;
    }[];
};
type LocationConfigDataAutoSettle = {
    hour: string;
};
type LocationConfigDataOutletZoneGroups = {
    id: number;
    outletId: number;
    name: string;
    zoneIds: number[];
    zones: Zone[];
}[];
type LocationConfigDataAutoPay = {
    terminalIdData: Record<
        number,
        {
            productId: number;
            isActive: boolean;
            outletId: number;
            price?: number;
        }
    >;
};
type LocationConfigDataPosModuleConfig = {
    categoryStyle: Record<string, any>;
};
type LocationConfigDataSettlementVismaSync = {};
type LocationConfigDataSettlementEJournalSync = {};
type LocationConfigDataSettlementAdyenPayout = {};
type LocationConfigDataOrderAutoArchive = {
    archiveAfterMinutes?: number;
};
type LocationConfigDataZoneIdleState = {
    redirect?: {
        afterXMinutes?: number;
        to?: 'SELECT_ZONE' | string;
        message?: string;
    };
};
type LocationConfigDataExternalPaymentMethodFee = {
    methods?: {
        key: string;
        method: string;
        percent: number;
    }[];
};
type LocationConfigDataPosCourseStyles = {
    rules: {
        id: number;
        courseId?: number[];
        requestStatus?: OrderProductRequestStatus[];
        minutes?: number;
        style?: any;
    }[];
};
type LocationConfig = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: LocationConfigType;
    isActive: boolean;
    data: LocationConfigData;
    location: Location;
    locationId: number;
};
type Location = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    hash: string;
    name: string;
    description: string;
    currency: string;
    timezoneMoment: string;
    browseTagId: string;
    imageLogo: string;
    imageBackground: string;
    latitude: number;
    longitude: number;
    city: string;
    isClosed: boolean;
    isHidden: boolean;
    isDevelopment: boolean;
    isEJournalActive: boolean;
    position: number;
    externalId: string;
    isVisibleInV1: boolean;
    isConfirmed: boolean;
    serviceFeeAmount: number;
    serviceFeePercent: number;
    isServiceFeeDisplayedInList: boolean;
    company: Company;
    companyId: number;
    adyenAccount: AdyenAccount;
    adyenAccountId: number;
    adyenStore: AdyenStore;
    adyenStoreId: number;
    adyenBalanceAccountId: string;
    orders: Order[];
    payments: Payment[];
    userLocationRoles: UserLocationRole[];
    outlets: Outlet[];
    settlements: Settlement[];
    locationSettlements: LocationSettlement[];
    integrations: Integration[];
    clients: Client[];
    pointOfSales: PointOfSale[];
    discounts: Discount[];
    inventories: Inventory[];
    miniInventories: MiniInventory[];
    products: Product[];
    accounts: Account[];
    recipes: Recipe[];
    menus: Menu[];
    variantGroups: VariantGroup[];
    inventoryPurchaseOrderVendors: InventoryPurchaseOrderVendor[];
    modifiers: Modifier[];
    modifierGroups: ModifierGroup[];
    paymentProviders: PaymentProvider[];
    tipGroups: TipGroup[];
    locationConfigs: LocationConfig[];
    adyenPayouts: AdyenPayout[];
    locationBalances: LocationBalance[];
    terminalPresets: TerminalPreset[];
    courses: Course[];
    features: Feature[];
    munuOrders: MunuOrder[];
    starPrinters: StarPrinter[];
    reports: Report[];
    posOperators: PosOperator[];
    posOperatorRoleGroups: PosOperatorRoleGroup[];
    spillageReports: SpillageReport[];
    paymentMethods: PaymentMethod[];
    terminals: Terminal[];
    zReports: ZReport[];
    productTags: ProductTag[];
    menuRules: MenuRule[];
    values: LocationValue[];
    i18ns: I18n[];
    systemModifications: SystemModification[];
    externalRequests: ExternalRequest[];
    kioskDevices: KioskDevice[];
    ingredients: Ingredient[];
};
enum LocationSettlementStatus {
    PENDING = 'PENDING',
    FAILED = 'FAILED',
    CONFIRMED = 'CONFIRMED',
}
type LocationSettlement = {
    id: number;
    sequence: number;
    status: LocationSettlementStatus;
    statusReason?: string;
    from: Date;
    to: Date;
    description?: string;
    timezone?: string;
    revenue?: number;
    location: Location;
    locationId: number;
    locationName: string;
    createdAt: Date;
    products: SettlementProduct[];
    payments: SettlementPayment[];
    events: SettlementEvent[];
};
type LocationValueType = string | 'TABLE_CSS';
type LocationValue = {
    location: Location;
    locationId: number;
    type: LocationValueType;
    value?: any;
    createdAt: Date;
    updatedAt: Date;
};
type MenuProduct = {
    menu: Menu;
    menuId: number;
    product: Product;
    productId: number;
    price: number;
    priceTakeaway: number;
    position: number;
    isHidden: boolean;
};
type MenuType = 'BREAKFAST' | 'LUNCH' | 'DINNER';
type Menu = {
    id: number;
    externalId: string;
    name: string;
    type: MenuType;
    location: Location;
    locationId: number;
    createdAt: Date;
    updatedAt: Date;
    menuProducts: MenuProduct[];
    outlets: Outlet[];
    outletMenus: OutletMenu[];
    outletMenuChanges: OutletMenuChange[];
    zoneGroups: ZoneGroup[];
    rules: MenuRule[];
};
type MenuRuleType = 'SHOW_PRODUCT' | 'HIDE_PRODUCT';
type MenuRuleData = MenuRuleDataMatchValueFilter & { time?: Partial<MenuRuleDataTime> };
type MenuRuleDataTime = Record<'MON' | 'TUE' | 'WED' | 'THU' | 'FRI' | 'SAT' | 'SUN', MenuRuleDataTimePeriod[]>;
type MenuRuleDataTimePeriod = { key: string; from?: string; to?: string; isActive: boolean };
type MenuRuleDataMatchValueFilter = {
    type: 'SHOW_PRODUCT' | 'HIDE_PRODUCT';
    matchValue?: Record<keyof Product, any[]>;
};
type MenuRule = {
    id: number;
    location: Location;
    locationId: number;
    menu: Menu;
    menuId: number;
    name: string;
    isActive: boolean;
    type: MenuRuleType;
    data: MenuRuleData;
    createdAt: Date;
    updatedAt: Date;
    times: MenuRuleTime[];
};
type MenuRuleTimeDateRuleType = 'ENABLE' | 'DISABLE';
type MenuRuleTime = {
    id: number;
    rule: MenuRule;
    ruleId: number;
    isActive: boolean;
    dateFrom: Date;
    dateTo: Date;
    dateRuleType: MenuRuleTimeDateRuleType;
    day: 1 | 2 | 3 | 4 | 5 | 6 | 7 | number;
    dayMinFrom: number;
    dayMinTo: number;
};
type MiniInventoryProductCountByProductId = {
    [productId: number]: number;
};
type MiniInventory = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    isActive: boolean;
    productCountByProductId?: MiniInventoryProductCountByProductId;
    location: Location;
    locationId: number;
};
type ModifierGroupItem = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    modifierGroup: ModifierGroup;
    modifierGroupId: number;
    product: Product;
    productId: number;
    modifier: Modifier;
    modifierId: number;
    price: number;
    unitAmount: number;
    position: number;
    course: Course;
    courseId: number;
};
enum ModifierGroupPresentationType {
    PACKAGE = 'PACKAGE',
    HORIZONTAL = 'HORIZONTAL',
}
type ModifierGroupType = string;
type ModifierGroup = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    nameInternal: string;
    nameStation: string;
    type: ModifierGroupType;
    presentationType: ModifierGroupPresentationType;
    name: string;
    description: string;
    autoSelectModifierId: number;
    autoSelectFirstModifier: boolean;
    createSeparateProducts: boolean;
    minAllowed: number;
    maxAllowed: number;
    location: Location;
    locationId: number;
    modifierGroupItems: ModifierGroupItem[];
    productModifierGroups: ProductModifierGroup[];
};
type Modifier = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    externalId: string;
    nameInternal: string;
    name: string;
    description: string;
    position: number;
    location: Location;
    locationId: number;
    modifierGroupItems: ModifierGroupItem[];
};
type MunuOrderRequest = { date: string; data: any; response: any; isError: boolean };
type MunuOrder = {
    id: number;
    isSuccess: boolean;
    request?: MunuOrderRequest;
    munuOrderId?: number;
    order: Order;
    orderId: number;
    location: Location;
    locationId: number;
    createdAt: Date;
};
type OrderProductModifier = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    guid: string;
    modifierGroupId: number;
    modifierGroupName: string;
    modifierGroupPresentationType: string;
    name: string;
    priceInitial: number;
    priceInitialExcludingVat: number;
    priceInitialVat: number;
    priceFinal: number;
    priceFinalExcludingVat: number;
    priceFinalVat: number;
    currency: string;
    productId: number;
    productName: string;
    productDescription: string;
    productIcon: string;
    productRootCategory: string;
    productCategory: string;
    productSubCategory: string;
    productUnitAmount: number;
    productContainer: string;
    productBaseUnit: string;
    productData: Partial<Product>;
    productAccountId: number;
    productAccountVatPercent: number;
    productAccountData: Partial<Account>;
    modifierId: number;
    modifierName: string;
    modifierData: any;
    discountId: number;
    discountName: string;
    discountVatPercent: number;
    discountData: any;
    orderProduct: OrderProduct;
    orderProductId: number;
};
type OrderProductPayment = {
    orderProduct: OrderProduct;
    orderProductId: number;
    payment: Payment;
    paymentId: number;
};
enum OrderProductStatus {
    PLACED = 'PLACED',
    IN_PREPARATION = 'IN_PREPARATION',
    READY = 'READY',
    IN_DELIVERY = 'IN_DELIVERY',
    DELIVERED = 'DELIVERED',
    CANCELLED = 'CANCELLED',
}
enum OrderProductPaymentStatus {
    MISSING = 'MISSING',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    CANCELLED = 'CANCELLED',
    REFUNDED = 'REFUNDED',
}
enum OrderProductSaleType {
    REVENUE = 'REVENUE',
    INVOICE = 'INVOICE',
    TIP = 'TIP',
    SERVICE_FEE = 'SERVICE_FEE',
}
enum OrderProductRequestStatus {
    HOLD = 'HOLD',
    REQUEST = 'REQUEST',
}
type OrderProduct = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    guid: string;
    saleType: OrderProductSaleType;
    priceInitial: number;
    priceInitialExcludingVat: number;
    priceInitialVat: number;
    priceFinal: number;
    priceFinalExcludingVat: number;
    priceFinalVat: number;
    priceCombined: number;
    priceCombinedExcludingVat: number;
    priceCombinedVat: number;
    currency: string;
    status: OrderProductStatus;
    comment: string;
    productId: number;
    productName: string;
    productDescription: string;
    productIcon: string;
    productRootCategory: string;
    productCategory: string;
    productSubCategory: string;
    productData: Partial<Product>;
    productAccountId: number;
    productAccountVatPercent: number;
    productAccountData: Partial<Account>;
    discountId: number;
    discountName: string;
    discountPercent: number;
    discountData: Partial<Discount>;
    locationId: number;
    locationName: string;
    outletId: number;
    outletName: string;
    zoneId: number;
    zoneName: string;
    isTip: boolean;
    paymentStatus: OrderProductPaymentStatus;
    paymentStatusUpdatedAt: Date;
    requestStatus: OrderProductRequestStatus;
    dateMonth: string;
    dateDay: string;
    dateHour: string;
    dateMinute: string;
    order: Order;
    orderId: number;
    course: Course;
    courseId: number;
    orderProductPayments: OrderProductPayment[];
    orderProductModifiers: OrderProductModifier[];
    inventoryOrderProductSyncs: InventoryOrderProductSync[];
    splits: OrderProductSplit[];
    statusChanges: OrderProductStatusChange[];
    statusChangesTimestamps: OrderProductStatusChangeTimestamp[];
    locks: OrderProductLock[];
    ingredients: OrderProductIngredient[];
    stationOrderProducts: StationOrderProduct[];
    stationRequestOrderProducts: StationRequestOrderProduct[];
};
enum OrderStatus {
    PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    ARCHIVED = 'ARCHIVED',
    /**
     * @deprecated
     */
    CANCELLED = 'CANCELLED',
    /**
     * @deprecated
     */
    REJECTED = 'REJECTED',
}
enum OrderPlacedFrom {
    ZONE = 'ZONE',
    COUNTER = 'COUNTER',
}
enum OrderPlacedBy {
    CUSTOMER = 'CUSTOMER',
    STAFF = 'STAFF',
}
enum OrderDeliveryType {
    DELIVERY = 'DELIVERY',
    PICKUP = 'PICKUP',
}
enum OrderVisibility {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
}
type Order = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    guid: string;
    externalId: string;
    deviceFingerprint: string;
    deviceFingerprintLastInteraction: string;
    appVersion: string;
    comment: string;
    contactAreaCode: string;
    contactPhone: string;
    visibilityType: OrderVisibility;
    status: OrderStatus;
    isDisplayedToCustomer: boolean;
    placedBy: OrderPlacedBy;
    placedFrom: OrderPlacedFrom;
    placedAt: Date;
    archivedAt: Date;
    takeawayAt?: Date;
    deliveryType: OrderDeliveryType;
    sequence: number;
    hash: string;
    cronComment: string;
    settlement: Settlement;
    settlementId: number;
    user: User;
    userId: number;
    location: Location;
    locationId: number;
    outlet: Outlet;
    outletId: number;
    zone: Zone;
    zoneId: number;
    pointOfSale: PointOfSale;
    pointOfSaleId: string;
    eJournalCashTransaction: EJournalCashTransaction;
    eJournalCashTransactionId: string;
    orderProducts: OrderProduct[];
    kdrSyncedOrder: KdrSyncedOrder;
    kdrSyncedOrderId: string;
    munuOrder: MunuOrder;
    operatorOrders: PosOperatorOrder[];
};
type OrderProductIngredient = {
    orderProduct: OrderProduct;
    orderProductId: number;
    ingredient: Ingredient;
    ingredientId: number;
    status: string | 'PLACED' | 'IN_PREPARATION' | 'READY';
    startedAt: Date;
    updatedAt: Date;
    finishedAt: Date;
    createdAt: Date;
};
type OrderProductLock = {
    orderProduct: OrderProduct;
    orderProductId: number;
    deviceFingerprint: string;
    zoneId: number;
    lockedAt: Date;
};
enum OrderProductSplitStatus {
    INITIATED = 'INITIATED',
    PAID = 'PAID',
    REFUNDED = 'REFUNDED',
}
type OrderProductSplit = {
    payment: Payment;
    paymentId: number;
    orderProduct: OrderProduct;
    orderProductId: number;
    amount: number;
    status: OrderProductSplitStatus;
};
type OrderProductStatusChange = {
    id: string;
    orderProduct: OrderProduct;
    orderProductId: number;
    name: string;
    rootCategory: string | 'FOOD' | 'DRINK' | 'OTHER';
    category: string;
    subCategory: string;
    status: string | 'PLACED' | 'IN_PREPARATION' | 'READY' | 'IN_DELIVERY' | 'DELIVERED' | 'CANCELLED';
    timestampPlaced: number;
    timestampChanged: number;
    timestamp: number;
    timestampDiff: number;
    datePlaced: Date;
    date: Date;
    posOperator: PosOperator;
    posOperatorId: number;
    posOperatorName: string;
    _raw?: any;
};
type OrderProductStatusChangeTimestamp = {
    id: string;
    orderProduct: OrderProduct;
    orderProductId: number;
    date: Date;
    name: string;
    rootCategory: string | 'FOOD' | 'DRINK' | 'OTHER';
    category: string;
    subCategory: string;
    PLACED: number;
    IN_PREPARATION: number;
    READY: number;
    IN_DELIVERY: number;
    DELIVERED: number;
    CANCELLED: number;
};
enum OutletConfigurationType {
    STATION_PRODUCT_STATUSES = 'STATION_PRODUCT_STATUSES',
    STATION_ORDER_CREATE_SETTLED_PAYMENT_WHEN_ARCHIVED = 'STATION_ORDER_CREATE_SETTLED_PAYMENT_WHEN_ARCHIVED',
    STATION_ORDER_CREATE_SETTLED_PAYMENT_WHEN_HANDED_OUT_BY_STAFF = 'STATION_ORDER_CREATE_SETTLED_PAYMENT_WHEN_HANDED_OUT_BY_STAFF',
    TERMINAL_PAYMENT_REQUIRED_FOR_DELIVERED = 'TERMINAL_PAYMENT_REQUIRED_FOR_DELIVERED',
    PRODUCT_CATEGORY_TO_STATUS_FLOW = 'PRODUCT_CATEGORY_TO_STATUS_FLOW',
}
type OutletConfigurationTypeStationProductStatuses = OrderProductStatus[] | boolean;
type OutletConfigurationTypeProductCategoryToStatusFlow = {
    [category: string]: string;
};
type OutletConfigurationData =
    | OutletConfigurationTypeStationProductStatuses
    | OutletConfigurationTypeProductCategoryToStatusFlow
    | any;
type OutletConfiguration = {
    type: OutletConfigurationType;
    isActive: boolean;
    data?: OutletConfigurationData;
    outlet: Outlet;
    outletId: number;
};
enum OutletEventType {
    OPENING_TIMES = 'OPENING_TIMES',
    MENU_CHANGE = 'MENU_CHANGE',
}
type OutletEvent = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    title: string;
    type: OutletEventType;
    isActive: boolean;
    data: any;
    outlet: Outlet;
    outletId: number;
};
type OutletTerminalPreset = {
    outlet: Outlet;
    outletId: number;
    terminalPreset: TerminalPreset;
    terminalPresetId: number;
};
enum OutletThemeColor {
    DARK = 'DARK',
    LIGHT = 'LIGHT',
    SYNG = 'SYNG',
}
type Outlet = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    description: string;
    image: string;
    isClosed: boolean;
    isHidden: boolean;
    isDeleted: boolean;
    isCovidRegistrationRequired: boolean;
    isCovidRegistrationRequiredUpfront: boolean;
    covidRegistrationTagId: string;
    position: number;
    queueLimiterActive: boolean;
    queueLimiterActiveLimit: number;
    isCaptureWhenHandedOut: boolean;
    themeColor: OutletThemeColor;
    hash: string;
    externalId: string;
    location: Location;
    locationId: number;
    inventory: Inventory;
    inventoryId: number;
    menu: Menu;
    menuId: number;
    zones: Zone[];
    orders: Order[];
    outletConfigurations: OutletConfiguration[];
    outletOpenTimes: OutletOpenTime[];
    outletMenuChanges: OutletMenuChange[];
    outletEvents: OutletEvent[];
    covidRegistrations: CovidRegistration[];
    terminals: Terminal[];
    outletTerminalPresets: OutletTerminalPreset[];
    outletMenus: OutletMenu[];
    zoneGroups: ZoneGroup[];
    kioskDevices: KioskDevice[];
    stations: Station[];
    stationRequests: StationRequest[];
};
enum OutletMenuType {
    POS = 'POS',
}
type OutletMenu = {
    outlet: Outlet;
    outletId: number;
    menu: Menu;
    menuId: number;
    type: OutletMenuType;
};
type OutletMenuChange = {
    id: number;
    day: number;
    minutesOffset: number;
    isActive: boolean;
    outlet: Outlet;
    outletId: number;
    menu: Menu;
    menuId: number;
    createdAt: Date;
};
type OutletOpenTime = {
    id: number;
    day: number;
    minutesFrom: number;
    minutesTo: number;
    isActive: boolean;
    outlet: Outlet;
    outletId: number;
    createdAt: Date;
};
enum PaymentEventType {
    API_REQUEST_PAYMENT_REQUEST = 'API_REQUEST_PAYMENT_REQUEST',
    API_REQUEST_CAPTURE = 'API_REQUEST_CAPTURE',
    API_REQUEST_REFUND = 'API_REQUEST_REFUND',
    REDIRECT_RETURN_RESULT = 'REDIRECT_RETURN_RESULT',
    AUTHORISATION = 'AUTHORISATION',
    CAPTURE = 'CAPTURE',
    TERMINAL_PAYMENT_SUCCESS = 'TERMINAL_PAYMENT_SUCCESS',
}
type PaymentEvent = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type?: string | PaymentEventType;
    reference?: string;
    request?: any;
    response?: any;
    success?: boolean;
    timestamp?: Date;
    payment: Payment;
    paymentId: number;
};
enum PaymentHistoryType {
    CREATE = 'CREATE',
    /**
     * @deprecated
     */
    CAPTURE = 'CAPTURE',
    /**
     * @deprecated
     */
    REFUND = 'REFUND',
    CANCEL_OR_REFUND = 'CANCEL_OR_REFUND',
    API_CALLBACK = 'API_CALLBACK',
}
type PaymentHistory = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: PaymentHistoryType;
    amount: number;
    data: any;
    deviceFingerprint?: string;
    payment: Payment;
    paymentId: number;
    user: User;
    userId: number;
};
enum PaymentTransactionType {
    SALE = 'SALE',
    REFUND = 'REFUND',
}
type PaymentTransaction = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    payment: Payment;
    paymentId: number;
    type: PaymentTransactionType;
    amount: number;
    merchantGross: number;
    merchantCost: number;
    merchantNet: number;
    rdxGross: number;
    rdxCost: number;
    rdxNet: number;
};
enum PaymentProvider {
    EXTERNAL = 'EXTERNAL',
    BAMBORA = 'BAMBORA',
    BAMBORA_VIPPS = 'BAMBORA_VIPPS',
    BAMBORA_MOBILE_PAY = 'BAMBORA_MOBILE_PAY',
    VIPPS = 'VIPPS',
    ADYEN = 'ADYEN',
    DEVELOPMENT = 'DEVELOPMENT',
    BALANCE_INVOICE = 'BALANCE_INVOICE',
    BALANCE_CREDIT = 'BALANCE_CREDIT',
}
enum PaymentStatus {
    CREATED = 'CREATED',
    AUTHORISED = 'AUTHORISED',
    SETTLED = 'SETTLED',
    ERROR = 'ERROR',
    /**
     * @deprecated
     */
    CANCELLED_OR_REFUNDED = 'CANCELLED_OR_REFUNDED',
}
enum PaymentMethodType {
    GIFT_CARD = 'GIFT_CARD',
    TERMINAL = 'terminal',
}
type Payment = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    hash: string;
    guid: string;
    deviceFingerprint: string;
    appVersion: string;
    provider: PaymentProvider;
    providerOrderId: string;
    merchantReference: string;
    providerTransactionId: string;
    pspReference: string;
    methodType: string | PaymentMethodType | 'scheme' | 'vipps' | 'applepay' | 'paywithgoogle' | 'terminal';
    methodBrand: string | 'amex' | 'visa' | 'mastercard';
    referenceTxnFee: string;
    referenceServiceFee: string;
    referenceMerchant: string;
    txnAmountInitial: number;
    txnAmountTotal: number;
    txnCostPercent: number;
    txnCost: number;
    txnMerchantGross: number;
    txnMerchantNet: number;
    txnMerchantCost: number;
    txnRdxGross: number;
    txnRdxNet: number;
    txnRdxCost: number;
    txnAdyenFee: number;
    txnAdyenFeePercent: number;
    txnRefundAmount: number;
    txnRefundCost: number;
    status: PaymentStatus;
    currency: string;
    amount: number;
    amountInitial: number;
    amountRefund: number;
    settledAt: Date;
    cardNumber: string;
    cardMaskedPan: string;
    cardExpiryDate: string;
    comment: any;
    data: any;
    zone: Zone;
    zoneId: number;
    zoneName: string;
    outletId: number;
    outletName: string;
    adyenPayout: AdyenPayout;
    adyenPayoutId: number;
    location: Location;
    locationId: number;
    locationName: string;
    locationImageLogo: string;
    locationImageBackground: string;
    companyName: string;
    companyRegistrationNumber: string;
    companyAddressCountry: string;
    companyAddressRegion: string;
    companyAddressCity: string;
    companyAddressStreetName: string;
    companyAddressStreetNumber: string;
    companyAddressStreetPostalCode: string;
    isOrderArchived: boolean;
    eJournalCashTransaction: EJournalCashTransaction;
    eJournalCashTransactionId: string;
    terminalPayment: Terminal;
    terminal: Terminal;
    terminalId: number;
    user: User;
    userId: number;
    pointOfSale: PointOfSale;
    pointOfSaleId: string;
    settlement: Settlement;
    settlementId: number;
    balance: Balance;
    balanceId: number;
    clientInvoice: ClientInvoice;
    clientInvoiceId: number;
    paymentEvents: PaymentEvent[];
    orderProductPayments: OrderProductPayment[];
    terminalEvents: TerminalEvent[];
    paymentTransactions: PaymentTransaction[];
    paymentSplits: PaymentSplit[];
    operatorPayments: PosOperatorPayment[];
    orderProductSplits: OrderProductSplit[];
    fields: PaymentField[];
    queuedTerminals: Terminal[];
    txnAmountRefund: number;
    txnRdxFee: number;
    txnCostMerchant: number;
    txnCostRdx: number;
    providerMethod: string;
    providerPspReference: string;
    orderXFeeAmount: number;
    transactionFeeAmount: number;
    transactionFeePercent: number;
    payableAmount: number;
    txnFeePercent: number;
    txnFeeAmount: number;
    txnMerchantAmount: number;
    txnRdxAmount: number;
    paymentHistory: PaymentHistory[];
};
type PaymentFieldType = 'fee_description' | 'representation_person' | 'representation_purpose' | 'is_invoice';
type PaymentField = {
    id: number;
    payment: Payment;
    paymentId: number;
    type: PaymentFieldType;
    value: any;
};
type PaymentMeta = {
    id: number;
    createdAt: Date;
    costPercent: number;
    paymentMethodType?: string | number | 'scheme';
    paymentMethodBrand?: string | 'mc';
    cardNumber?: string;
    raw?: any[];
    value?: any;
    error?: any;
};
type PaymentMethod = {
    id: number;
    name: string;
    value: string;
    isActive: boolean;
    data?: any;
    description?: string;
    createdAt: Date;
    location: Location;
    locationId: number;
};
enum PaymentSplitType {
    MarketPlace = 'MarketPlace',
    Commission = 'Commission',
    BalanceAccount = 'BalanceAccount',
}
enum PaymentSplitAction {
    Capture = 'CAPTURE',
    Refund = 'REFUND',
}
type PaymentSplit = {
    id: number;
    payment: Payment;
    paymentId: number;
    type: string | PaymentSplitType;
    action: string | 'CAPTURE' | 'REFUND';
    amount: number;
    account: string;
    reference: string;
    createdAt: Date;
};
type PointOfSale = {
    id: string;
    description: string;
    location: Location;
    locationId: number;
    orders: Order[];
    payments: Payment[];
    createdAt: Date;
    updatedAt: Date;
};
type PosDeviceEvent = {
    id: string;
    deviceFingerprint: string;
    label: string;
    date: Date;
    ref?: string;
    data?: number;
    createdAt: Date;
    updatedAt: Date;
};
type PosOperator = {
    id: number;
    uuid: string;
    code: string;
    name?: string;
    description?: string;
    createdAt: Date;
    location: Location;
    locationId: number;
    roleGroup: PosOperatorRoleGroup;
    roleGroupId?: number;
    operatorOrders: PosOperatorOrder[];
    operatorPayments: PosOperatorPayment[];
    actions: PosOperatorAction[];
    spillageReports: SpillageReport[];
    orderProductStatusChanges: OrderProductStatusChange[];
};
enum PosOperatorActionType {
    LOGIN = 'LOGIN',
    AUTHORISE = 'AUTHORISE',
    REFUND = 'REFUND',
}
type PosOperatorAction = {
    id: number;
    operator: PosOperator;
    operatorId: number;
    type: PosOperatorActionType;
    value?: any;
    createdAt: Date;
};
type PosOperatorOrder = {
    operator: PosOperator;
    operatorId: number;
    order: Order;
    orderId: number;
    createdAt: Date;
};
type PosOperatorPayment = {
    operator: PosOperator;
    operatorId: number;
    payment: Payment;
    paymentId: number;
    createdAt: Date;
};
enum PosOperatorRoleValue {
    CANCEL_AND_REFUND = 'CANCEL_AND_REFUND',
    DISCOUNT = 'DISCOUNT',
    POS_MODULE_SHORTCUT = 'POS_MODULE_SHORTCUT',
    POS_MODULE_LINK = 'POS_MODULE_LINK',
    POS_MODULE_CONTROL_CENTER = 'POS_MODULE_CONTROL_CENTER',
    POS_MODULE_CHANGE_NAV_LINKS = 'POS_MODULE_CHANGE_NAV_LINKS',
    POS_LAYOUT = 'POS_LAYOUT',
    POS_SPILLAGE = 'POS_SPILLAGE',
    STATION_SETTINGS = 'STATION_SETTINGS',
}
type PosOperatorRole = {
    id: number;
    value: PosOperatorRoleValue;
    description?: string;
    roleGroupRoles: PosOperatorRoleGroupPosOperatorRole[];
};
type PosOperatorRoleGroup = {
    id: number;
    ref?: string;
    name: string;
    sessionLengthMinutes?: number;
    createdAt: Date;
    location: Location;
    locationId: number;
    operators: PosOperator[];
    roleGroupRoles: PosOperatorRoleGroupPosOperatorRole[];
};
type PosOperatorRoleGroupPosOperatorRole = {
    roleGroup: PosOperatorRoleGroup;
    roleGroupId: number;
    role: PosOperatorRole;
    roleId: number;
};
type ProductModifierGroup = {
    product: Product;
    productId: number;
    modifierGroup: ModifierGroup;
    modifierGroupId: number;
    position: number;
};
type ProductProductTag = {
    product: Product;
    productId: number;
    productTag: ProductTag;
    productTagId: number;
};
type ProductTagType = 'HIDE_FROM_TAKEAWAY' | 'HIDE_FROM_TAKEAWAY_APP' | 'TABLE_PROMOTED';
type ProductTag = {
    id: number;
    name: string;
    type: ProductTagType;
    location: Location;
    locationId: number;
    createdAt: Date;
    updatedAt: Date;
    productProductTags: ProductProductTag[];
};
enum ProductCategoryRoot {
    FOOD = 'FOOD',
    DRINK = 'DRINK',
    OTHER = 'OTHER',
}
enum ProductType {
    CONSUMABLE = 'CONSUMABLE',
    SERVICE = 'SERVICE',
    TIP = 'TIP',
    MODIFIER = 'MODIFIER',
    INVENTORY = 'INVENTORY',
    RECIPE = 'RECIPE',
    TICKET = 'TICKET',
    DYNAMIC_PRICE = 'DYNAMIC_PRICE',
}
enum ProductContainer {
    OTHER = 'OTHER',
    BOTTLE = 'BOTTLE',
    TANK = 'TANK',
    KEG = 'KEG',
    PIECE = 'PIECE',
}
enum ProductBaseUnit {
    OTHER = 'OTHER',
    OZ = 'OZ',
    L = 'L',
    DL = 'DL',
    CL = 'CL',
    ML = 'ML',
    /**
     * @deprecated
     */
    OUNCE = 'OUNCE',
    LITRE = 'LITRE',
    DECILITRE = 'DECILITRE',
    CENTILITRE = 'CENTILITRE',
    MILLILITRE = 'MILLILITRE',
}
enum ProductUnitAmountType {
    OZ = 'OZ',
    L = 'L',
    DL = 'DL',
    CL = 'CL',
    ML = 'ML',
}
enum ProductInventoryContainerType {
    OTHER = 'OTHER',
    BOTTLE = 'BOTTLE',
    TANK = 'TANK',
    KEG = 'KEG',
    PIECE = 'PIECE',
}
enum ProductInventoryContainerUnitType {
    OZ = 'OZ',
    L = 'L',
    DL = 'DL',
    CL = 'CL',
    ML = 'ML',
}
type Product = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    guid: string;
    externalId: string;
    name: string;
    nameInternal: string;
    description: string;
    rootCategory: ProductCategoryRoot;
    category: string;
    subCategory: string;
    price: number;
    priceTakeaway: number;
    icon: string;
    position: number;
    isOutOfStock: boolean;
    isHidden: boolean;
    isCommentAllowed: boolean;
    allergens: string[];
    type: ProductType;
    alcoholPercent: number;
    inventoryContainerType: ProductInventoryContainerType;
    inventoryContainerUnitType: ProductInventoryContainerUnitType;
    inventoryContainerUnitAmount: number;
    inventoryBaseUnitAmount: number;
    costPrice: number;
    location: Location;
    locationId: number;
    account: Account;
    accountId: number;
    purchaseAccount: Account;
    purchaseAccountId: number;
    takeawayAccount: Account;
    takeawayAccountId: number;
    variantGroup: VariantGroup;
    variantGroupId: number;
    defaultCourse: Course;
    defaultCourseId: number;
    defaultRequestStatus: OrderProductRequestStatus;
    variantGroupProducts: VariantGroupProduct[];
    inventoryProducts: InventoryProduct[];
    inventoryCountingReportProducts: InventoryCountingReportProduct[];
    recipeProducts: RecipeProduct[];
    menuProducts: MenuProduct[];
    recipes: Recipe[];
    modifierGroupItems: ModifierGroupItem[];
    tipGroups: TipGroup[];
    productModifierGroups: ProductModifierGroup[];
    discountProducts: DiscountProduct[];
    balanceProducts: BalanceProduct[];
    productProductTags: ProductProductTag[];
    productAccounts: ProductAccount[];
    productIngredients: ProductIngredient[];
    stationProducts: StationProduct[];
    container: ProductContainer;
    baseUnit: ProductBaseUnit;
    unitAmountType: ProductUnitAmountType;
    unitAmount: number;
    unitAmountBase: number;
};
type ProductAccount = {
    product: Product;
    productId: number;
    account: Account;
    accountId: number;
};
type ProductIngredient = {
    product: Product;
    productId: number;
    ingredient: Ingredient;
    ingredientId: number;
};
enum QueueItemStatus {
    ACTIVE = 'ACTIVE',
    FINISHED = 'FINISHED',
    FAILED = 'FAILED',
}
enum QueueItemType {
    VISMA_SYNC_SETTLEMENT = 'VISMA_SYNC_SETTLEMENT',
}
type QueueItem = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    status?: QueueItemStatus;
    type: string | QueueItemType;
    uniqueId: string;
    data?: any;
    executionCount: number;
    executionCountLimit: number;
    executionNext?: Date;
    requests: any;
    errors: any;
};
enum QueueTaskStatus {
    FAILED = 'FAILED',
    FINISHED = 'FINISHED',
}
type QueueTask = {
    id: number;
    path: string;
    ref?: string;
    status?: QueueTaskStatus;
    data?: any;
    executionCount: number;
    executionCountLimit: number;
    executionNext?: Date;
    results: any[];
    createdAt: Date;
    updatedAt: Date;
};
type RecipeProduct = {
    recipe: Recipe;
    recipeId: number;
    product: Product;
    productId: number;
    unitAmount: number;
    externalId: string;
};
type Recipe = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    location: Location;
    locationId: number;
    product: Product;
    productId: number;
    externalId: string;
    recipeProducts: RecipeProduct[];
};
enum ReportType {
    SETTLEMENT = 'SETTLEMENT',
}
enum ReportStatus {
    GENERATING = 'GENERATING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}
type Report = {
    id: number;
    ref: string;
    type: ReportType;
    description?: string;
    status: ReportStatus;
    data?: any;
    error?: string;
    location?: Location;
    locationId?: number;
    createdAt: Date;
};
type RequestStatus = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    position: number;
    location: Location;
    locationId: number;
    products: Product[];
    orderProducts: OrderProduct[];
};
type RuleType = 'EXCLUDE_ORDER_FROM_STATION';
type Rule = {
    id: number;
    type: RuleType;
    values: RuleValue[];
};
type RuleValue = {
    id: number;
    rule: Rule;
    ruleId: number;
    key: string;
    value: string;
};
enum SentSmsType {
    USER_GENERATE_CONFIRMATION_CODE = 'USER_GENERATE_CONFIRMATION_CODE',
    ORDER_READY = 'ORDER_READY',
    RECEIPT_FROM_TERMINAL = 'RECEIPT_FROM_TERMINAL',
}
type SentSms = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: SentSmsType;
    areaCode: string;
    phone: string;
    message: string;
    messageLength: number;
    keywords: string;
};
type Settlement = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    settledAt: Date;
    sequence: number;
    periodStart: Date;
    periodEnd: Date;
    revenueTotalIncludingVat: number;
    isSyncedToEJournal: boolean;
    hasAdyenPayments: boolean;
    s3ObjectUrl: string;
    description?: string;
    orders: Order[];
    payments: Payment[];
    eJournalEventReports: EJournalEventReport[];
    settlementSyncRequests: SettlementSettlementSyncRequest[];
    location: Location;
    locationId: number;
    user: User;
    userId: number;
    adyenPayout: AdyenPayout;
    adyenPayoutId: number;
    vismaSettlement: VismaSettlement;
    tripletexSettlement: VismaSettlement;
    zReport: ZReport;
    vismaSettlementId: number;
};
enum SettlementEventType {
    ADYEN_PAYOUT = 'ADYEN_PAYOUT',
    E_JOURNAL_SYNC = 'E_JOURNAL_SYNC',
    VISMA_SYNC = 'VISMA_SYNC',
}
enum SettlementEventStatus {
    INITIATED = 'INITIATED',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}
type SettlementEvent = {
    id: number;
    reference?: string;
    type: SettlementEventType;
    status: SettlementEventStatus;
    statusReason?: string;
    request?: any;
    response?: any;
    data?: any;
    settlement: LocationSettlement;
    settlementId: number;
    createdAt: Date;
    eventEJournalEventReports: SettlementEventEJournalEventReport[];
    eventEJournalCashTransactions: SettlementEventEJournalCashTransaction[];
};
type SettlementEventEJournalCashTransaction = {
    event: SettlementEvent;
    eventId: number;
    eJournalCashTransaction: EJournalCashTransaction;
    eJournalCashTransactionId: string;
};
type SettlementEventEJournalEventReport = {
    event: SettlementEvent;
    eventId: number;
    eJournalEventReport: EJournalEventReport;
    eJournalEventReportId: number;
};
enum SettlementPaymentCountAs {
    REVENUE = 'REVENUE',
    INVOICE = 'INVOICE',
}
type SettlementPayment = {
    id: number;
    settlement: LocationSettlement;
    settlementId: number;
    locationId: number;
    locationName: string;
    outletId: number;
    outletName: string;
    amountInitial: number;
    amount: number;
    amountRefund: number;
    merchantGross: number;
    merchantCost: number;
    merchantNet: number;
    costPercent: number;
    provider?: PaymentProvider;
    methodType: string | 'scheme' | 'vipps' | 'applepay' | 'paywithgoogle' | 'terminal';
    methodBrand: string | 'amex' | 'visa' | 'mastercard';
    countAs?: SettlementPaymentCountAs;
    createdAt: Date;
    productPayments: SettlementProductPayment[];
};
enum SettlementProductStatus {
    DELIVERED = 'DELIVERED',
    CANCELLED = 'CANCELLED',
}
enum SettlementProductSaleType {
    SALE = 'SALE',
    TIP = 'TIP',
    SERVICE_FEE = 'SERVICE_FEE',
}
enum SettlementProductCountAs {
    REVENUE = 'REVENUE',
    INVOICE = 'INVOICE',
}
type SettlementProduct = {
    id: number;
    key: string;
    settlement: LocationSettlement;
    settlementId: number;
    locationId: number;
    locationName: string;
    outletId: number;
    outletName: string;
    orderId: number;
    orderProductOrModifierId: number;
    productId?: number;
    name?: string;
    status?: SettlementProductStatus;
    saleType?: SettlementProductSaleType;
    countAs?: SettlementProductCountAs;
    amount: number;
    amountVat: number;
    amountExclVat: number;
    type: 'PRODUCT' | 'MODIFIER';
    accountId?: number;
    accountType?: string;
    accountName?: string;
    accountCode?: string;
    accountVatPercent?: number;
    placedAt: Date;
    createdAt: Date;
    productPayments: SettlementProductPayment[];
};
type SettlementProductPayment = {
    product: SettlementProduct;
    productId: number;
    payment: SettlementPayment;
    paymentId: number;
};
type SettlementSettlementSyncRequest = {
    settlement: Settlement;
    settlementId: number;
    syncRequest: SettlementSyncRequest;
    syncRequestId: number;
};
type SettlementSyncRequestProvider = 'TRIPLETEX' | 'SEVEN_OFFICE_24';
type SettlementSyncRequestStatus = 'PENDING' | 'SUCCESS' | 'ERROR' | 'MANUALLY_HANDLED';
type SettlementSyncRequest = {
    id: number;
    provider: SettlementSyncRequestProvider;
    status: SettlementSyncRequestStatus;
    requestUrl: string;
    requestData: any;
    response?: any;
    createdAt: Date;
    settlementSyncRequests: SettlementSettlementSyncRequest[];
};
type SpillageReport = {
    id: number;
    date: Date;
    reason: string;
    location: Location;
    locationId: number;
    posOperator: PosOperator;
    posOperatorId?: number;
    items: SpillageReportItem[];
    createdAt: Date;
};
type SpillageReportItem = {
    id: number;
    unitAmount: number;
    costPrice?: number;
    productId: number;
    productName: string;
    creditAccountCode?: string;
    creditAccountName?: string;
    creditAccountData?: Account;
    debitAccountCode?: string;
    debitAccountName?: string;
    debitAccountData?: Account;
    report: SpillageReport;
    reportId: number;
};
type StarPrinter = {
    id: number;
    name: string;
    topic: string;
    host: string;
    port: string;
    username: string;
    password: string;
    createdAt: Date;
    location?: Location;
    locationId?: number;
};
type Station = {
    id: number;
    name: string;
    outlet: Outlet;
    outletId: number;
    createdAt: Date;
    stationProducts: StationProduct[];
    stationIngredients: StationIngredient[];
    stationOrderProducts: StationOrderProduct[];
};
type StationIngredient = {
    station: Station;
    stationId: number;
    ingredient: Ingredient;
    ingredientId: number;
    createdAt: Date;
};
type StationOrderProduct = {
    station: Station;
    stationId: number;
    orderProduct: OrderProduct;
    orderProductId: number;
    createdAt: Date;
};
type StationProduct = {
    station: Station;
    stationId: number;
    product: Product;
    productId: number;
};
type Status = 'active' | 'inactive' | string;
type StationRequest = {
    id: number;
    status: Status;
    requestedAt: Date;
    requestedFinishAt: Date;
    orderProducts: StationRequestOrderProduct[];
    outlet: Outlet;
    outletId: number;
};
type StationRequestOrderProduct = {
    request: StationRequest;
    requestId: number;
    orderProduct: OrderProduct;
    orderProductId: number;
};
type SystemModificationStatus = 'NEW' | 'ARCHIVED';
type SystemModificationType = SystemModificationTypePaymentRefund | SystemModificationTypePaymentAmountsCorrection;
type SystemModificationTypePaymentRefund = 'PAYMENT_REFUND';
type SystemModificationTypePaymentAmountsCorrection = 'PAYMENT_AMOUNTS_CORRECTION';
type SystemModificationValue = SystemModificationValuePaymentRefund | SystemModificationValuePaymentAmountsCorrection;
type SystemModificationValuePaymentRefund = {
    type: SystemModificationTypePaymentRefund;
    paymentId: number;
    amount: number;
    orderProducts: {
        id: number;
        name: string;
        amount: number;
    }[];
    settlementId?: number;
    settlementSequence?: number;
};
type SystemModificationValuePaymentAmountsCorrection = {
    type: SystemModificationTypePaymentAmountsCorrection;
    id: number;
    settlementId?: number;
    settlementSequence?: number;
    before: Partial<Payment>;
    after: Partial<Payment>;
};
type SystemModification = {
    id: number;
    ref: string;
    reason: string;
    status: SystemModificationStatus;
    type: SystemModificationType;
    value: SystemModificationValue;
    location: Location;
    locationId: number;
    createdAt: Date;
};
enum SystemNotificationType {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
}
enum SystemNotificationEvent {
    MUNU_ORDER_SYNC_ERROR = 'MUNU_ORDER_SYNC_ERROR',
    VISMA_SETTLEMENT_SYNC_ERROR = 'VISMA_SETTLEMENT_SYNC_ERROR',
    QUEUE_DEAD_TASK = 'QUEUE_DEAD_TASK',
    SETTLEMENT_AUTO_SETTLE_FAIL = 'SETTLEMENT_AUTO_SETTLE_FAIL',
    SETTLEMENT_AUTO_PAY_OUT_FAIL = 'SETTLEMENT_AUTO_PAY_OUT_FAIL',
    ERROR = 'ERROR',
}
type SystemNotificationData =
    | SystemNotificationDataMunuOrderSyncErrorData
    | SystemNotificationDataQueueDeadTask
    | SystemNotificationDataSettlementAutoSettleFail
    | SystemNotificationDataError
    | any;
type SystemNotificationDataMunuOrderSyncErrorData = {
    locationId: number;
    orderId: number;
    munuOrderId?: number;
    request?: any;
    response?: any;
};
type SystemNotificationDataQueueDeadTask = {
    taskId: number;
    message?: string;
    payload?: any;
};
type SystemNotificationDataSettlementAutoSettleFail = {
    locationId?: number;
    openOrderCount?: number;
    openOrderIds?: number[];
};
type SystemNotificationDataError = any & {
    message: string;
};
type SystemNotification = {
    id: number;
    type: SystemNotificationType;
    event: SystemNotificationEvent;
    message: string;
    data?: SystemNotificationData;
    isHandled: boolean;
    createdAt: Date;
};
enum TagType {
    ZONE = 'ZONE',
    OUTLET = 'OUTLET',
    OUTLET_GROUP_TO_ZONE = 'OUTLET_GROUP_TO_ZONE',
    OUTLET_GROUP = 'OUTLET_GROUP',
    DISCOUNT_CLAIM = 'DISCOUNT_CLAIM',
    OUTLETS_PRODUCTS_SHOW = 'OUTLETS_PRODUCTS_SHOW',
    COVID_REGISTRATION = 'COVID_REGISTRATION',
}
type TAG_DATA_ZONE = {
    zoneId: number;
};
type TAG_DATA_OUTLET = {
    outletId: number;
};
type TAG_DATA_OUTLET_GROUP_TO_ZONE = {
    title: string;
    outletIds: number[];
    zoneNumber: number;
};
type TAG_DATA_OUTLET_GROUP = {
    title: string;
    outletIds: number[];
};
type TAG_DATA_DISCOUNT_CLAIM = {
    discountId: number;
    outletId?: number;
    zoneId?: number;
    persist?: boolean;
};
type TAG_DATA_OUTLETS_PRODUCTS_SHOW = {
    locationId: number;
    outletIds: number[];
    productIds: number[];
};
type TAG_DATA_COVID_REGISTRATION = {
    locationId: number;
    outletId?: number;
    outletIds?: number[];
    isZoneRequired?: boolean;
};
type TAG_DATA =
    | TAG_DATA_ZONE
    | TAG_DATA_OUTLET
    | TAG_DATA_OUTLET_GROUP_TO_ZONE
    | TAG_DATA_DISCOUNT_CLAIM
    | TAG_DATA_OUTLETS_PRODUCTS_SHOW
    | TAG_DATA_COVID_REGISTRATION;
type Tag = {
    id: string;
    type: TagType;
    value: string;
    data: TAG_DATA;
    name: string;
    position: number;
    description: string;
    createdAt: Date;
    updatedAt: Date;
};
enum TaskStatus {
    EXECUTING = 'EXECUTING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    DEAD = 'DEAD',
}
enum TaskType {
    ADYEN_PAY_OUT = 'ADYEN_PAY_OUT',
    ADYEN_SETTLEMENT_DETAILS_SYNC = 'ADYEN_SETTLEMENT_DETAILS_SYNC',
    MUNU_ORDER_SYNC = 'MUNU_ORDER_SYNC',
    SETTLEMENT_EVENT = 'SETTLEMENT_EVENT',
    VISMA_SETTLEMENT_SYNC = 'VISMA_SETTLEMENT_SYNC',
}
type Task = {
    id: number;
    reference: string;
    executeAt: Date;
    executedAt?: Date;
    iteration: number;
    maxIterationCount: number;
    type: string | TaskType;
    payload?: any;
    status?: TaskStatus;
    response?: any;
    deleteAt?: Date;
    createdAt: Date;
};
type Type = string | 'requested_by_waiter';
type Temp = {
    id: string;
    type: Type;
    valueN: number;
    valueS: string;
    valueD: Date;
    createdAt: Date;
};
enum TerminalEventType {
    IDLE = 'IDLE',
    PAYMENT_REQUEST = 'PAYMENT_REQUEST',
    PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
    PAYMENT_ERROR = 'PAYMENT_ERROR',
}
type TerminalEvent = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    type: TerminalEventType;
    errorCondition: string;
    timestamp: Date;
    request: any;
    response: any;
    terminal: Terminal;
    terminalId: number;
    payment: Payment;
    paymentId: number;
    lastTerminalEvent: Terminal;
};
type TerminalPresetTerminal = {
    terminalPreset: TerminalPreset;
    terminalPresetId: number;
    terminal: Terminal;
    terminalId: number;
    position: number;
};
type TerminalPreset = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    location: Location;
    locationId?: number;
    name?: string;
    isActive?: boolean;
    terminalPresetTerminals: TerminalPresetTerminal[];
    outletTerminalPresets: OutletTerminalPreset[];
};
enum TerminalLastEvent {
    BEGIN_MAINTENANCE = 'BeginMaintenance',
    END_MAINTENANCE = 'EndMaintenance',
    SHUTDOWN = 'Shutdown',
    INITIALISED = 'Initialised',
    OUT_OF_ORDER = 'OutOfOrder',
    COMPLETED = 'Completed',
    ABORT = 'Abort',
    SAKE_WAKE_UP = 'SaleWakeUp',
    SALE_ADMIN = 'SaleAdmin',
    CUSTOMER_LANGUAGE = 'CustomerLanguage',
    KEY_PRESSED = 'KeyPressed',
    SECURITY_ALARM = 'SecurityAlarm',
    STOP_ASSISTANCE = 'StopAssistance',
    CARD_INSERTED = 'CardInserted',
    CARD_REMOVED = 'CardRemoved',
    REJECT = 'Reject',
}
type Terminal = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    pOIID: string;
    name: string;
    referenceId: string;
    isActive: boolean;
    model: string;
    serialNumber: string;
    permanentTerminalId: string;
    adyenAppVersion: string;
    merchant: string;
    lastEvent: string | AdyenNotificationTerminalEventToNotify | TerminalLastEvent;
    lastEventTimestamp: string;
    pendingServiceId?: string;
    pendingServiceCreatedAt?: Date;
    company: Company;
    companyId: number;
    location: Location;
    locationId?: number;
    outlet: Outlet;
    outletId: number;
    nextTerminalService?: TerminalService;
    nextTerminalServiceId?: number;
    queuedPayment?: Payment;
    queuedPaymentId?: number;
    adyenNotificationTerminals: AdyenNotificationTerminal[];
    payments: Payment[];
    terminalPresetTerminals: TerminalPresetTerminal[];
    kioskDevices: KioskDevice[];
    lastTerminalEvent: TerminalEvent;
    lastTerminalEventId: number;
    terminalPayment: Payment;
    terminalPaymentId: number;
};
enum TerminalServiceType {
    PAYMENT = 'PAYMENT',
    PRINT = 'PRINT',
}
type TerminalServiceData = TerminalServiceDataPayment | TerminalServiceDataPrint;
type TerminalServiceDataPayment = {
    type: TerminalServiceType.PAYMENT;
    paymentId: number;
};
type TerminalServiceDataPrint = {
    type: TerminalServiceType.PRINT;
    paymentId: number;
};
type TerminalService = {
    id: number;
    data: TerminalServiceData;
    createdAt: Date;
    nextTerminalServiceTerminals: Terminal[];
};
type TipGroup = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    isActive: boolean;
    presetPercent: number[];
    location: Location;
    locationId: number;
    product: Product;
    productId: number;
};
type TripletexSettlement = {
    id: number;
    request: any;
    response?: any;
    error?: any;
    settlement: Settlement;
    settlementId: number;
    zReport: ZReport;
    zReportId: number;
    createdAt: Date;
};
type UserBalance = {
    user: User;
    userId: number;
    balance: Balance;
    balanceId: number;
};
type UserCompanyRole = {
    user: User;
    userId: number;
    company: Company;
    companyId: number;
};
enum UserLocationRoleValue {
    ADMIN = 'ADMIN',
    STAFF = 'STAFF',
}
type UserLocationRole = {
    user: User;
    userId: number;
    location: Location;
    locationId: number;
    value: UserLocationRoleValue;
};
type User = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    username: string;
    password: string;
    awsCognitoUsernameApp: string;
    awsCognitoUsernameAdmin: string;
    firstName: string;
    lastName: string;
    email: string;
    areaCode: string;
    phone: string;
    isClaimed: boolean;
    isConfirmed: boolean;
    confirmationCode: string;
    confirmationCodeSent: Date;
    stripeCustomerId: string;
    isSuperAdmin: boolean;
    authAttempts: number;
    authAttemptsTotal: number;
    lastAuthAttemptAt: Date;
    payments: Payment[];
    userCompanyRoles: UserCompanyRole[];
    userLocationRoles: UserLocationRole[];
    userBalances: UserBalance[];
    orders: Order[];
    inventoryActions: InventoryAction[];
    inventoryPurchaseOrders: InventoryPurchaseOrder[];
    inventoryCountingReports: InventoryCountingReport[];
    inventoryCountingReportSummaries: InventoryCountingReportSummary[];
    paymentHistory: PaymentHistory[];
    settlements: Settlement[];
    covidRegistrations: CovidRegistration[];
    discountUsers: DiscountUser[];
};
type ValueId =
    | `LOC_${number}_TX_PERCENT`
    | `LOC_${number}_ORDER_PRODUCT_STATUS_FOR_SMS`
    | `LOC_${number}_SETTLEMENT_SYNC_NEW`
    | `LOC_${number}_POS_COURSE_MANAGEMENT`
    | `OUTLET_${number}_POS_COURSE_MANAGEMENT`
    | 'ADYEN_LAST_SETTLEMENT_SYNC_ECOM'
    | 'ADYEN_LAST_SETTLEMENT_SYNC_POS'
    | `DEVICE_${string}_SETTLED`
    | string;
type Value = {
    id: ValueId;
    value: any;
    description: string;
    createdAt: Date;
    updatedAt: Date;
};
type VariantGroupProduct = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    variantGroup: VariantGroup;
    variantGroupId: number;
    product: Product;
    productId: number;
    price: number;
    position: number;
};
type VariantGroup = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    nameInternal: string;
    name: string;
    description: string;
    location: Location;
    locationId: number;
    products: Product[];
    variantGroupProducts: VariantGroupProduct[];
};
type VismaSettlement = {
    id: number;
    settlement: Settlement;
    settlementId: number;
    requestUrl?: string;
    requestData?: any;
    response?: any;
    createdAt: Date;
    updatedAt: Date;
};
enum ZoneOrderVisibilityType {
    PUBLIC = 'PUBLIC',
    USER_ORDERS_ONLY = 'USER_ORDERS_ONLY',
}
enum ZonePaymentType {
    UPFRONT = 'UPFRONT',
    AFTER = 'AFTER',
}
enum ZoneLayoutType {
    DEFAULT = 'DEFAULT',
    COMPACT = 'COMPACT',
    GROUPED_BY_CATEGORY = 'GROUPED_BY_CATEGORY',
}
enum ZoneOrderDeliveryType {
    DELIVERY = 'DELIVERY',
    PICKUP = 'PICKUP',
    TAKEAWAY = 'TAKEAWAY',
    SHOW_CODE = 'SHOW_CODE',
}
type Zone = {
    id: number;
    createdAt: Date;
    updatedAt: Date;
    hash: string;
    name: string;
    isClosed: boolean;
    isHidden: boolean;
    hasTakeaway: boolean;
    position: number;
    externalId: string;
    orderVisibilityType: ZoneOrderVisibilityType;
    paymentType: ZonePaymentType;
    layoutType: ZoneLayoutType;
    orderDeliveryType: ZoneOrderDeliveryType;
    isPayMode: boolean;
    outlet: Outlet;
    outletId: number;
    orders: Order[];
    payments: Payment[];
    zoneGroupZones: ZoneGroupZone[];
    values: ZoneValue[];
    kioskDevices: KioskDevice[];
};
type ZoneGroup = {
    id: number;
    outlet: Outlet;
    outletId: number;
    name: string;
    menu: Menu;
    menuId: number;
    createdAt: Date;
    updatedAt: Date;
    parents: ZoneGroupZoneGroup[];
    children: ZoneGroupZoneGroup[];
    zoneGroupZones: ZoneGroupZone[];
};
type ZoneGroupZone = {
    zoneGroup: ZoneGroup;
    zoneGroupId: number;
    zone: Zone;
    zoneId: number;
};
type ZoneGroupZoneGroup = {
    parent: ZoneGroup;
    parentId: number;
    child: ZoneGroup;
    childId: number;
};
type ZoneValueType = 'CALLING_WAITER' | 'NUM_PEOPLE' | 'SHOW_ALLERGENS';
type ZoneValue = {
    zone: Zone;
    zoneId: number;
    type: ZoneValueType;
    value?: any;
    createdAt: Date;
    updatedAt: Date;
};
type ZReportStatus = 'OPEN' | 'PENDING_CONFIRMATION' | 'CONFIRMED';
type ZReport = {
    id: number;
    ref: string;
    location: Location;
    locationId: number;
    sequence: number;
    dateTimezone: string;
    date: string | '2022-12-08';
    dateFrom: Date;
    dateTo: Date;
    dateStartHour: number;
    amountSales: number;
    amountRevenue: number;
    amountNonRevenue: number;
    status: ZReportStatus;
    items: ZReportItem[];
    payments: ZReportPayment[];
    tripletexSettlement: TripletexSettlement;
    adyenPayout: AdyenPayout;
    adyenPayoutId: number;
    settlement: Settlement;
    settlementId: number;
    createdAt: Date;
};
type ZReportItemType = 'PRODUCT' | 'MODIFIER' | 'TIP' | 'FEE';
type ZReportItem = {
    id: string;
    report: ZReport;
    reportId: number;
    order: ZReportOrder;
    orderId: number;
    groupId: string;
    type: ZReportItemType;
    name: string;
    price: number;
    priceExcludingVat: number;
    vatAmount: number;
    vatPercent: number;
    accountDisplayName?: string;
    accountName?: string;
    accountCode?: string;
    outletId?: number;
    outletName?: string;
    zoneId?: number;
    zoneName?: string;
    createdAt: Date;
    _accountId?: number;
    _orderProductId?: number;
    _orderProductModifierId?: number;
    _raw?: any;
    itemPayments: ZReportItemPayment[];
};
type ZReportItemPayment = {
    item: ZReportItem;
    itemId: string;
    payment: ZReportPayment;
    paymentId: number;
    fraction: number;
    amount: number;
    amountVat: number;
    amountExclVat: number;
};
type ZReportOrder = {
    id: number;
    report: ZReport;
    reportId: number;
    createdAt: Date;
    items: ZReportItem[];
    _raw?: any;
};
type ZReportPaymentSaleType = 'REVENUE' | 'NON_REVENUE';
type ZReportPayment = {
    id: number;
    report: ZReport;
    reportId: number;
    ref?: string;
    saleType: ZReportPaymentSaleType;
    provider: 'ADYEN' | 'BAMBORA' | 'ETC...' | string;
    method: 'TERMINAL' | 'GIFT_CARD' | 'CASH' | 'ETC...' | string;
    amount: number;
    amountRefund: number;
    txCostPercent: number;
    txCostPercentDescription: string;
    feeGross: number;
    feeCost: number;
    feeNet: number;
    merchantGross: number;
    merchantCost: number;
    merchantNet: number;
    outletId?: number;
    outletName?: string;
    zoneId?: number;
    zoneName?: string;
    createdAt: Date;
    itemPayments: ZReportItemPayment[];
    _raw?: any;
};

export namespace SharedType {
    export type Nullable<T> = { [K in keyof T]: T[K] | null };

    export type DataQueryInput<T> = T & {
        pagination: { limit: number; offset: number };
    };

    export type DataQueryOutput<T> = {
        count: number;
        items: (T & { key: string | number })[];
    };

    export type SocketEvent = SocketEventZoneOrderCreate | SocketEventZoneOrderUpdate;

    export type SocketEventZoneOrderCreate = {
        event: `zone/:zoneId/order/create`;
        data: any;
    };

    export type SocketEventZoneOrderUpdate = {
        event: `zone/:zoneId/order/update`;
        data: any;
    };

    export namespace Service {
        export namespace analytics {
            export namespace query {
                export namespace analyticsQueryPosOverview {
                    export type Input = {
                        locationId: number;
                        from: string;
                        to: string;
                        groupBy?: 'outlet';
                    };

                    export type Output = Summary & {
                        outlets: Summary[];
                    };

                    export type Summary = {
                        key: number;
                        name: string;
                        amount: number;
                        count: number;
                        avgPayment: number;
                        drinkPercentageOfTotal: number;
                        perPeriod?: {
                            label: string;
                            items: {
                                key: string;
                                label: string;
                                amount: number;
                                percent: number;
                            }[];
                        };
                        products: {
                            id: number;
                            name: string;
                            count: number;
                            amount: number;
                        }[];
                    };
                }
            }
        }
    }

    export namespace Model {
        export namespace Settlement {
            export namespace createReport {
                export type Input = {
                    locationId: number;
                    from: string;
                    to: string;
                    includeOrderType: 'SETTLEMENT' | 'PERIOD';
                    groupByPeriod?: 'DAY' | 'MONTH';
                    outletIds?: number[];
                };

                export type Output = {
                    location: { name: string };
                    isCountBalanceAsRevenue: boolean;
                    dataSettlements?: DataObject & {
                        settlements: {
                            id: number;
                            sequence: number;
                            from?: Date;
                            to: Date;
                        }[];
                    };
                    dataByDay?: (DataObject & { date: string })[];
                    dataByPeriod?: DataObject;
                };

                export type DataObject = {
                    tip: (Shared & {
                        key: string;
                        saleType: string;
                    })[];
                    vat: (Shared & {
                        key: string;
                        vatPercent: number;
                        saleType: string;
                    })[];
                    product: (Shared & {
                        id: number;
                        name: string;
                        pricePerUnit: number;
                    })[];
                    account: (Shared & {
                        id: number;
                        code: string;
                        name: string;
                        vatPercent: number;
                    })[];
                    payment: (Shared & {
                        provider: string;
                        name: string;
                        refunds: 0;
                    })[];
                    fee: (Shared & {
                        percent: number;
                    })[];
                };

                export type Shared = SaleAmount & {
                    key: string;
                    saleType: string;
                    revenueType: 'REVENUE' | 'NON_REVENUE';
                };

                export type SaleAmount = {
                    count: number;
                    net: number;
                    vat: number;
                    gross: number;
                };
            }
        }
    }
}
